module.exports = {
  messages: {
    ' COMMBOX_SCHEDULING_SUCCESSFULLY_SCHEDULED_TO':
      'Dein Beitrag wird am {date} um {time} geteilt.',
    A11Y_LOGO: 'Zur XING Startseite',
    A11Y_SETTINGS_DROPDOWN_LABEL: 'Einstellungen verwalten',
    ABOUT_ME: 'Über mich',
    ACCOUNT: 'Benutzerkonto',
    ACTION_BLOCK_USER: 'Blockieren',
    ACTION_BLOCK_USER_DIALOG_DESCRIPTION:
      'Wenn Du {displayName} blockierst, kann Dich dieses Mitglied nicht mehr auf XING kontaktieren.',
    ACTION_BLOCK_USER_DIALOG_TITLE:
      'Möchtest Du Dein Profil für dieses Mitglied blockieren?',
    ACTION_BLOCK_USER_SUCCESS: 'Mitglied blockiert',
    ACTIVE_LANGUAGE: 'Deutsch',
    ADD_ADDRESS: 'Adresse hinzufügen',
    ADD_COMPANY_SIZE: 'Firmengröße hinzufügen',
    ADD_ENTRY: 'Eintrag hinzufügen',
    ADD_IM_ID: 'Chat-Dienst hinzufügen',
    ADD_PROFILE: 'Profil hinzufügen',
    ADD_SUBJECT: 'Fachrichtung hinzufügen',
    ADD_WEBSITE: 'Webseite hinzufügen',
    ADDRESS: 'Adresse',
    AMBASSADOR_ICON_LINK:
      'http://official-events.xing.com/ambassador.php?dpt=prd&ttp=plat&plf=amb&pid=20070712&lng=de',
    ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT: 'Austausch',
    ARTICLE_KIT_RECOMMEND_STREAM_PLACEHOLDER:
      'Was möchtest Du Deinen Kontakten hierzu erzählen?',
    ASK_XING_NEW: 'Neu',
    ASK_XING_TITLE: 'Frag XING',
    AWARD: 'Auszeichnung',
    AWARDS: 'Auszeichnungen',
    AWARDS_EMPTY:
      'Gib hier Auszeichnungen an, die Du erhalten hast, z. B. "Networker des Jahres 2010".',
    BASE_PROFILE: 'Basis-Profil',
    BILLING_ADDRESS_CHANGE_HINT:
      'Die Rechnungsadresse wird nicht automatisch geändert, wenn Du diese Adresse aktualisierst. Deine Rechnungsadresse kannst Du unter "<a href="{!BILLING_ADDRESS_URL}">{\'NAVI_ACCOUNTS}</a>" bearbeiten.',
    BILLING_ADDRESS_CHANGE_HINT_TITLE:
      'Sind Deine Zahlungsinformationen noch aktuell?',
    BIRTHDATE_EMPTY: 'Du hast noch kein Geburtsdatum angegeben.',
    BIRTHDATE_PROFILES_EMPTY: 'Du hast noch keinen Geburtstag angegeben.',
    BOTTOM_BAR_FIND_JOBS_LABEL: 'Jobs finden',
    BOTTOM_BAR_INSIGHTS_LABEL: 'Insights',
    BOTTOM_BAR_NETWORK_LABEL: 'Netzwerk',
    BOTTOM_BAR_NOTIFICATIONS_LABEL: 'Mitteilungen',
    BOTTOM_BAR_YOUR_JOBS_LABEL: 'Deine Jobs',
    BREWERY_NOCOOKIES_LINK_TARGET:
      'https://faq.xing.com/de/sicherheit/was-sind-cookies-und-warum-brauche-ich-sie-beim-einloggen',
    BREWERY_NOCOOKIES_LINK_TEXT: 'Cookies aktivieren',
    BREWERY_NOCOOKIES_PARAGRAPH:
      "Denn nur mit aktivierten Cookies funktioniert das Einloggen. Hier erfährst Du, wie's geht: ",
    BREWERY_NOCOOKIES_TITLE: 'Bitte aktiviere die Cookies.',
    BREWERY_NOJAVASCRIPT_LINK_TARGET:
      'https://faq.xing.com/de/einstellungen/javascript-meinem-browser-aktivieren',
    BREWERY_NOJAVASCRIPT_LINK_TEXT: 'JavaScript aktivieren',
    BREWERY_NOJAVASCRIPT_PARAGRAPH:
      "Aktivier bitte JavaScript, denn nur so siehst Du alle unsere Inhalte. Hier erfährst Du, wie's geht:",
    BREWERY_NOJAVASCRIPT_TITLE: 'Bitte aktiviere JavaScript.',
    BUSINESS: 'Geschäftlich',
    BUSINESS_ADDRESS_STUDENT_CHANGE_HINT:
      'Lass es die Welt wissen, wenn Du Dein Studium abgeschlossen und Deinen ersten richtigen Job gefunden hast: ändere Deinen Status!',
    BUSINESS_UNIVERSITY: 'Geschäftlich / Hochschule',
    BUTTON_BACK: 'Zurück',
    BUTTON_CANCEL: 'Abbrechen',
    BUTTON_CLOSE: 'Schließen',
    BUTTON_CLOSEWINDOW: 'Fenster schließen',
    BUTTON_CONTINUE: 'OK',
    BUTTON_FORWARD: 'Weiter',
    BUTTON_PRINT_PROFILE: 'Profil ausdrucken',
    BUTTON_SAVE: 'Speichern',
    CAL_DATE_FORMAT: 'DD.MM.YYYY',
    CAL_DATE_FORMAT_HINT: 'TT.MM.JJJJ',
    CAREER_LEVEL_1: 'Student·in / Praktikant·in',
    CAREER_LEVEL_2: 'Berufseinsteiger·in',
    CAREER_LEVEL_3: 'Mit Berufserfahrung',
    CAREER_LEVEL_4: 'Manager (mit und ohne Personalverantwortung)',
    CAREER_LEVEL_5: 'Direktor·in (Bereichsleitung, VP, SVP etc.)',
    CAREER_LEVEL_6: 'Geschäftsführer·in (GF, CEO etc.)',
    CB_POSTING_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    CELLPHONE: 'Handy',
    CERTIFICATE_ERROR_DOWNLOAD_FAILED:
      'Diese Datei konnte leider nicht heruntergeladen werden. Bitte versuche es erneut.',
    CERTIFICATE_ERROR_EMPTY_FILE: 'Bitte wähle eine Datei aus.',
    CERTIFICATE_ERROR_EMPTY_TITLE: 'Bitte gib einen Titel ein.',
    CERTIFICATE_ERROR_ERROR_FILE_TOO_BIG:
      'Bitte wähle eine Datei mit einer maximalen Größe von 2MB aus.',
    CERTIFICATE_ERROR_FILE_NOT_SAVED:
      'Die Datei konnte leider nicht hochgeladen werden. Bitte versuche es erneut.',
    CERTIFICATE_ERROR_FILE_TYPE_NOT_ALLOWED:
      'Bitte wähle eine Datei im Format PDF, JPG oder PNG aus.',
    CERTIFICATE_FILE: 'Datei',
    CERTIFICATE_MIMETYPE_APPLICATION_PDF: 'pdf',
    CERTIFICATE_MIMETYPE_IMAGE_JPEG: 'jpg',
    CERTIFICATE_MIMETYPE_IMAGE_PNG: 'png',
    CERTIFICATE_OPEN_OR_SAVE: 'Öffnen oder speichern',
    CERTIFICATE_PRIVACY: 'Datei sichtbar für:',
    CERTIFICATE_PRIVACY_ALL: 'Alle XING Mitglieder',
    CERTIFICATE_PRIVACY_CONTACTS_ONLY: 'Nur meine Kontakte',
    CERTIFICATE_TITLE: 'Dateibeschreibung',
    CERTIFICATE_UPLOAD_NEW_FILE: 'Datei ändern',
    CERTIFICATE_VISIBILITY_CONTACTS_ONLY: 'Nur für Kontakte sichtbar',
    CERTIFICATES: 'Dateianhänge',
    CERTIFICATES_EDIT_INFO: 'Du kannst bis zu 3 Dateien hochladen.',
    CERTIFICATES_EDIT_INFO_2:
      '(jeweils maximal 2MB in den Formaten PDF, JPG oder PNG).',
    CERTIFICATES_EMPTY:
      'Weitere Informationen über Dich (z.B. Arbeitsproben & Zeugnisse)',
    CERTIFICATES_NEW: 'NEU',
    CHANGE_PRIMARY_JOB_EXPL:
      'Du kannst die Anzeige Deiner Tätigkeit wechseln, indem Du das Häkchen bei einem anderen Beruf  setzt.',
    CHANGE_PRIMARY_SCHOOL_EXPL:
      'Du kannst die Anzeige Deiner Hochschule wechseln, indem Du das Häkchen bei einer anderen Hochschule setzt.',
    CHANGE_UN_PW: 'Ändere die Zugangsdaten Deines XING Benutzerkontos.',
    CHOOSE_LANG:
      'Wähle aus, in welcher Sprache Du {-SITENAME} verwenden möchtest.',
    CHOOSE_NOTIFICATION_TYPES:
      'Wähle aus, welche Benachrichtigungen Du von {-SITENAME} erhalten möchtest.',
    CHOOSE_PRIVACY: 'Wähle aus, wie öffentlich oder privat Du sein möchtest.',
    CITY: 'Ort',
    COMMBOX_ACTOR_SWITCH_CANCEL: 'Absender beibehalten',
    COMMBOX_ACTOR_SWITCH_CONFIRM: 'Absender ändern',
    COMMBOX_ACTOR_SWITCH_HEADLINE:
      'Wer soll der Absender dieses Beitrags sein?',
    COMMBOX_ACTOR_SWITCH_HINT:
      'Um den Absender dieses Beitrags zu ändern, tipp einfach oben auf den Namen.',
    COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Bild geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Video geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_TYPE_PAGE: 'Eine Seite',
    COMMBOX_ACTOR_SWITCH_TYPE_USER: 'Eine Person',
    COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER:
      '1 Bild kannst Du noch hinzufügen.',
    COMMBOX_AUDIENCE_CITY_CONTACTS:
      'Nur Kontakte in meinem Arbeitsort ({totalCount})',
    COMMBOX_AUDIENCE_FOLLOWERS: 'Nur Follower',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS: 'Follower & Kontakte',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC:
      'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_FOLLOWERS_DESC: 'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_HEADLINE: 'Wer darf das sehen?',
    COMMBOX_AUDIENCE_PRIVATE: 'Privat (nur XING Kontakte)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: 'Dein Beitrag kann nicht geteilt werden.',
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Privat',
    COMMBOX_AUDIENCE_PUBLIC: 'Öffentlich',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Jeder kann Deinen Beitrag sehen und teilen.',
    COMMBOX_BUTTON_ADD_VIDEO_LABEL: 'Video hinzufügen',
    COMMBOX_BUTTON_OPEN_FILES_LABEL: 'Dokument hinzufügen',
    COMMBOX_BUTTON_OPEN_POLL_LABEL: 'Umfrage starten',
    COMMBOX_CANCEL_POSTING_BUTTON_BACK: 'Weiter bearbeiten',
    COMMBOX_CANCEL_POSTING_BUTTON_CANCEL: 'Beitrag verwerfen',
    COMMBOX_CANCEL_POSTING_HEADLINE: 'Möchtest Du den Beitrag verwerfen?',
    COMMBOX_CANCEL_POSTING_TEXT_MESSAGE: 'Deine Eingaben gehen dann verloren.',
    COMMBOX_CHARACTERS_LEFT: 'übrig',
    COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT: 'Bilder auswählen',
    COMMBOX_EMPTY_DROPZONE_TEXT:
      'JPG, BMG oder PNG (max. {max_size} MB pro Bild)',
    COMMBOX_EMPTY_DROPZONE_TITLE:
      'Du kannst bis zu {max_images} Bilder hierher ziehen oder auswählen.',
    COMMBOX_EMPTY_TEXT_FIELD: 'Teil ein Foto, einen Link oder schreib was …',
    COMMBOX_EMPTY_TEXT_FIELD_MENTIONS:
      'Teil ein Foto, einen Link oder einen Gedanken (mit "@" andere erwähnen) ...',
    COMMBOX_ENTRY_POINT_LABEL: 'Eingabefeld für Deinen Beitrag',
    COMMBOX_ENTRY_POINT_TEXT: 'Was gibt’s Neues?',
    COMMBOX_FILLED_DROPZONE_HEADER:
      '{pictures} Bilder kannst Du noch hinzufügen.',
    COMMBOX_FULL_FILLED_DROPZONE_HEADER:
      'Du hast jetzt die maximale Anzahl an Fotos hinzugefügt.',
    COMMBOX_IMAGE_BUTTON_LABEL: 'Bild hinzufügen',
    COMMBOX_IMAGE_SIZE_UPLOAD_ERROR:
      'Bitte wähle ein Bild, das max. 10 MB groß ist.',
    COMMBOX_IMAGE_TYPE_UPLOAD_ERROR:
      'Bitte wähle ein Bild im JPG- oder PNG-Format.',
    COMMBOX_POST: 'Teilen',
    COMMBOX_SCHEDULE: 'Fertig',
    COMMBOX_SCHEDULING_DATE: 'Datum',
    COMMBOX_SCHEDULING_DATE_FUTURE_ERROR: 'Bitte wähl ein zukünftiges Datum.',
    COMMBOX_SCHEDULING_DATE_VALIDITY_ERROR:
      'Bitte gib das Datum in diesem Format ein: "20.01.2021"',
    COMMBOX_SCHEDULING_FENCING_CTA_BUTTON: 'Alle Vorteile entdecken',
    COMMBOX_SCHEDULING_FENCING_HEADLINE: 'Beiträge planen',
    COMMBOX_SCHEDULING_FENCING_SUBLINE:
      'Legen Sie gezielt fest, wann Ihr Beitrag mit Ihren Followern geteilt wird. Durch die Planungsfunktion wird er dann automatisch zu dem Zeitpunkt veröffentlicht.',
    COMMBOX_SCHEDULING_HOUR_RECOS: 'Empfohlene Uhrzeiten',
    COMMBOX_SCHEDULING_IMMEDIATELY: 'Sofort',
    COMMBOX_SCHEDULING_NOW: 'Abbrechen',
    COMMBOX_SCHEDULING_SAVE: 'Speichern',
    COMMBOX_SCHEDULING_SCHEDULE: 'Fertig',
    COMMBOX_SCHEDULING_TIME: 'Uhrzeit',
    COMMBOX_SCHEDULING_TIME_FUTURE_ERROR:
      'Bitte wähl eine Uhrzeit, die noch nicht vorbei ist. ',
    COMMBOX_SCHEDULING_TITLE: 'Termin festlegen',
    COMMBOX_SUCCESS_ACTION: 'Beitrag ansehen',
    COMMBOX_SUCCESS_DESC: 'Dein Beitrag wurde auf XING geteilt.',
    COMMBOX_SUCCESS_HEADLINE: 'Und fertig!',
    COMMBOX_SUCCESS_SCHEDULED_DESC:
      'Dein Beitrag wird am {date} um {time} Uhr geteilt.',
    COMMBOX_UPDATE_BTN: 'Speichern',
    COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED:
      'Du hast schon 10 Bilder hinzugefügt – mehr geht leider nicht.',
    COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE:
      'Das Video wird gerade vorbereitet ... einen Moment Geduld bitte.',
    COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR:
      'Das hat leider nicht geklappt – einfach gleich nochmal versuchen!',
    COMMBOX_VIEW_POST_BTN: 'Beitrag ansehen',
    COMMENT_BUTTON_LABEL: 'Kommentieren',
    COMPANY: 'Unternehmen',
    COMPANY_BENEFIT_ACCESSIBILITY: 'Barrierefreiheit',
    COMPANY_BENEFIT_CANTEEN: 'Kantine',
    COMPANY_BENEFIT_CHILDCARE: 'Kinderbetreuung',
    COMPANY_BENEFIT_COMPANY_CAR: 'Firmenwagen',
    COMPANY_BENEFIT_COMPANY_DOCTOR: 'Betriebsarzt',
    COMPANY_BENEFIT_COMPANY_PENSION: 'Betriebliche Altersvorsorge',
    COMPANY_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Günstige Anbindung',
    COMPANY_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Vorteile für Mitarbeitende',
    COMPANY_BENEFIT_DOGS_WELCOME: 'Hunde willkommen',
    COMPANY_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Veranstaltungen',
    COMPANY_BENEFIT_FLEXITIME: 'Flexible Arbeitszeiten',
    COMPANY_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Gesundheitsmaßnahmen',
    COMPANY_BENEFIT_HOME_OFFICE: 'Home-Office',
    COMPANY_BENEFIT_MOBILE_DEVICE: 'Smartphone',
    COMPANY_BENEFIT_PRIVATE_INTERNET_USE: 'Privat das Internet nutzen',
    COMPANY_BENEFIT_PROFIT_SHARING: 'Gewinnbeteiligung',
    COMPANY_BENEFIT_RESTAURANT_TICKETS: 'Restaurant-Tickets',
    COMPANY_BENEFIT_TRAINING: 'Training',
    COMPANY_HP: 'Homepage des Unternehmens',
    COMPANY_SIZE: 'Unternehmensgröße',
    COMPANY_SIZE_1: 'Nur ich',
    COMPANY_SIZE_2: '1-10 Mitarbeitende',
    COMPANY_SIZE_3: '11-50 Mitarbeitende',
    COMPANY_SIZE_4: '51-200 Mitarbeitende',
    COMPANY_SIZE_5: '201-500 Mitarbeitende',
    COMPANY_SIZE_6: '501-1.000 Mitarbeitende',
    COMPANY_SIZE_7: '1.001-5.000 Mitarbeitende',
    COMPANY_SIZE_8: '5.001-10.000 Mitarbeitende',
    COMPANY_SIZE_9: '10.001 oder mehr Mitarbeitende',
    COMPLETE_BUSINESS_ADDRESS: 'Vervollständige bitte Deine Geschäftsadresse.',
    COMPLETENESS_HINT:
      'Beim Networking geht es um "finden" und "gefunden werden" – zum Beispiel für Jobs, Kollegen, Freunde und Geschäftspartner. Dein Foto und ausführliche Kontaktdaten helfen Dir dabei.',
    COMPLETION_LEVEL_WHATS_THIS: 'Was bedeutet das?',
    CONTACT_DETAILS: 'Kontaktdaten',
    CONTACTSHTML_LIST_DISABLED:
      'Dieses Mitglied hat seine Kontaktliste leider nicht zur Ansicht freigegeben.',
    CONTENT_ACTION_BLOCK_USER: 'Blockieren',
    CONTENT_ERROR_404_BUTTON: 'Zur XING Startseite',
    CONTENT_ERROR_404_HEADLINE:
      'Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.',
    CONTENT_ERROR_404_SUBLINE:
      "Aber hier gibt's garantiert etwas zu entdecken:",
    CONTENT_ERROR_503_HEADLINE:
      'Sieht so aus, als hätten wir gerade ein kleines Problem.',
    CONTENT_ERROR_503_SUBLINE:
      'Bitte hab einen Moment Geduld. Wir arbeiten daran.',
    CONTENT_ERROR_OFFLINE:
      "Bitte prüfe Deine Internet-Verbindung. Versuch's dann einfach noch einmal.",
    CONTENT_FOLLOW: 'Folgen',
    CONTENT_FOLLOW_LIGHTBOX_HEADLINE: '{title} folgen',
    CONTENT_FOLLOW_LIGHTBOX_TEXT:
      'Möchtest Du regelmäßig Artikel von {title} auf XING lesen?',
    CONTENT_FOLLOWED: 'Folgst Du',
    CONTENT_SWITCHER_MORE: 'Mehr',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG:
      '{minutesCount, plural,\n   =1 {Eben gerade}\n   other {Vor # Minuten}\n}',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT:
      '{minutesCount, plural,\n   =1 {Jetzt}\n   other {# Min.}\n}',
    CONTENT_TIMESTAMP_DAYS: 'Tage',
    CONTENT_TIMESTAMP_DAYS_AGO_LONG:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {Vor # Tagen}\n}',
    CONTENT_TIMESTAMP_DAYS_AGO_SHORT:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {# Tage}\n}',
    CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO: 'Gerade eben',
    CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT:
      '{hoursCount, plural,\n   =1 {1 Std.}\n   other {# Std.}\n}',
    CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG:
      '{hoursCount, plural,\n   =1 {Vor 1 Stunde}\n   other {Vor # Stunden}\n}',
    CONTENT_TIMESTAMP_TODAY: 'Heute',
    CONTENT_TIMESTAMP_YESTERDAY: 'Gestern',
    CONTENT_UNFOLLOW: 'Nicht mehr folgen',
    CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER:
      'Geben Sie hier den Titel Ihres Videos ein.',
    CONTENT_VIDEO_ARTICLE_VIDEO_ADDED: 'Video hinzugefügt',
    CONTENT_VIDEO_RECOS_REASON: 'Beliebte Videos auf XING',
    CONTROL_DISPLAY_NAME:
      'Hier kannst Du Deine Stammdaten ändern und Deinen akademischen Titel eintragen.',
    CONTROL_PROFILE_VISIBILITY:
      'Bestimme selbst, welche Bereiche in Deinem Profil sichtbar sind.',
    CORRECT_END_DATE: 'Bitte gib ein korrektes Enddatum an.',
    CORRECT_START_DATE: 'Bitte gib ein korrektes Einstiegsdatum an.',
    COUNTRY: 'Land',
    COUNTRY_AD: 'Andorra',
    COUNTRY_AE: 'Vereinigte Arabische Emirate',
    COUNTRY_AF: 'Afghanistan',
    COUNTRY_AG: 'Antigua und Barbuda',
    COUNTRY_AI: 'Anguilla',
    COUNTRY_AL: 'Albanien',
    COUNTRY_AM: 'Armenien',
    COUNTRY_AN: 'Niederländische Antillen',
    COUNTRY_AO: 'Angola',
    COUNTRY_AQ: 'Antarktis',
    COUNTRY_AR: 'Argentinien',
    COUNTRY_AS: 'Amerikanisch-Samoa',
    COUNTRY_AT: 'Österreich',
    COUNTRY_AU: 'Australien',
    COUNTRY_AW: 'Aruba',
    COUNTRY_AX: 'Älandinseln',
    COUNTRY_AZ: 'Aserbaidschan',
    COUNTRY_BA: 'Bosnien-Herzegowina',
    COUNTRY_BB: 'Barbados',
    COUNTRY_BD: 'Bangladesch',
    COUNTRY_BE: 'Belgien',
    COUNTRY_BF: 'Burkina Faso',
    COUNTRY_BG: 'Bulgarien',
    COUNTRY_BH: 'Bahrain',
    COUNTRY_BI: 'Burundi',
    COUNTRY_BJ: 'Benin',
    COUNTRY_BL: 'Sankt Bartholomäus',
    COUNTRY_BM: 'Bermuda',
    COUNTRY_BN: 'Brunei',
    COUNTRY_BO: 'Bolivien',
    COUNTRY_BQ: 'Bonaire, Sint Eustatius und Saba',
    COUNTRY_BR: 'Brasilien',
    COUNTRY_BS: 'Bahamas',
    COUNTRY_BT: 'Bhutan',
    COUNTRY_BV: 'Bouvetinsel',
    COUNTRY_BW: 'Botswana',
    COUNTRY_BY: 'Weißrußland',
    COUNTRY_BZ: 'Belize',
    COUNTRY_CA: 'Kanada',
    COUNTRY_CC: 'Kokosinseln',
    COUNTRY_CD: 'Die Demokratische Republik Kongo',
    COUNTRY_CF: 'Zentralafrikanische Republik',
    COUNTRY_CG: 'Kongo',
    COUNTRY_CH: 'Schweiz',
    COUNTRY_CI: "Côte d'Ivoire",
    COUNTRY_CK: 'Cook-Inseln',
    COUNTRY_CL: 'Chile',
    COUNTRY_CM: 'Kamerun',
    COUNTRY_CN: 'China',
    COUNTRY_CO: 'Kolumbien',
    COUNTRY_CR: 'Costa Rica',
    COUNTRY_CU: 'Kuba',
    COUNTRY_CV: 'Kap Verde',
    COUNTRY_CW: 'Curaçao',
    COUNTRY_CX: 'Weihnachtsinsel',
    COUNTRY_CY: 'Zypern',
    COUNTRY_CZ: 'Tschechische Republik',
    COUNTRY_DE: 'Deutschland',
    COUNTRY_DJ: 'Dschibuti',
    COUNTRY_DK: 'Dänemark',
    COUNTRY_DM: 'Dominika',
    COUNTRY_DO: 'Dominikanische Republik',
    COUNTRY_DZ: 'Algerien',
    COUNTRY_EC: 'Ecuador',
    COUNTRY_EE: 'Estland',
    COUNTRY_EG: 'Ägypten',
    COUNTRY_EH: 'Westsahara',
    COUNTRY_ER: 'Eritrea',
    COUNTRY_ES: 'Spanien',
    COUNTRY_ET: 'Äthiopien',
    COUNTRY_FI: 'Finnland',
    COUNTRY_FJ: 'Fidschi-Inseln',
    COUNTRY_FK: 'Falklandinseln (Malwinen)',
    COUNTRY_FM: 'Mikronesien',
    COUNTRY_FO: 'Faroer-Inseln',
    COUNTRY_FR: 'Frankreich',
    COUNTRY_GA: 'Gabun',
    COUNTRY_GB: 'Vereinigtes Königreich',
    COUNTRY_GD: 'Grenada',
    COUNTRY_GE: 'Georgien',
    COUNTRY_GF: 'Französisch Guyana',
    COUNTRY_GG: 'Guernsey',
    COUNTRY_GH: 'Ghana',
    COUNTRY_GI: 'Gibraltar',
    COUNTRY_GL: 'Grönland',
    COUNTRY_GM: 'Gambia',
    COUNTRY_GN: 'Guinea',
    COUNTRY_GP: 'Guadeloupe',
    COUNTRY_GQ: 'Äquatorial-Guinea',
    COUNTRY_GR: 'Griechenland',
    COUNTRY_GS: 'Südgeorgien und Südliche Sandwichinseln',
    COUNTRY_GT: 'Guatemala',
    COUNTRY_GU: 'Guam',
    COUNTRY_GW: 'Guinea-Bissau',
    COUNTRY_GY: 'Guyana',
    COUNTRY_HK: 'Hongkong',
    COUNTRY_HM: 'Heard und McDonald-Inseln',
    COUNTRY_HN: 'Honduras',
    COUNTRY_HR: 'Kroatien',
    COUNTRY_HT: 'Haiti',
    COUNTRY_HU: 'Ungarn',
    COUNTRY_ID: 'Indonesien',
    COUNTRY_IE: 'Irland',
    COUNTRY_IL: 'Israel',
    COUNTRY_IM: 'Isle of Man',
    COUNTRY_IN: 'Indien',
    COUNTRY_IO: 'Britisches Territorium im Indischen Ozean',
    COUNTRY_IQ: 'Irak',
    COUNTRY_IR: 'Iran (Islamische Republik )',
    COUNTRY_IS: 'Island',
    COUNTRY_IT: 'Italien',
    COUNTRY_JE: 'Jersey',
    COUNTRY_JM: 'Jamaika',
    COUNTRY_JO: 'Jordanien',
    COUNTRY_JP: 'Japan',
    COUNTRY_KE: 'Kenia',
    COUNTRY_KG: 'Kirgistan',
    COUNTRY_KH: 'Kambodscha',
    COUNTRY_KI: 'Kiribati',
    COUNTRY_KM: 'Komoren',
    COUNTRY_KN: 'Saint Christopher/Kitts',
    COUNTRY_KP: 'Nordkorea',
    COUNTRY_KR: 'Südkorea',
    COUNTRY_KW: 'Kuwait',
    COUNTRY_KY: 'Cayman-Inseln',
    COUNTRY_KZ: 'Kasachstan',
    COUNTRY_LA: 'Laos',
    COUNTRY_LB: 'Libanon',
    COUNTRY_LC: 'Karibische Inseln - Saint Lucia',
    COUNTRY_LI: 'Liechtenstein',
    COUNTRY_LK: 'Sri Lanka',
    COUNTRY_LR: 'Liberia',
    COUNTRY_LS: 'Lesotho',
    COUNTRY_LT: 'Litauen',
    COUNTRY_LU: 'Luxemburg',
    COUNTRY_LV: 'Lettland',
    COUNTRY_LY: 'Libyen',
    COUNTRY_MA: 'Marokko',
    COUNTRY_MC: 'Monaco',
    COUNTRY_MD: 'Moldawien',
    COUNTRY_ME: 'Montenegro',
    COUNTRY_MF: 'Saint-Martin (französischer Teil)',
    COUNTRY_MG: 'Madagaskar',
    COUNTRY_MH: 'Marschall-Inseln',
    COUNTRY_MK: 'Mazedonien',
    COUNTRY_ML: 'Mali',
    COUNTRY_MM: 'Burma',
    COUNTRY_MN: 'Mongolei',
    COUNTRY_MO: 'Macao',
    COUNTRY_MP: 'Nördliche Marianen-Inseln',
    COUNTRY_MQ: 'Martinique',
    COUNTRY_MR: 'Mauretanien',
    COUNTRY_MS: 'Montserrat',
    COUNTRY_MT: 'Malta',
    COUNTRY_MU: 'Mauritius',
    COUNTRY_MV: 'Malediven',
    COUNTRY_MW: 'Malawi',
    COUNTRY_MX: 'Mexiko',
    COUNTRY_MY: 'Malaysia',
    COUNTRY_MZ: 'Mosambik',
    COUNTRY_NA: 'Namibia',
    COUNTRY_NC: 'Neu-Kaledonien',
    COUNTRY_NE: 'Niger',
    COUNTRY_NF: 'Norfolk-Inseln',
    COUNTRY_NG: 'Nigeria',
    COUNTRY_NI: 'Nicaragua',
    COUNTRY_NL: 'Niederlande',
    COUNTRY_NO: 'Norwegen',
    COUNTRY_NP: 'Nepal',
    COUNTRY_NR: 'Nauru',
    COUNTRY_NU: 'Niue-Inseln',
    COUNTRY_NZ: 'Neuseeland',
    COUNTRY_OM: 'Oman',
    COUNTRY_PA: 'Panama',
    COUNTRY_PE: 'Peru',
    COUNTRY_PF: 'Französisch Polynesien',
    COUNTRY_PG: 'Papua-Neuguinea',
    COUNTRY_PH: 'Philippinen',
    COUNTRY_PK: 'Pakistan',
    COUNTRY_PL: 'Polen',
    COUNTRY_PM: 'Saint Pierre et Miquelon',
    COUNTRY_PN: 'Pitcairn',
    COUNTRY_PR: 'Puerto Rico',
    COUNTRY_PS: 'Palästinensisches Gebiet, Besetztes',
    COUNTRY_PT: 'Portugal',
    COUNTRY_PW: 'Palau-Inseln',
    COUNTRY_PY: 'Paraguay',
    COUNTRY_QA: 'Katar',
    COUNTRY_RE: 'Reunion',
    COUNTRY_RO: 'Rumänien',
    COUNTRY_RS: 'Serbien',
    COUNTRY_RU: 'Russische Föderation',
    COUNTRY_RW: 'Ruanda',
    COUNTRY_SA: 'Saudi-Arabien',
    COUNTRY_SB: 'Salomonen',
    COUNTRY_SC: 'Seychellen',
    COUNTRY_SD: 'Sudan',
    COUNTRY_SE: 'Schweden',
    COUNTRY_SG: 'Singapur',
    COUNTRY_SH: 'Sankt Helena',
    COUNTRY_SI: 'Slowenien',
    COUNTRY_SJ: 'Svalbard und Jan Mayen-Inseln',
    COUNTRY_SK: 'Slowakei',
    COUNTRY_SL: 'Sierra Leone',
    COUNTRY_SM: 'San Marino',
    COUNTRY_SN: 'Senegal',
    COUNTRY_SO: 'Somalia',
    COUNTRY_SR: 'Surinam',
    COUNTRY_SS: 'Südsudan',
    COUNTRY_ST: 'Sao Tome & Principe',
    COUNTRY_SV: 'El Salvador',
    COUNTRY_SX: 'Sint Maarten (niederländischer Teil)',
    COUNTRY_SY: 'Syrien',
    COUNTRY_SZ: 'Swasiland',
    COUNTRY_TC: 'Turks- und Caicos Inseln',
    COUNTRY_TD: 'Tschad',
    COUNTRY_TF: 'Französische Gebiete im südlichen Indischen Ozean',
    COUNTRY_TG: 'Togo',
    COUNTRY_TH: 'Thailand',
    COUNTRY_TJ: 'Tadschikistan',
    COUNTRY_TK: 'Tokelau',
    COUNTRY_TL: 'Ost-Timor',
    COUNTRY_TM: 'Turkmenistan',
    COUNTRY_TN: 'Tunesien',
    COUNTRY_TO: 'Tonga',
    COUNTRY_TR: 'Türkei',
    COUNTRY_TT: 'Trinidad und Tobago',
    COUNTRY_TV: 'Tuvalu',
    COUNTRY_TW: 'Taiwan',
    COUNTRY_TZ: 'Tansania',
    COUNTRY_UA: 'Ukraine',
    COUNTRY_UG: 'Uganda',
    COUNTRY_UM: 'United States Minor Outlying Islands',
    COUNTRY_US: 'Vereinigte Staaten',
    COUNTRY_UY: 'Uruguay',
    COUNTRY_UZ: 'Usbekistan',
    COUNTRY_VA: 'Vatikanstadt',
    COUNTRY_VC: 'Saint Vincent u. Grenadien',
    COUNTRY_VE: 'Venezuela',
    COUNTRY_VG: 'Jungfern-Inseln (UK)',
    COUNTRY_VI: 'Jungfern-Inseln (USA)',
    COUNTRY_VN: 'Vietnam',
    COUNTRY_VU: 'Vanuatu',
    COUNTRY_WF: 'Wallis und Futuna',
    COUNTRY_WS: 'Samoa-Inseln',
    COUNTRY_XK: 'Kosovo',
    COUNTRY_YE: 'Jemen',
    COUNTRY_YT: 'Mayotte',
    COUNTRY_ZA: 'Südafrika',
    COUNTRY_ZM: 'Zambia',
    COUNTRY_ZW: 'Zimbabwe',
    CP_KUNUNU_RATED_BY: '{kununu_ratings_num} Arbeitgeber-Bewertungen auf',
    CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US:
      'XING empfiehlt folgende Unternehmen:',
    CP_REVIEWS_BENEFITS_1: 'Flexible Arbeitszeiten',
    CP_REVIEWS_BENEFITS_10: 'Coaching',
    CP_REVIEWS_BENEFITS_11: 'Parkplatz',
    CP_REVIEWS_BENEFITS_12: 'Günstige Anbindung',
    CP_REVIEWS_BENEFITS_13: 'Spezielle Rabatte',
    CP_REVIEWS_BENEFITS_14: 'Firmenwagen',
    CP_REVIEWS_BENEFITS_15: 'Eigenes Handy',
    CP_REVIEWS_BENEFITS_16: 'Gewinnbeteiligung',
    CP_REVIEWS_BENEFITS_17: 'Interne Events',
    CP_REVIEWS_BENEFITS_18: 'Internetnutzung',
    CP_REVIEWS_BENEFITS_19: 'Hunde willkommen',
    CP_REVIEWS_BENEFITS_2: 'Home-Office',
    CP_REVIEWS_BENEFITS_3: 'Kantine',
    CP_REVIEWS_BENEFITS_4: 'Essenszulagen',
    CP_REVIEWS_BENEFITS_5: 'Kinderbetreuung',
    CP_REVIEWS_BENEFITS_6: 'Betr. Altersversorgung',
    CP_REVIEWS_BENEFITS_7: 'Barrierefreiheit',
    CP_REVIEWS_BENEFITS_8: 'Gesundheitsmaßnahmen',
    CP_REVIEWS_BENEFITS_9: 'Betriebsarzt',
    CREATE_ACCOUNT_HINT: 'Verwalte hier Dein XING Benutzerkonto.',
    CROSSPOST_SHARE_ERROR:
      'Bitte nicht übertreiben. Du hast den Beitrag schon in 3 Gruppen geteilt.',
    DATA_PROTECTION: 'Datenfreigabe bearbeiten',
    DAY_NAMES: 'Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag,Sonntag',
    DAY_NAMES_SHORT: 'Mo,Di,Mi,Do,Fr,Sa,So',
    DEGREE: 'Abschluss',
    DESC_POS: 'Beschreibe Deine Position',
    DISCIPLINE_1001: 'Analyse und Statistik',
    DISCIPLINE_1002: 'Administration, Sachbearbeitung und Verwaltung',
    DISCIPLINE_1003: 'Beratung / Consulting',
    DISCIPLINE_1004: 'Kundenbetreuung',
    DISCIPLINE_1005: 'Einkauf, Materialwirtschaft und Logistik',
    DISCIPLINE_1006: 'Finanzen, Rechnungswesen und Controlling',
    DISCIPLINE_1007: 'Forschung, Lehre und Entwicklung',
    DISCIPLINE_1008: 'Gesundheit, Medizin und Soziales',
    DISCIPLINE_1009: 'Grafik, Design und Architektur',
    DISCIPLINE_1010: 'Ingenieurwesen und technische Berufe',
    DISCIPLINE_1011: 'IT und Softwareentwicklung',
    DISCIPLINE_1012: 'Management und Unternehmensentwicklung',
    DISCIPLINE_1013: 'Marketing und Werbung',
    DISCIPLINE_1014: 'Personalwesen und HR',
    DISCIPLINE_1015: 'PR, Öffentlichkeitsarbeit und Journalismus',
    DISCIPLINE_1016: 'Produktion und Handwerk',
    DISCIPLINE_1017: 'Produktmanagement',
    DISCIPLINE_1018: 'Projektmanagement',
    DISCIPLINE_1019: 'Prozessplanung und Qualitätssicherung',
    DISCIPLINE_1020: 'Recht',
    DISCIPLINE_1021: 'Vertrieb und Handel',
    DISCIPLINE_1022: 'Sonstige Tätigkeitsfelder',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM: 'Ja, deaktivieren',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE: '@-Erwähnung deaktivieren?',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT:
      'Dein Name wird hier dann nicht mehr mit Deinem Profil verlinkt.',
    DONT_REMIND: 'Bitte nicht mehr erinnern.',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES: 'Ein Unternehmen',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS: 'Ein Event',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS: 'Eine Gruppe',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS: 'Einen Job',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS: 'Eine Person',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS: 'Einen Artikel',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS: 'Ein Thema',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS: 'Entdecke {keyword}-Jobs.',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT:
      '{keyword}-Jobs entdecken',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH: 'Suchvorschläge',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS: 'Was suchst Du?',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION: 'Suchvorschläge',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS:
      'Profile, die Du besucht hast',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES:
      'Deine letzten Job-Suchen',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION: 'Empfehlungen',
    DUPLICATE_SHARE_ERROR:
      'Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.',
    EDIT_JOB_COMPANY: 'Tätigkeit bei &quot;{-company}&quot; bearbeiten',
    EDIT_JOB_HEADER: 'Tätigkeit bei &quot;{-company}&quot; bearbeiten',
    EDIT_MOTIVATIONS: 'Gründe bearbeiten',
    EDIT_SCHOOL: 'Hochschule &quot;{-name}&quot; bearbeiten',
    EDIT_SCHOOL_HEADER: 'Hochschule "{-name}" bearbeiten',
    EDIT_WIDGET_EMAILS_LABEL_ADDITIONAL: 'Sonstige',
    EDIT_WIDGET_EMAILS_LABEL_BUSINESS: 'Geschäftlich',
    EDIT_WIDGET_EMAILS_LABEL_PRIVATE: 'Privat',
    EDIT_WIDGET_UNSAVED_CHANGES: 'ungespeicherte Änderung(en)',
    EDUCATION: 'Ausbildung',
    EMAIL_PREFS: 'E-Mail-Einstellungen',
    EMAILS_ACTIVATE: 'Für Benachrichtigungen aktivieren',
    EMAILS_ACTIVATED_BODY:
      'Die E-Mail-Adresse <strong>&quot;{-email_for_flash}&quot;</strong> wurde erfolgreich aktiviert.',
    EMAILS_ACTIVATED_HEADER: 'Aktivierung erfolgreich',
    EMAILS_ACTIVATION_EMAIL_BODY:
      'Die E-Mail-Adresse <strong>&quot;{-email_for_flash}&quot;</strong> konnte nicht als Benachrichtigungs-Adresse übernommen werden, da sie noch nicht bestätigt wurde. Wir haben jedoch eine Bestätigungs-Mail an diese Adresse gesendet. Bitte ruf die E-Mail ab und klick auf den Bestätigungs-Link. Nach erfolgreicher Bestätigung der neuen Adresse wird diese als Benachrichtigungs-Adresse aktiviert.<br/>\nDiese Maßnahme dient Deiner Sicherheit und verhindert Spam.',
    EMAILS_ACTIVATION_EMAIL_HEADER: 'Du hast Post',
    EMAILS_ACTIVE: 'aktive Benachrichtigungs-Adresse',
    EMAILS_ADDITONAL_INFO:
      '<strong>Hinweis:</strong> Deine zusätzlichen E-Mail-Adressen sind für andere XING Mitglieder nicht sichtbar. Du kannst sie jedoch als Deine Benachrichtigungs-Adresse verwenden. Deine zusätzlichen E-Mail-Adressen werden außerdem bei Adressbuch-Abgleichen berücksichtigt, d. h., Du kannst leichter auf XING gefunden werden.',
    EMAILS_CHANGE_ACTIVE_BODY:
      'Um Deine aktive Benachrichtigungs-Adresse in\n<strong>&quot;{-email_for_flash}&quot;</strong> zu ändern, haben wir Dir eine E-Mail mit einem Bestätigungs-Link geschickt. Die Änderung wird übernommen, sobald Du auf diesen Link klickst!',
    EMAILS_CONFIRM: 'Bestätigen',
    EMAILS_CONFIRMATION_EMAIL_BODY:
      'Wir haben Dir eine E-Mail an <strong>&quot;{-email_for_flash}&quot;</strong> geschickt. Bitte klick auf den Link in dieser E-Mail, um Deine neue E-Mail-Adresse zu aktivieren.',
    EMAILS_CONFIRMED: 'bestätigt',
    EMAILS_CONFIRMED_BODY:
      'Die E-Mail-Adresse <strong>&quot;{-email_for_flash}&quot;</strong> wurde bestätigt.',
    EMAILS_DELIVERY_EMAIL_INFO:
      '<strong>Hinweis</strong>: Bitte beachte, dass die Zustellung der Bestätigungs-E-Mail je nach E-Mail-Provider mehrere Minuten dauern kann. XING hat hierauf keinen Einfluss.',
    EMAILS_NOT_VISIBLE: 'nicht sichtbar für andere',
    EMAILS_UNCONFIRMED: 'nicht bestätigt',
    EMPLOYMENT_TYPE_CONTRACTOR: 'Selbstständig',
    EMPLOYMENT_TYPE_CONTRACTOR_LOCAL_SERPS: 'Freelancer',
    EMPLOYMENT_TYPE_FULL_TIME: 'Vollzeit',
    EMPLOYMENT_TYPE_INTERN: 'Studierende',
    EMPLOYMENT_TYPE_PART_TIME: 'Teilzeit',
    EMPLOYMENT_TYPE_SEASONAL: 'Saisonarbeit',
    EMPLOYMENT_TYPE_TEMPORARY: 'Aushilfe',
    EMPLOYMENT_TYPE_TEMPORARY_LOCAL_SERPS: 'Mini',
    EMPLOYMENT_TYPE_VOLUNTARY: 'Ehrenamt',
    ENTER_BIRTHDAY_HINT:
      'Gib Deinen Geburtstag an, damit Deine Kontakte Dir gratulieren können.',
    ENTER_COMPANY: 'Bitte gib den Namen der Firma an.',
    ENTER_PREV_COMPANIES_HINT:
      'Ehemalige Kollegen und Geschäftspartner finden Dich leichter, wenn Du Deine vorherigen Firmen einträgst.',
    ENTER_SCHOOL_NAME: 'Bitte gib den Namen der Hochschule an.',
    ENTER_TITLE: 'Bitte gib eine Position an.',
    ENTER_UNIVERSITY_HINT:
      'Triff alte Studienfreunde auf XING wieder und trage Deine Hochschulen ein.',
    ENTER_URL: 'Bitte gib eine gültige URL an.',
    EP_404_ERROR:
      'Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.',
    EP_404_ERROR_SUBLINE: "Aber hier gibt's garantiert was zu entdecken",
    EP_500_ERROR:
      'Hoppla! Sieht so aus, als würde unser Server gerade nicht ganz rund laufen.',
    EP_500_ERROR_SUBLINE:
      'Komm bitte in ein paar Minuten nochmal wieder. Wir arbeiten daran. ',
    EP_503_ERROR: 'Offenbar haben wir gerade ein kleines Problem.',
    EP_503_ERROR_SUBLINE:
      'Einen Moment Geduld bitte, wir arbeiten schon daran.',
    EP_ABOUT_EDIT_VIEW_COPY:
      'Verfasse hier eine kurze Selbstbeschreibung, mit der Du Dich in der Autor·innenbox vorstellst. Bis zu {maxCharacters} Zeichen kannst Du dafür verwenden.',
    EP_ABOUT_EDIT_VIEW_LABEL_INPUT_FIELD: 'Beschreibung',
    EP_ABOUT_EDIT_VIEW_TITLE: 'Deine Selbstbeschreibung',
    EP_ABOUT_US_DESCRIPTION: 'Über uns',
    EP_ABOUT_US_DISCOVER_CTA: 'Alle Infos ansehen',
    EP_ABOUT_US_HEADLINE: 'Über uns',
    EP_ABOUT_US_NAVIGATION_TITLE: 'Über',
    EP_ABOUT_US_SUBPAGE_EDIT_DESCRIPTION: 'Titel und Beschreibung bearbeiten',
    EP_ABOUT_US_SUBPAGE_LINK: 'Alle Infos über uns',
    EP_ABOUT_VISITOR_VIEW_TITLE: 'Über',
    EP_ADD_CONTACTS_SEARCH_LABEL: 'Ansprechperson hinzufügen',
    EP_ADD_CTA: 'Hinzufügen',
    EP_ADD_IMAGE: 'Bild hinzufügen',
    EP_ADD_MORE_COMPANIES: 'Verbindung hinzufügen',
    EP_ADD_VIDEO: 'Video hinzufügen',
    EP_ADMINISTRATE_PAGE: 'Seite verwalten',
    EP_AFFILIATES: 'Verbindungen zu anderen Unternehmen',
    EP_AFFILIATES_CATEGORY_ASSOCIATE: 'Schwester',
    EP_AFFILIATES_CATEGORY_CLIENT: 'Kunde',
    EP_AFFILIATES_CATEGORY_FRANCHISE: 'Franchise',
    EP_AFFILIATES_CATEGORY_JOINT_VENTURE: 'Joint Venture',
    EP_AFFILIATES_CATEGORY_PARENT: 'Mutter',
    EP_AFFILIATES_CATEGORY_PARTNER: 'Geschäftspartner',
    EP_AFFILIATES_CATEGORY_REGIONAL_BRANCH: 'Niederlassung',
    EP_AFFILIATES_CATEGORY_SERVICE_PROVIDER: 'Dienstleister',
    EP_AFFILIATES_CATEGORY_SUBSIDIARY: 'Tochter',
    EP_AFFILIATES_FEEDBACK_ERROR: 'Das hat leider nicht geklappt.',
    EP_AFFILIATES_NO_DATA_DESCRIPTION:
      'Also z. B. andere Firmen Ihrer Unternehmensgruppe, Ihre Dienstleister, Ihre Kunden usw.',
    EP_AFFILIATES_NO_DATA_HEADER:
      'Zeigen Sie hier, mit welchen Unternehmen Sie eine Verbindung haben.',
    EP_AFFILIATES_UPSELL_BODY:
      'Verlinken Sie auf Arbeitgeberprofile von Unternehmen, die mit Ihrem eigenen Unternehmen verbunden sind und stellen Sie Ihre Marke so umfassend dar.',
    EP_AFFILIATES_UPSELL_HEADLINE: 'Partnerprofile verknüpfen',
    EP_AFFILIATES_VALIDATION_NO_NAME_ERROR:
      'Hier bitte das Unternehmen eingeben',
    EP_AFFILIATION_TYPE: 'Art der Verbindung',
    EP_ALERT_DIALOG_FOLLOW_BTN_CANCEL: 'Abbrechen',
    EP_ALERT_DIALOG_FOLLOW_BTN_CONFIRM: 'Folgen',
    EP_ALERT_DIALOG_FOLLOW_BTN_OK: 'Alles klar',
    EP_ALERT_DIALOG_FOLLOW_INFORMATION_WEB:
      'Gute Nachricht: Du folgst {page} schon.',
    EP_ALERT_DIALOG_FOLLOW_QUESTION_WEB:
      'Du siehst die neuesten Beiträge von {page} dann immer automatisch unter Insights.',
    EP_ALERT_DIALOG_FOLLOW_TITLE_WEB: '{page} folgen?',
    EP_ALL_CONTACTS: 'Alle Ansprechpersonen',
    EP_AMOUNT_EMPLOYEES: 'Mitarbeitende',
    EP_AND: 'und',
    EP_ARMSTRONG_CREATE: 'Erstellen',
    EP_ARMSTRONG_CREATE_POST: 'Beitrag',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_CONFIRM_BUTTON: 'Löschen',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_DISMISS_BUTTON: 'Abbrechen',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_MESSAGE:
      'Alle Eingaben gehen dann verloren.',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_TITLE: 'Artikel löschen?',
    EP_ARTICLES_MODULE_HEADLINE: 'Neuigkeiten',
    EP_ARTICLES_MODULE_PINNED_LABEL: 'Top-Artikel',
    EP_ARTICLES_NAVIGATION_TITLE: 'Neuigkeiten',
    EP_ARTICLES_SOCIAL_COMMENTS_COUNTER_LABEL:
      '{counter, plural,\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}',
    EP_ARTICLES_SOCIAL_SHARES_COUNTER_LABEL: '{counter} Geteilt',
    EP_AWARDS_EDIT_HINT:
      'Hier werden alle Auszeichnungen gelistet, die in Ihrem kununu-Profil hinterlegt sind.',
    EP_AWARDS_HEADLINE: 'Auszeichnungen',
    EP_BACK_TO_OVERVIEW: 'Zurück zur Übersicht',
    EP_BANNER_ROLLOUT_AUTOMATIC_ROLLOUT:
      'Am 30. Nov. 2020 werden wir alle Arbeitgeberprofile ins neue Design konvertieren und alle bisherigen Daten für Sie übernehmen. Schließen Sie die Migration bereits jetzt selbst ab, um sicherzustellen, dass sich Ihre Arbeitgebermarke optimal präsentiert. Bitte beachten Sie, dass Sie nicht auf das alte Design zurück wechseln können.',
    EP_BENEFIT_ACCESSIBILITY: 'Barrierefreiheit',
    EP_BENEFIT_CANTEEN: 'Kantine',
    EP_BENEFIT_CAR_PARK: 'Parkplatz',
    EP_BENEFIT_CHILDCARE: 'Kinderbetreuung',
    EP_BENEFIT_COMPANY_CAR: 'Firmenwagen',
    EP_BENEFIT_COMPANY_DOCTOR: 'Betriebsarzt',
    EP_BENEFIT_COMPANY_PENSION: 'Betriebliche Altersvorsorge',
    EP_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Günstige Anbindung',
    EP_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Rabatte',
    EP_BENEFIT_DOGS_WELCOME: 'Hunde willkommen',
    EP_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Veranstaltungen',
    EP_BENEFIT_FLEXITIME: 'Flexible Arbeitszeiten',
    EP_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Gesundheitsmaßnahmen',
    EP_BENEFIT_HOME_OFFICE: 'Home-Office',
    EP_BENEFIT_MOBILE_DEVICE: 'Smartphone',
    EP_BENEFIT_PRIVATE_INTERNET_USE: 'Privat das Internet nutzen',
    EP_BENEFIT_PROFIT_SHARING: 'Gewinnbeteiligung',
    EP_BENEFIT_RESTAURANT_TICKETS: 'Restaurant-Tickets',
    EP_BENEFIT_TRAINING: 'Training',
    EP_CANCEL: 'Abbrechen',
    EP_CHANGE_IMAGE_CTA: 'Bild ändern',
    EP_CHANGE_TITLE_INFO:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>',
    EP_CHANGE_TITLE_INFO_FREE:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a href="mailto:arbeitgeberprofil@xing.com">arbeitgeberprofil@xing.com</a>',
    EP_CHANGE_TITLE_INFO_FREE_V2:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a>arbeitgeberprofil@xing.com</a>',
    EP_CHANGE_TITLE_INFO_V2:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a>customer.support@xing.com</a>',
    EP_CHOOSE_ACTION: 'Was möchtest Du tun?',
    EP_CHOOSE_COVER: 'Titelbild auswählen',
    EP_CHOOSE_COVER_INFO_BANNER: 'Tipps für ein gelungenes Titelbild',
    EP_CHOOSE_COVER_INFO_BANNER_CTA: 'Tipps lesen',
    EP_CHOOSE_LOGO:
      'Fügen Sie hier Ihr Unternehmenslogo hinzu: Damit erkennt man Ihr Unternehmen auch visuell auf einen Blick.',
    EP_CHOOSE_SECTION: 'Ändern Sie hier den Ausschnitt:',
    EP_CLEAR_ALL: 'Filter entfernen',
    EP_COMMBOX_ERROR:
      "Das hat leider nicht geklappt – versuch's bitte nochmal.",
    EP_COMMBOX_PLACEHOLDER: "Gibt's was, das Du mit anderen teilen möchtest?",
    EP_COMMBOX_POST: 'Teilen',
    EP_COMMBOX_POSTING_SUCCESSFUL_MESSAGE: 'Beitrag geteilt',
    EP_COMPANIES_AUTOMIGRATION_BANNER_CONTACT_SUPPORT:
      'Haben Sie Fragen dazu? Wir helfen Ihnen gern:\n<br/>\nE-Mail: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>\n<br/>\nTelefon: +49 40 419 131-778\n',
    EP_COMPANIES_AUTOMIGRATION_BANNER_REDIRECT_ADVISE:
      'Wenn der Link zu Ihrem alten Arbeitgeberprofil aufgerufen wird, leiten wir automatisch zur neuen XING Seite weiter.',
    EP_COMPANIES_AUTOMIGRATION_BANNER_TITLE:
      'Frischer Wind für Ihr Arbeitgeberprofil',
    EP_COMPANIES_AUTOMIGRATION_BANNER_UPDATED_URL:
      'Der Link Ihres Arbeitgeberprofil ist jetzt <strong>www.xing.com/pages/{slug}</strong>.',
    EP_COMPANIES_FEEDBACK_BANNER:
      'Dein Feedback hilft uns, das XING Employer Branding Profil für Dich zu optimieren! ',
    EP_COMPANIES_FEEDBACK_BANNER_BUTTON: 'Zur Umfrage',
    EP_COMPANY_ABOUT_US_FACTS: 'Steckbrief',
    EP_COMPANY_ABOUT_US_INDUSTRY: 'Branche',
    EP_COMPANY_INDUSTRY: 'Branche',
    EP_COMPANY_NAME: 'Unternehmensname',
    EP_COMPANY_NAME_VALIDATION_ERROR: '2-64 Zeichen kann man hier eingeben.',
    EP_COMPANY_NOT_FOUND: 'Unternehmen nicht gefunden',
    EP_COMPANY_PAGE_CREATION_ERROR:
      "Das hat leider nicht geklappt – versuchen Sie's bitte nochmal.",
    EP_COMPANY_PAGE_CREATION_INVALID_CHARACTERS_ERROR:
      'Bitte geben Sie hier nur Buchstaben und Ziffern ein, keine Sonderzeichen.',
    EP_COMPANY_PAGE_CREATION_NAME_ALREADY_USED_ERROR:
      "Für diesen Namen gibt's schon eine XING Seite. Hat sie vielleicht jemand anders aus Ihrem Unternehmen bereits erstellt? Kontaktieren Sie uns gern, wenn Sie dazu noch Fragen haben.",
    EP_COMPANY_PAGE_CREATION_NAME_HAS_ONLY_NUMBERS_ERROR:
      'Dieser Name enthält leider nur Zahlen. Bitte verwenden Sie auch Buchstaben.',
    EP_COMPANY_PAGE_CREATION_NAME_TOO_LONG_ERROR:
      'Dieser Name ist leider zu lang: Bis zu 80 Zeichen sind möglich.',
    EP_COMPANY_PAGE_CREATION_NAME_TOO_SHORT_ERROR:
      'Dieser Name ist leider zu kurz: Mindestens zwei Zeichen sind notwendig.',
    EP_COMPANY_PAGE_CREATION_STEP_1: 'Basis-Infos',
    EP_COMPANY_PAGE_CREATION_STEP_2: 'Kontaktdaten',
    EP_COMPANY_PAGE_CREATION_STEP_3: 'Unternehmenslogo',
    EP_COMPANY_PAGE_CREATION_STEP_4: 'Kurzbeschreibung',
    EP_COMPANY_RECOMMENDATIONS_HEADLINE: 'Empfehlenswerte Unternehmen',
    EP_COMPANY_RECOMMENDATIONS_NAVIGATION_TITLE: 'Ähnliche Unternehmen',
    'EP_COMPANY_SOCIAL_PROOF.one': '{username} arbeitet hier.',
    'EP_COMPANY_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte arbeiten hier.',
    EP_COMPANY_SUMMARY: 'Steckbrief',
    EP_CONFIRMATION_LAST_STEP_CREATE_PAGE:
      '– Sobald Ihre Seite freigeschaltet ist, sagen wir Ihnen per E-Mail Bescheid (innerhalb von 72 Stunden).',
    EP_CONTACT_EDIT_LABEL: 'Beschreibung der Ansprechperson',
    EP_CONTACT_FOLLOWING: 'folgt dieser Seite.',
    EP_CONTACT_WORK: 'arbeitet hier.',
    EP_CONTACTS_CHANGE_OWNER_INFO:
      'Wenn Sie den Eigentümer dieser Seite ändern möchten, schreiben Sie uns bitte: <a href="mailto:{cs_email}">{cs_email}</a>',
    EP_CONTACTS_CHANGE_OWNER_INFO_V2:
      'Wenn Sie den Eigentümer dieser Seite ändern möchten, schreiben Sie uns bitte: <a>{cs_email}</a>',
    EP_CONTACTS_DESCRIPTION: 'Ansprechpersonen bei',
    EP_CONTACTS_EDIT_CTA: 'Ansprechpersonen bearbeiten',
    EP_CONTACTS_EDIT_TITLE: 'Ansprechpersonen bearbeiten',
    EP_CONTACTS_EMPTY_LIST:
      'Wer steht Besuchern Ihrer XING Seite für Fragen, Anregungen und Anliegen zur Verfügung? Tragen Sie diese Personen hier ein.',
    EP_CONTACTS_FOLLOWING: 'folgen dieser Seite.',
    EP_CONTACTS_HEADLINE: 'Ansprechpersonen',
    EP_CONTACTS_HIGHLIGHT_INFO:
      'Die ersten zwei Ansprechpersonen erscheinen auf der Startseite. Alle Ansprechpersonen im Überblick sind in der Rubrik "Kontakt" aufgelistet.',
    EP_CONTACTS_MESSENGER_INFO:
      'Bevor Sie jemanden als Ansprechperson hinzufügen: Stellen Sie bitte sicher, dass diese Person damit einverstanden ist. Wenn die Seite veröffentlicht wird, werden alle Ansprechpersonen darüber benachrichtigt.',
    EP_CONTACTS_MODULE_TITLE: 'Ansprechpersonen',
    EP_CONTACTS_NAVIGATION_TITLE: 'Kontakt',
    EP_CONTACTS_SEARCH_INPUT_ERROR:
      "Das hat leider nicht geklappt – versuchen Sie's einfach nochmal.",
    EP_CONTACTS_SEARCH_NO_RESULTS:
      'Diesen Namen haben wir leider nicht gefunden.',
    EP_CONTACTS_SEARCH_PLACEHOLDER: 'Namen eingeben',
    EP_CONTACTS_SUBPAGE_DESCRIPTION:
      'Alle Ansprechpersonen von {pageTitle} auf einen Blick',
    EP_CONTACTS_WORK: 'arbeiten hier.',
    EP_COVER_CROP_DESCRIPTION:
      '<b>Wichtig:</b> Bei einigen Bildschirmgrößen (z. B. auf Smartphones) ist nur die Mitte des Hintergrundbildes sichtbar. Wählen Sie deshalb ein Bild, bei dem sich die wichtigsten Elemente innerhalb der gestrichelten Linien befinden: Dieser Bereich ist nämlich immer zu sehen.',
    EP_CREATE_COMPANY_PAGE_MOBILE_INFO:
      'Bitte nutzen Sie zur Erstellung Ihrer XING Seite einen <span>großen Bildschirm</span>.',
    EP_DELETE_COVER: 'Titelbild löschen',
    EP_DELETE_COVER_DIALOG: 'Möchten Sie das Hintergrundbild wirklich löschen?',
    EP_DELETE_COVER_DIALOG_CONFIRM: 'Löschen',
    EP_DELETE_COVER_DIALOG_HEADLINE: 'Titelbild löschen?',
    EP_DELETE_COVER_DIALOG_KEEP: 'Behalten',
    EP_DELETE_DOCUMENT_DIALOG: 'Möchten Sie dieses Dokument wirklich löschen?',
    EP_DELETE_DOCUMENT_DIALOG_CANCEL: 'Abbrechen',
    EP_DELETE_DOCUMENT_DIALOG_CONFIRM: 'Ja, löschen',
    EP_DELETE_DOCUMENT_DIALOG_HEADLINE: 'Dokument löschen?',
    EP_DELETE_IMAGE_GM_DIALOG:
      'Das Bild und Ihre Eingaben dazu werden dann gelöscht.',
    EP_DELETE_IMAGE_GM_DIALOG_CANCEL: 'Abbrechen',
    EP_DELETE_IMAGE_GM_DIALOG_CONFIRM: 'Ja, löschen',
    EP_DELETE_IMAGE_GM_DIALOG_HEADLINE: 'Alles löschen?',
    EP_DELETE_VIDEO_DIALOG_CANCEL: 'Nicht löschen',
    EP_DELETE_VIDEO_DIALOG_CONFIRM: 'Ja, löschen',
    EP_DELETE_VIDEO_DIALOG_HEADLINE: 'Video löschen?',
    'EP_DELETE_VIDEO_DIALOG_HEADLINE (Copy)': 'Video löschen?',
    EP_DELETE_VIDEO_DIALOG_TEXT:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    EP_DIALOG_PAGE_CREATION_CLOSE: 'Nicht beenden',
    EP_DIALOG_PAGE_CREATION_CONFIRM: 'Prozess beenden',
    EP_DISCARD_CTA: 'Verwerfen',
    EP_DISCARD_DIALOG_CANCEL: 'Abbrechen',
    EP_DISCARD_DIALOG_CONFIRM: 'Verwerfen',
    EP_DISCARD_DIALOG_HEADLINE: 'Änderungen verwerfen?',
    EP_DISCARD_DIALOG_TEXT: 'Ihre Änderungen gehen dadurch verloren.',
    EP_DISCOVER_ABOUT_US: 'Alle Infos über uns',
    EP_DISCUSSION_COMMBOX_BLOCKED_BANNER:
      'Du wurdest blockiert und kannst zur Zeit nicht an der Gruppen-Diskussion teilnehmen. Wende Dich bitte an das Moderations-Team.',
    EP_DISCUSSION_EMPTY_STATE_BODY:
      "Sobald jemand etwas veröffentlicht, siehst Du's hier.",
    EP_DISCUSSION_EMPTY_STATE_BODY_LO:
      "Sobald jemand etwas veröffentlicht, siehst Du's hier.",
    EP_DISCUSSION_EMPTY_STATE_HEADLINE: "Hier gibt's noch keine Beiträge.",
    EP_DISCUSSION_EMPTY_STATE_HEADLINE_LO: "Hier gibt's noch keine Beiträge.",
    EP_DISCUSSION_EMPTY_STATE_MODERATOR_BODY:
      'Wenn Du Deinen ersten Gruppen-Beitrag veröffentlichst, sehen Gruppen-Mitglieder, dass die Gruppe aktiv ist.',
    EP_DISCUSSION_EMPTY_STATE_MODERATOR_HEADLINE:
      'Schreib Deinen ersten Gruppen-Beitrag.',
    EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_BODY:
      'Ausgeblendete Beiträge sind nur für das Moderations-Team sichtbar, erscheinen aber nicht in der Gruppe. Klick auf das kleine Auge neben einem Beitrag, um ihn auszublenden. ',
    EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_HEADLINE:
      'Es gibt momentan keine ausgeblendeten Beiträge.',
    EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_BODY:
      'Wenn Du Deinen ersten Gruppen-Beitrag veröffentlichst, sehen Gruppen-Mitglieder, dass die Gruppe aktiv ist.',
    EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_HEADLINE:
      'Veröffentliche Deinen ersten Gruppen-Beitrag.',
    EP_DISCUSSIONS_DELETE_POST: 'Diesen Beitrag löschen?',
    EP_DISCUSSIONS_DELETE_POST_POPUP_BODY:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_CANCEL: 'Abbrechen',
    EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_DELETE: 'Löschen',
    EP_DISCUSSIONS_DESCRIPTION: 'Diskussionen',
    EP_DISCUSSIONS_EDIT_ALL: 'Alle Beiträge',
    'EP_DISCUSSIONS_EDIT_ALL (Copy)': 'Alle Beiträge',
    EP_DISCUSSIONS_HEADLINE: 'Diskussionen',
    EP_DISCUSSIONS_HIDE_POST: 'Beitrag ausblenden',
    EP_DISCUSSIONS_HIDE_POST_ERROR:
      'Das hat leider gerade nicht geklappt. Versuch es bitte noch einmal.',
    EP_DISCUSSIONS_HIDE_POST_POPUP_BODY:
      'Dann ist er für die Gruppe nicht mehr sichtbar.',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_CANCEL: 'Abbrechen',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_HIDE: 'Ausblenden',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_UNHIDE: 'Wieder einblenden',
    EP_DISCUSSIONS_HIDE_POST_POPUP_HEADLINE: 'Beitrag ausblenden?',
    EP_DISCUSSIONS_MARK_POST: 'Beitrag oben anpinnen',
    EP_DISCUSSIONS_NAVIGATION_TITLE: 'Diskussionen',
    EP_DISCUSSIONS_REPORT_POST: 'Beitrag melden',
    EP_DISCUSSIONS_UNHIDE_POST: 'Wieder einblenden',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_BODY:
      'Der Beitrag ist dann wieder unter "Diskussionen" in Deiner Gruppe sichtbar.',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_CANCEL: 'Abbrechen',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_HIDE: 'Wieder einblenden',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_HEADLINE:
      'Diesen Beitrag wieder einblenden?',
    EP_DOCUMENT_TITLE_EDIT_ERROR:
      'Bitte hier den Titel des Dokumentes eingeben',
    EP_DOCUMENT_TITLE_EDIT_HINT:
      'Fügen Sie hier den Titel Ihres Dokuments hinzu.',
    EP_DOCUMENT_TITLE_EDIT_LABEL: 'Titel des Dokuments',
    EP_DOCUMENTS_HEADLINE: 'Dokumente',
    EP_DONE_CTA: 'Fertig',
    EP_DRAFT_LAST_STEP_CREATE_PAGE:
      '– Bitte beachten Sie, dass sich Ihr Arbeitgeberprofil bis zur Genehmigung im Entwurfsmodus befindet und bis dahin noch nicht veröffentlicht ist.',
    EP_DRAFT_REPUBLISH_CTA: 'Veröffentlichen',
    EP_DRAFT_REPUBLISH_DESCRIPTION:
      'Die Beschwerde über diese Seite wurde zurückgewiesen – sie kann also wieder veröffentlicht werden.',
    EP_DUMMY_COMMBOX_PLACEHOLDER: 'Etwas mit anderen teilen…',
    EP_EDIT_ABOUT_DATA_TITLE: 'Eingaben bearbeiten',
    EP_EDIT_ABOUTMETA_CTA: 'Infos bearbeiten',
    EP_EDIT_ABOUTUS_COPY_TO_INTRO:
      'Als Kurzbeschreibung die ersten Zeilen der ausführlichen Beschreibung anzeigen',
    EP_EDIT_ABOUTUS_DESCRIPTION: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_DESCRIPTION_DISCARD: 'Abbrechen',
    EP_EDIT_ABOUTUS_DESCRIPTION_PUBLISH: 'Speichern',
    EP_EDIT_ABOUTUS_DETAILED_REQUIRED:
      'Bitte fügen Sie jetzt noch den Text Ihrer "Über uns"-Rubrik hinzu.',
    EP_EDIT_ABOUTUS_EXTERNALVIDEO_INFO:
      'Videos, die Sie per Link eingebunden haben, können bald nicht mehr angezeigt werden. Laden Sie deshalb jetzt Ihre Videos direkt auf XING hoch – und fügen Sie auf Wunsch auch Untertitel und Vorschaubilder hinzu.',
    EP_EDIT_ABOUTUS_HINT:
      '<b>Tipp:</b> Nenne hier Eure wichtigsten Produkte bzw. Dienstleistungen. Benutze dabei Begriffe, die Eure Zielgruppe auch benutzt – so ist die Seite bei Google & Co. besser auffindbar.\nDu kannst hier eine Detailbeschreibung und optional eine Kurzbeschreibung eingeben. Verzichtest Du auf die Kurzbeschreibung, werden automatisch die erste Sätze der Detailbeschreibung angezeigt.',
    EP_EDIT_ABOUTUS_INDUSTRIES_INTRO:
      'Zu welcher Branche gehört Ihr Unternehmen? Geben Sie hier bis zu 5 passende Branchen ein, damit Ihre Seite besser gefunden wird und wir sie den richtigen Mitgliedern vorschlagen können.',
    EP_EDIT_ABOUTUS_INTRO_DESCRIPTION: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_INTRO_DESCRIPTION_LABEL: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_INTRO_INFO_TEXT:
      'Diese Kurzbeschreibung erscheint in der Übersicht unter "Über uns" – und auch bei Google & Co. in den Suchergebnissen.',
    EP_EDIT_ABOUTUS_INTRO_TITLE: 'Überschrift',
    EP_EDIT_ABOUTUS_INTRO_TITLE_LABEL: 'Überschrift',
    EP_EDIT_ABOUTUS_NAV_DESCRIPTION: 'Ausführliche Beschreibung',
    EP_EDIT_ABOUTUS_NAV_FACTS: 'Steckbrief',
    EP_EDIT_ABOUTUS_NAV_INDUSTRIES: 'Branchen',
    EP_EDIT_ABOUTUS_NAV_INTRO: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_SUMMARY: 'Über uns: Eckdaten',
    EP_EDIT_ACTION_DISCARD: 'Abbrechen',
    EP_EDIT_ACTION_POST: 'Beitrag schreiben',
    EP_EDIT_ACTION_PROMOTE: 'Seite bewerben',
    EP_EDIT_ACTION_PUBLISH: 'Fertig',
    EP_EDIT_ACTION_SET_EDIT_MODE_OFF: 'Zur Besucheransicht',
    EP_EDIT_ACTION_SET_EDIT_MODE_ON: 'Seite bearbeiten',
    EP_EDIT_ACTION_WRITE_ARTICLE: 'Artikel schreiben',
    EP_EDIT_AFFILIATES: 'Verbindungen bearbeiten',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY:
      'Möchten Sie "{companyName}" als verbundenes Unternehmen entfernen?',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY_MARKUP:
      'Möchten Sie <strong>"{companyName}"</strong> als verbundenes Unternehmen entfernen?',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CANCEL: 'Abbrechen',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CONFIRM: 'Ja, entfernen',
    EP_EDIT_AFFILIATES_DESCRIPTION:
      'Fügen Sie hier verwandte Unternehmen sowie Kunden, Dienstleister usw. hinzu. Voraussetzung ist, dass diese Unternehmen ebenfalls eine XING Seite haben. Wir empfehlen Ihnen zudem, sich ihrer Zustimmung zu versichern, auf Ihrer Seite als "verbundenes Unternehmen" zu erscheinen.',
    EP_EDIT_AFFILIATES_INFO:
      'Fügen Sie hier z. B. Tochter- oder Schwesterunternehmen hinzu – aber auch Kunden, Dienstleister usw. Wichtig: Diese Unternehmen müssen ebenfalls eine XING Seite haben und sollten der Verknüpfung vorher zugestimmt haben.',
    EP_EDIT_BACK_GALLERY: 'Zur Galerie',
    EP_EDIT_COMPANY_FACTS_TITLE: 'Steckbrief',
    EP_EDIT_COMPANYSIZEID: 'Mitarbeitende',
    EP_EDIT_COMPANYSIZEID_FIELD_LABEL: 'Mitarbeitende',
    EP_EDIT_CONTACTS: 'Kontakt bearbeiten',
    EP_EDIT_CONTACTS_DELETE:
      'Möchten Sie diese Ansprechperson wirklich entfernen?',
    EP_EDIT_CONTACTS_DELETE_CANCEL_CONFIRM: 'Entfernen',
    EP_EDIT_CONTACTS_DELETE_CANCEL_CTA: 'Abbrechen',
    EP_EDIT_CONTACTS_DELETED: 'Ansprechperson entfernt',
    EP_EDIT_CONTACTS_DESCRIPTION_INPUT_FIELD:
      'Tipp: Gib hier an, für welche Themen diese Ansprechperson zuständig ist.',
    EP_EDIT_CONTACTS_FREE_INFO:
      'Hier tragen Sie ein, an wen sich Besucher Ihrer XING Seite bei Fragen oder Anliegen wenden können. Wenn Sie diese Ansprechperson ändern wollen, fügen Sie einfach eine neue Person hinzu: Die bisherige wird dann automatisch entfernt. (Bei einer kostenlosen XING Seite kann man leider nur eine Ansprechperson eintragen.)',
    EP_EDIT_CONTACTS_NAV_CONTACTS: 'Kontakt',
    EP_EDIT_CONTACTS_NAV_LOCATION: 'Standort',
    EP_EDIT_CONTACTS_PAID_INFO:
      'Hier tragen Sie ein, an wen sich Besucher·innen Ihrer XING Seite bei Fragen oder Anliegen wenden können. Die ersten beiden Ansprechpersonen in dieser Liste erscheinen nicht nur auf der Detailseite "Ansprechpersonen", sondern auch auf der Übersicht Ihrer XING Seite.',
    EP_EDIT_DOCUMENTS: 'Dokumente bearbeiten',
    EP_EDIT_EVENT_ALL_LINK: 'Alle Events',
    EP_EDIT_EVENT_COPY_EVENT: 'Event kopieren',
    EP_EDIT_EVENT_DRAFT_MESSAGE_BODY:
      "Sobald Du bereit bist, kannst Du's veröffentlichen und die ersten Gäste dazu einladen. Dadurch finden auch neue Leute in Deine Gruppe.",
    EP_EDIT_EVENT_DRAFT_MESSAGE_CTA: 'Zum Event-Entwurf',
    EP_EDIT_EVENT_DRAFT_MESSAGE_HEADLINE:
      'Zeit, Deiner Gruppe vom nächsten Event zu erzählen! ',
    EP_EDIT_EVENT_EDIT_EVENTS: 'Events verwalten',
    EP_EDIT_EVENT_EMPTY_STATE_BODY:
      'Events zum Kennenlernen und Austauschen helfen Dir beim Aufbau Deiner Gruppe und Deinen Mitgliedern dabei, sich zu vernetzen und wirklich etwas für sich mitzunehmen.',
    EP_EDIT_EVENT_EMPTY_STATE_CTA: 'Gruppen-Event organisieren',
    EP_EDIT_EVENT_EMPTY_STATE_FAQ_LINK:
      'Hier findest Du Tipps für Dein Gruppen-Event.',
    EP_EDIT_EVENT_EMPTY_STATE_HEADLINE:
      'Versammle Deine Gruppe und finde neue Mitglieder – online und vor Ort.',
    EP_EDIT_EVENT_ORGANISE_CTA: 'Event organisieren',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_BODY:
      'Regelmäßige Treffen fördern den Austausch untereinander und locken auch immer wieder neue Leute in Deine Gruppe.',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_CTA: 'Event kopieren',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_HEADLINE: 'Zeit fürs nächste Gruppen-Event?',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_TIP:
      'Tipp: Spar Zeit, indem Du Dein letztes Event kopierst.',
    'EP_EDIT_EVENT_PAST_TITLE.one': 'Vergangene Events',
    'EP_EDIT_EVENT_PAST_TITLE.other': 'Vergangene Events',
    'EP_EDIT_EVENT_PAST_TITLE.zero': 'Vergangene Events',
    EP_EDIT_EVENT_SUBPAGE_BACK_LINK: 'Zurück zur Übersicht',
    EP_EDIT_EVENT_SUBPAGE_COPY_EVENT_BUTTON: 'Event kopieren',
    EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_BODY:
      'Bei Events gilt: Je eher Du sie veröffentlichst, desto mehr Leute werden darauf aufmerksam und können sich den Termin freihalten.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.one':
      'Erinnerung: Du hast einen unveröffentlichten Event-Entwurf.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.other':
      'Erinnerung: Du hast unveröffentlichte Event-Entwürfe.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.zero':
      'Zeit, Deiner Gruppe vom nächsten Event zu erzählen! ',
    EP_EDIT_EVENT_SUBPAGE_DRAFT_TAB: 'Entwürfe',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_HELP_BODY:
      'Hier findest Du <a>Tipps für Dein Gruppen-Event</a>.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_TITLE_HELP: 'Noch Fragen?',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BODY:
      'Bei einem Event kommt Deine Gruppe zusammen, die Mitglieder lernen sich kennen und tauschen sich aus. Dadurch entsteht erst ein Gemeinschaftsgefühl und Du erweckst die Gruppe zum Leben. ',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_BODY:
      'Zuallererst solltest Du festlegen: Wann findet das Event statt? Trefft Ihr Euch online oder vor Ort? Und worum soll es gehen? Mit diesen Infos kannst Du Dein Event erstellen.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_TITLE: '1. Die Eckdaten',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_BODY:
      'Kümmer Dich als nächstes um die Details: Wie ist der Ablauf, gibt es Vorträge oder eine Networking-Runde und wie sehen die Online-Anmeldung oder der Einlass aus?',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_TITLE: '2. Der Feinschliff',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_BODY:
      'Sobald die Eventseite steht, lad Deine Gruppe und Leute aus Deinem Netzwerk oder Deiner Branche ein. Dadurch werden auch andere XING Mitglieder auf Dein Event aufmerksam. ',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_TITLE: '3. Die Gäste',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_HEADLINE: 'So gehst Du vor:',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_CTA: 'Gruppen-Event organisieren',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_FAQ_LINK:
      'Hier findest Du Tipps für Dein Gruppen-Event.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_HEADLINE: 'Plan Dein nächstes Event.',
    EP_EDIT_EVENT_SUBPAGE_LIVE_TAB: 'Veröffentlicht',
    EP_EDIT_EVENT_SUBPAGE_MORE_BUTTON: 'Mehr anzeigen',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_BODY:
      'Regelmäßige Treffen fördern den Austausch untereinander und locken auch immer wieder neue Leute in Deine Gruppe.',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_HEADLINE:
      'Zeit fürs nächste Gruppen-Event?',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_TIP:
      'Tipp: Spar Zeit, indem Du Dein letztes Gruppen-Event kopierst.',
    EP_EDIT_EVENT_SUBPAGE_PAST_TAB: 'Archiv',
    'EP_EDIT_EVENT_UPCOMING_TITLE.one': 'Anstehendes Event',
    'EP_EDIT_EVENT_UPCOMING_TITLE.other': 'Anstehende Events',
    'EP_EDIT_EVENT_UPCOMING_TITLE.zero': 'Anstehende Events',
    EP_EDIT_FOUNDINGYEAR: 'Gründungsjahr',
    EP_EDIT_FOUNDINGYEAR_FIELD_LABEL: 'Gründungsjahr',
    EP_EDIT_GALLERY: 'Galerie bearbeiten',
    EP_EDIT_GALLERY_EMPTY_STATE_BODY:
      'Mit Bildern und Videos wird Eure Seite lebendiger und eindrucksvoller. Hier ist Platz dafür.',
    EP_EDIT_GALLERY_EMPTY_STATE_CTA_IMAGE: 'Bild hinzufügen',
    EP_EDIT_GALLERY_EMPTY_STATE_CTA_VIDEO: 'Video hinzufügen ',
    EP_EDIT_GALLERY_EMPTY_STATE_HEADER: 'Sehenswert: Eure XING Seite.',
    EP_EDIT_GROUP_RULES: 'Gruppenregeln bearbeiten',
    EP_EDIT_IMPRINT: 'Impressum',
    EP_EDIT_IMPRINT_FIELD_LABEL: 'Impressum',
    EP_EDIT_INDUSTRY: 'Branche',
    EP_EDIT_INDUSTRY_FIELD_LABEL: 'Branche',
    EP_EDIT_INDUSTRYSEGMENT: 'Bereich',
    EP_EDIT_INDUSTRYSEGMENT_FIELD_LABEL: 'Bereich',
    EP_EDIT_INFO_EDIT_VIEW: 'Bearbeitungs-Ansicht',
    EP_EDIT_INFO_MOBILE:
      'Bitte nutzen Sie zur Bearbeitung einen <span>großen Bildschirm</span>.',
    EP_EDIT_INFO_MOBILE_EDITABLE:
      'Leider lassen sich noch nicht alle Bereiche am kleinen Bildschirm bearbeiten. Wir arbeiten aber dran.',
    EP_EDIT_INFO_VISITOR_VIEW: 'Besucheransicht',
    EP_EDIT_LOCATION_ADDRESS: 'Straße und Hausnr.',
    EP_EDIT_LOCATION_ADDRESSSUFFIX: 'Adresszusatz',
    EP_EDIT_LOCATION_CITY: 'Ort',
    EP_EDIT_LOCATION_COUNTRY: 'Land',
    EP_EDIT_LOCATION_EMAIL: 'E-Mail',
    EP_EDIT_LOCATION_FAXNUMBER: 'Fax',
    EP_EDIT_LOCATION_FAXNUMBERCOUNTRYCODE: 'Landesvorwahl',
    EP_EDIT_LOCATION_LABEL: 'Standort',
    EP_EDIT_LOCATION_PHONENUMBER: 'Telefon',
    EP_EDIT_LOCATION_PHONENUMBERCOUNTRYCODE: 'Landesvorwahl',
    EP_EDIT_LOCATION_POSTCODE: 'PLZ',
    EP_EDIT_LOCATION_WEBSITEURL: 'Website',
    EP_EDIT_PAGEINFO_COMPANY_BANNER:
      'Möchten Sie den Namen der Seite ändern? Kontaktieren Sie uns dafür bitte.',
    EP_EDIT_SECTION: 'Ausschnitt ändern',
    EP_EDIT_SELECTION: 'Einträge bearbeiten',
    EP_EDIT_SUBPAGE_LINK: 'Detailseite bearbeiten',
    EP_EDIT_WEBSITEURL: 'Website',
    EP_EDIT_WEBSITEURL_FIELD_LABEL: 'Website',
    EP_EDITBAR_MANAGE_UPDATES: 'Neuigkeiten verwalten',
    EP_EDITOR_BODY_PLACEHOLDER:
      'Füge eine Beschreibung über Euer Unternehmen hinzu.',
    EP_EDITOR_TITLE_PLACEHOLDER: 'Gib einen Titel an, z. B. „Wer wir sind“.\t',
    EP_EMPLOYEE: 'Mitarbeitende·r',
    EP_EMPLOYEE_CARD_SHARED_CONTACTS:
      '{sharedContactsNumber} gemeinsame Kontakte',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.one': '{value} gemeinsamer Kontakt',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.other': '{value} gemeinsame Kontakte',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.zero': 'Keine gemeinsamen Kontakte',
    EP_EMPLOYEE_FENCED:
      'Logg Dich ein, um alle {total} Mitarbeitenden auf XING zu sehen – und Deine persönliche Verbindung zum Unternehmen.',
    EP_EMPLOYEES: 'Mitarbeitende',
    EP_EMPLOYEES_BUTTON_ADD_CONTACT: 'Hinzufügen',
    EP_EMPLOYEES_BUTTON_REGISTER_NOW: 'Registrieren',
    EP_EMPLOYEES_BUTTON_SEND_MESSAGE: 'Nachricht',
    EP_EMPLOYEES_BUTTON_SIGN_IN: 'Einloggen',
    EP_EMPLOYEES_COUNT: '{employeesNumber} Mitarbeitende',
    EP_EMPLOYEES_DESCRIPTION: 'Mitarbeitende',
    EP_EMPLOYEES_EDIT_HINT:
      'Hier werden alle XING Mitglieder gelistet, die Ihr Unternehmen als Arbeitgeber angegeben haben.',
    EP_EMPLOYEES_EMPTY_STATE:
      'Bisher hat noch kein Mitglied dieses Unternehmen als Arbeitgeber angegeben.',
    EP_EMPLOYEES_FEEDBACK_ERROR: 'Das hat leider nicht geklappt.',
    EP_EMPLOYEES_HEADLINE: 'Mitarbeitende',
    EP_EMPLOYEES_LINK: 'Alle {number} Mitarbeitenden',
    EP_EMPLOYEES_LOAD_MORE_CTA: 'Weitere Mitarbeitende',
    EP_EMPLOYEES_NAVIGATION_TITLE: 'Mitarbeitende',
    EP_EMPLOYEES_NUMBER_EMPTY_STATE: 'Unternehmensgröße',
    EP_EMPLOYEES_OR: 'oder',
    EP_EMPLOYEES_SIGNIN: 'Einloggen',
    EP_EMPLOYEES_SUBPAGE_DESCRIPTION:
      'Auf einen Blick: Alle Mitarbeitenden von {pageTitle}, die bei XING sind.',
    EP_EMPLOYEES_TEXT_CTA_REGISTER_TO_SEE:
      'Registrier Dich, um alle {employeesNumber} Mitarbeitenden zu sehen.',
    EP_EMPLOYEES_TEXT_PROFILE_IMAGE_ALT: 'Profilbild von {profileName}',
    EP_EMPLOYEES_VIEW_PROFILE: 'Profil ansehen',
    EP_ERROR: 'Warum ist hier denn nichts zu sehen?',
    EP_ERROR_BODY:
      'Vielleicht klappt\'s wieder, wenn Du auf "Aktualisieren" klickst.',
    EP_ERROR_HEADER: 'Warum ist hier denn nichts zu sehen?',
    EP_ERROR_RELOAD_CTA: 'Aktualisieren',
    EP_EVENT_ALL_CTA: 'Alle Events',
    EP_EVENT_ALL_LINK: 'Alle Events',
    EP_EVENT_DELETE_ERROR:
      "Das hat gerade leider nicht geklappt. Versuchen Sie's bitte noch einmal.",
    EP_EVENT_EMPTY_STATE_BODY:
      'Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.',
    EP_EVENT_EMPTY_STATE_HEADLINE:
      'In dieser Gruppe haben noch keine Events stattgefunden.',
    EP_EVENT_PAST_TITLE: 'Vergangenes Event',
    EP_EVENT_SUBPAGE_BACK_LINK: 'Zurück zur Übersicht',
    EP_EVENT_SUBPAGE_EMPTY_STATE_PAST:
      'In dieser Gruppe haben noch keine Events stattgefunden.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_PAST_BODY:
      'Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING:
      'Zurzeit stehen keine Gruppen-Events an.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING_BODY:
      'Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.',
    EP_EVENT_SUBPAGE_MORE_CTA: 'Mehr anzeigen',
    EP_EVENT_SUBPAGE_PAST_TAB: 'Vergangene Events',
    EP_EVENT_SUBPAGE_UPCOMING_TAB: 'Anstehende Events',
    'EP_EVENT_UPCOMING_TITLE.one': 'Anstehendes Event',
    'EP_EVENT_UPCOMING_TITLE.other': 'Anstehende Events',
    'EP_EVENT_UPCOMING_TITLE.zero': 'Anstehende Events',
    EP_EVENTS_DESCRIPTION: 'Events',
    EP_EVENTS_HEADLINE: 'Events',
    EP_EVENTS_NAVIGATION_TITLE: 'Events',
    EP_EXISTING_COMPANY_NAME:
      'Es gibt schon eine XING Seite mit diesem Namen – nehmen Sie bitte einen anderen.',
    EP_FAX: 'Fax',
    EP_FEEDBACK_BUTTON: 'Feedback?',
    EP_FIELD_EMPTY_OR_MIN_CHARACTERS_ERROR:
      'Geben Sie hier bitte nichts oder mind. {value} Zeichen ein.',
    EP_FIELD_MAX_CHARACTERS_ERROR: 'Hier bitte max. {value} Zeichen eingeben',
    EP_FIELD_REQUIRED_ERROR: 'Können Sie dieses Feld bitte noch ausfüllen?',
    EP_FILE_SIZE_FORMAT_ERROR:
      'Bitte wählen Sie ein PDF-Dokument, das max. 100 MB groß ist.',
    EP_FIND_US_HERE: 'Hier findest Du uns:',
    EP_FLAG_EMPLOYER_BRANDING_PROFILE: 'Employer Branding Profile',
    EP_FOLLOW: 'Folgen',
    'EP_FOLLOWERS_COUNT_WEB.one': '{value} Follower',
    'EP_FOLLOWERS_COUNT_WEB.other': '{value} Follower',
    'EP_FOLLOWERS_COUNT_WEB.zero': 'Keine Follower',
    'EP_FOLLOWERS_SOCIAL_PROOF.one': '{username} folgt dieser Seite.',
    'EP_FOLLOWERS_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte folgen dieser Seite.',
    'EP_FOLLOWERS.one': 'Follower',
    'EP_FOLLOWERS.other': 'Follower',
    'EP_FOLLOWERS.zero': 'Follower',
    EP_FOLLOWING: 'Folgst Du',
    EP_FORMATTEDTIMESTAMP_DAYSAGO: 'Vor {number} Tagen',
    EP_FORMATTEDTIMESTAMP_DAYSAGO_SHORT: '{number} Tage',
    EP_FORMATTEDTIMESTAMP_TODAY: 'Heute',
    EP_FORMATTEDTIMESTAMP_YESTERDAY: 'Gestern',
    EP_FOUNDING_YEAR: '{foundingYear} gegründet',
    EP_FOUNDING_YEAR_EMPTY_STATE: 'Gründungsjahr',
    EP_FREE_ADD_CONTACT_INFO:
      'Mit der kostenlosen XING Seite können Sie nur eine Ansprechperson angeben. Daher haben wir Ihre bisherige Ansprechperson ersetzt.',
    EP_FREE_CONTACTS_PROBLEM:
      "Leider ist die Ansprechperson gerade nicht änderbar. Bitte versuchen Sie's später nochmal.",
    EP_GALLERY_MANAGER_INFO:
      'Hier können Sie Ihre Bilder und Videos verschieben, bearbeiten und löschen. Übrigens: Die obersten vier Bilder / Videos erscheinen im Modul "Impressionen" auf der Übersicht Ihrer XING Seite.',
    EP_GENERAL_ERROR_BUTTON: 'Neu laden',
    EP_GENERAL_ERROR_TEXT: 'Bitte lade die Seite erneut.',
    EP_GENERAL_ERROR_TITLE: 'Sieht so aus, als hätten wir ein Problem.',
    EP_GENERAL_FEEDBACK_ERROR:
      "Das hat leider nicht geklappt – versuchen Sie's einfach nochmal.",
    EP_GENERIC_FEEDBACK_ERROR:
      'Hoppla! Sieht so aus, als würde unser Server gerade nicht ganz rund laufen. Versuchen Sie es bitte nochmal.',
    EP_GM_IMAGE_CAPTION_HINT: 'Was soll unter dem Bild stehen?',
    EP_GM_IMAGE_CAPTION_LABEL: 'Bildunterschrift',
    EP_GM_IMAGE_INFO_BANNER: 'So wählst Du ideale Bilder aus:',
    EP_GM_IMAGE_INFO_BANNER_CTA: 'Tipps lesen',
    EP_GM_IMAGE_WILL_BE_DELETED: 'Bild gelöscht',
    EP_GM_NO_MEDIA:
      'Starten Sie eine Galerie: mit Bildern und Videos aus Ihrem Unternehmen.',
    EP_GM_NO_MEDIA_HEADLINE: 'Zeigen Sie hier Eindrücke aus Ihrem Unternehmen.',
    EP_GM_VIDEO_ENCODING:
      'Das Video <span>“{video_name}“</span> wird aufbereitet.',
    EP_GM_VIDEO_ENCODING_FAILED_INFO:
      'Dieses Video kann leider nicht abgespielt werden und wird deshalb entfernt. So sollte das Video sein: Eine Datei im Format .avi .mov oder .mp4, im Verhältnis 16: 9 und max. 5 GB groß.',
    EP_GM_VIDEO_ENCODING_FAILED_TITLE:
      'Videokodierung für <span>“{video_name}“</span> fehlgeschlagen',
    EP_GM_VIDEO_ENCODING_MESSAGE:
      'Wir werden Sie per E-Mail informieren, sobald es fertig und veröffentlicht ist.',
    EP_GM_VIDEO_WILL_BE_DELETED: 'Video gelöscht',
    EP_GO_HOME: 'Zur Startseite',
    EP_GROUP_ABOUT_LEGAL_NOTICE: 'Impressum',
    EP_GROUP_ABOUT_US_BOX_CATEGORIES_TITLE: 'Thema',
    EP_GROUP_ABOUT_US_BOX_HEADLINE: 'Infos',
    EP_GROUP_ABOUT_US_CATEGORY: 'Thema',
    'EP_GROUP_ABOUT_US_EVENTS.one': '{amount} Event',
    'EP_GROUP_ABOUT_US_EVENTS.other': '{amount} Events',
    'EP_GROUP_ABOUT_US_EVENTS.zero': 'Keine Events',
    EP_GROUP_ABOUT_US_FACTS: 'Infos',
    'EP_GROUP_ABOUT_US_MEMBERS.one': '{amount} Mitglied',
    'EP_GROUP_ABOUT_US_MEMBERS.other': '{amount} Mitglieder',
    'EP_GROUP_ABOUT_US_MEMBERS.zero': 'Keine Mitglieder',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_BODY:
      'Leg hier fest, wie Mitglieder sich verhalten sollen. ',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_CTA: 'Hinzufügen',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_EDIT: 'Bearbeiten',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HEADER: 'Was geht – und was nicht?',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HELP_TEXT:
      'Erklär, wie sich Gruppen-Mitglieder verhalten sollen, z. B. ...\n<ul>\n <li>welche Beiträge relevant sind und wie die Gruppe zu Spam steht und</li>\n <li>dass der Umgangston bei einer Diskussion wertschätzend bleiben sollte.</li>\n</ul>\n Die Regeln sollten übrigens gut leserlich sein, z. B. durch Stichpunkte.',
    EP_GROUP_ABOUT_US_RULES_PLACEHOLDER:
      'Leg hier fest, was erlaubt ist – und was nicht.',
    EP_GROUP_ABOUT_US_TITLE: 'Dürfen wir uns vorstellen?',
    EP_GROUP_ABOUT_US_UPCOMING_EVENTS_NONE: 'Keine anstehenden Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.one': '{amount} anstehendes Event',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.other': '{amount} anstehende Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.zero': 'Keine anstehenden Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.one': '%,d anstehendes Event',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.other': '%,d anstehende Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.zero': 'Keine anstehenden Events',
    EP_GROUP_ABOUT_US_VISIBILITY_PRIVATE: 'Privat',
    EP_GROUP_ABOUT_US_VISIBILITY_PUBLIC: 'Öffentlich',
    EP_GROUP_CREATION_CANCEL_CTA: 'Gruppe verwerfen',
    EP_GROUP_CREATION_CANCEL_KEEP_CTA: 'Nein, behalten',
    EP_GROUP_CREATION_CANCEL_TEXT:
      'Deine Eingaben auf dieser Seite gehen dann verloren.',
    EP_GROUP_CREATION_CANCEL_TITLE:
      'Möchtest Du Deine Gruppe wirklich verwerfen?',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_1: 'Name & Einstellungen',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_2: 'Thema',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_3: 'Beschreibung',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_4: 'Logo',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_1:
      'förderst Du den Netzwerk-Gedanken und machst die Mitglieder miteinander bekannt.',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2:
      'unterstützt Du die Mitglieder dabei, persönliche Kontakte zu knüpfen.\n',
    'EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2\n':
      'unterstützt Du die Mitglieder dabei, persönliche Kontakte zu knüpfen.\n',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_3:
      'organisierst Du regelmäßig Events (z. B. Workshops, Meetups oder Feierabend-Treffs).',
    EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL: 'Ja, ich akzeptiere den {link}.',
    EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL_LINK:
      'Verhaltenskodex für die Moderation',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_FEMALE:
      'Als Moderatorin einer Gruppe ...',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_MALE:
      'Als Moderator einer Gruppe ...',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_OTHER:
      'Als Moderatx einer Gruppe ...',
    EP_GROUP_CREATION_STEP_1_LOCATION_HELP_TEXT:
      'Wenn Du eine Stadt auswählst, empfehlen wir Deine Gruppe Mitgliedern, die von dort kommen oder dort arbeiten, auf deren Gruppen-Startseite. Es können aber auch andere Deiner Gruppe beitreten.',
    EP_GROUP_CREATION_STEP_1_LOCATION_OPTIONAL: '(Optional)',
    EP_GROUP_CREATION_STEP_1_LOCATION_TITLE:
      'Wähl hier Deine Stadt für eine lokale Gruppe aus. Sie wird dadurch Leuten aus der Gegend angezeigt.',
    EP_GROUP_CREATION_STEP_1_NAME_HEADER: 'Wie soll Deine Gruppe heißen?',
    EP_GROUP_CREATION_STEP_1_NAME_HELP_TEXT:
      "Der Gruppenname ist das Erste, was Deine neuen Mitglieder sehen. Wähl deshalb einen Namen, der auf den Punkt bringt, worum's geht.",
    EP_GROUP_CREATION_STEP_1_NAME_PLACEHOLDER: 'Z. B. "Marketing {city}"',
    EP_GROUP_CREATION_STEP_1_TITLE: 'Name & Einstellungen',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_HELP_TEXT:
      'Bei öffentlichen Gruppen können alle XING Mitglieder sehen, wer in der Gruppe ist, und Beiträge lesen. <br>\nWenn die Gruppe privat ist, können das nur Gruppen-Mitglieder. <br>\nDie Privatsphäre-Einstellungen für Events gelten unabhängig von denen der Gruppe: Öffentliche Gruppen können auch private Events veranstalten und umgekehrt.',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_PRIVATE:
      'Privat (nicht nachträglich änderbar)',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_PUBLIC: 'Öffentlich',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_TITLE:
      'Ist Deine Gruppe privat oder öffentlich?',
    EP_GROUP_CREATION_STEP_2_CATEGORY_HEADER:
      'Wähle Themen aus, die zu Deiner Gruppe passen.',
    EP_GROUP_CREATION_STEP_2_CATEGORY_HELPTEXT:
      'Füge hier bis zu 20 Themen hinzu. Dadurch können Interessenten Deine Gruppe bei der Suche nach diesen Themen finden und beitreten oder an Deinen Events teilnehmen.',
    EP_GROUP_CREATION_STEP_2_CATEGORY_PLACEHODER:
      'Z. B. "Marketing" oder "Projektmanagement"\n',
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_HEADER:
      "Worum geht's in Deiner Gruppe?",
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_HELP:
      'Beantworte z. B. diese Fragen:\n <ul>\n  <li>Für wen könnte die Gruppe interessant sein?</li>\n  <li>Was macht sie aus?</li>\n  <li>Wie oft finden Gruppen-Events statt und wie laufen die ab?</li>\n</ul> \n\nDu kannst übrigens {min}-{max} Zeichen verwenden und den Text auch formatieren.',
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_PLACEHOLDER:
      'Z. B. "Bei uns lernt Ihr andere aus der Branche kennen und tauscht Euch über Erfolge, Fehlschläge, Tipps und Neuigkeiten aus."\n',
    EP_GROUP_CREATION_STEP_4_CTA_CREATE_GROUP: 'Gruppe beantragen',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_CTA: 'Datei auswählen',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_HINT:
      'JPG, BMP oder PNG (max. 20 MB) im Format 16:9',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_TITLE:
      'Logo hierher ziehen oder auswählen',
    EP_GROUP_CREATION_SUCCESS_BULLET_1:
      'Wir schauen sie uns gleich an. Du bekommst dann eine E-Mail, sobald Deine Gruppe freigegeben wird. Das kann bis zu 48 Stunden dauern.',
    EP_GROUP_CREATION_SUCCESS_BULLET_2:
      'In der Zwischenzeit kannst Du ein Banner, Bilder oder ein Video hochladen. (Nutz dazu bitte einen Desktop-PC.)',
    EP_GROUP_CREATION_SUCCESS_BULLET_3:
      'Oder Du schreibst einen Willkommens-Beitrag. Neue Mitglieder sehen diesen, sobald die Gruppe freigegeben wurde.',
    EP_GROUP_CREATION_SUCCESS_CTA_BACK: 'Zur Gruppen-Übersicht',
    EP_GROUP_CREATION_SUCCESS_HEADLINE: 'Deine neue Gruppe "<name>" ist da.',
    EP_GROUP_CREATION_SUCCESS_LARGE_SCREEN_CTA: 'Zur Gruppe',
    EP_GROUP_CREATION_SUCCESS_SMALL_SCREEN_CTA: 'Zur Gruppe',
    EP_GROUP_DELETION_CTA: 'Jetzt löschen',
    EP_GROUP_DELETION_ERROR:
      "Deine Gruppe konnte gerade leider nicht gelöscht werden. Versuch's bitte nochmal.",
    EP_GROUP_DELETION_KEEP_CTA: 'Gruppe behalten',
    EP_GROUP_DELETION_SUCCESS: 'Deine Gruppe wurde gelöscht.',
    EP_GROUP_DELETION_TITLE: 'Möchtest Du Deine Gruppe wirklich löschen?',
    EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR:
      'Wir können gerade keine Beiträge erstellen. Bitte lad diese Seite neu.',
    EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR_CTA: 'Seite neu laden',
    EP_GROUP_DISCUSSIONS_LOAD_MORE_ERROR:
      "Wir können gerade keine weiteren Beiträge anzeigen. Bitte versuch's gleich nochmal.",
    'EP_GROUP_HEADER_MEMBERS.one': 'Mitglied',
    'EP_GROUP_HEADER_MEMBERS.other': 'Mitglieder',
    'EP_GROUP_HEADER_MEMBERS.zero': 'Mitglieder',
    EP_GROUP_HEADER_VISIBILITY_PRIVATE: 'Privat',
    EP_GROUP_HEADER_VISIBILITY_PUBLIC: 'Öffentlich',
    EP_GROUP_INFO_BLOCKED: 'Blockiert',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP:
      'Bitte übertrag die Moderation jemand anderem, bevor Du sie verlässt.\nKontaktier dafür unseren Kundenservice.',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CLOSE_CTA: 'Jetzt nicht',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CONTACT_CTA: 'Kontaktieren',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_TITLE: 'Diese Gruppe gehört Dir.',
    EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_EMAIL_ADDRESS: 'de-support@xing.com',
    EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_SUBJECT:
      'Ich möchte die Gruppen-Verantwortlichkeit abgeben.',
    EP_GROUP_LOCATION_TITLE: 'Ort',
    EP_GROUP_MEMBER_ADD_CONTACT: 'Vernetzen',
    EP_GROUP_MEMBER_ADD_CONTACT_ERROR:
      "Das hat leider nicht geklappt. Bitte versuch's nochmal.",
    EP_GROUP_MEMBER_ALL_LINK: 'Alle Gruppen-Mitglieder',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.one': '%d gemeinsamer Kontakt',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.other': '%d gemeinsame Kontakte',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.zero': '%d shared contacts',
    EP_GROUP_MEMBER_EDIT: 'Mitglieder verwalten',
    EP_GROUP_MEMBER_INVITE_CTA: 'Mitglieder einladen',
    EP_GROUP_MEMBER_INVITE_PLACEHOLDER:
      'Hallo,\nich möchte Dich gerne in die Gruppe "{group_name}" einladen und freue mich, Dich bald dort zu sehen!\n\nViele Grüße\n{invitor_name}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_BODY:
      'Alle Mitglieder haben Zugriff auf diese Gruppe und können Beiträge schreiben, lesen und kommentieren.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_TITLE:
      'Niemand ist zur Zeit blockiert.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SINCE: 'Blockiert seit {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SWITCHER: 'Blockiert',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_BODY:
      'Ausgeschlossene Personen verlieren ihre Mitgliedsrechte und können erst wieder beitreten, wenn Du den Ausschluss aufhebst.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_TITLE:
      'Niemand ist zur Zeit ausgeschlossen.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SINCE:
      'Ausgeschlossen seit {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SWITCHER: 'Ausgeschlossen',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_MEMBERS_SWITCHER: 'Mitglieder',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_BODY:
      'Sobald jemand dieser Gruppe beitreten möchte, sieht Du die Mitgliedsanfrage hier.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_TITLE:
      'Zur Zeit gibt es keine neuen Mitgliedsanfragen.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SINCE:
      'Mitgliedsanfrage vom {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SWITCHER: 'Anfragen',
    EP_GROUP_MEMBER_POP_UP_BODY_LO:
      'Registrier Dich kostenlos oder logg Dich ein, um alle {count} Mitglieder zu sehen.',
    EP_GROUP_MEMBER_REGISTER_LO: 'Kostenlos registrieren',
    EP_GROUP_MEMBER_SEARCH_EMPTY_BODY:
      "Wird die Person vielleicht anders geschrieben? Versuch's einfach nochmal oder mit einem anderen Wort.",
    EP_GROUP_MEMBER_SEARCH_EMPTY_HEADLINE:
      'Mit diesem Namen haben wir leider niemanden gefunden.',
    EP_GROUP_MEMBER_SIGN_IN_LO: 'Einloggen',
    EP_GROUP_MEMBER_SUBPAGE_MORE_CTA: 'Mehr anzeigen',
    EP_GROUP_MEMBER_TITLE: 'Mitglieder',
    EP_GROUP_MEMBER_VIEW_PROFILE_LO: 'Profil ansehen',
    EP_GROUP_MEMBER_WRITE_MESSAGE: 'Nachricht schreiben',
    EP_GROUP_MEMBERS_ADD_AS_MODERATOR: 'Ins Moderations-Team holen',
    EP_GROUP_MEMBERS_ADD_AS_MODERATOR_SUCCESS:
      'Du hast {name} ins Moderations-Team Deiner Gruppe geholt.',
    EP_GROUP_MEMBERS_BLOCK_MEMBER: 'Mitglied blockieren',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP:
      '{first_name} kann dann solange keine Beiträge oder Kommentare veröffentlichen, bis Du die Blockierung aufhebst.',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_HEADLINE: '{name} blockieren?',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_YES: 'Ja, blockieren',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_SUCCESS: '{name} ist jetzt blockiert.',
    EP_GROUP_MEMBERS_BLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_CHANGE_ROLE_ERROR:
      'Das hat leider nicht geklappt. Kannst Du es bitte noch einmal versuchen?',
    EP_GROUP_MEMBERS_CHANGE_STATUS_POP_UP_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_CONFIRM_MEMBER_SUCCESS:
      '{first_name} ist jetzt auch ein Mitglied dieser Gruppe.',
    EP_GROUP_MEMBERS_DECLINE_MEMBER_SUCCESS:
      'Du hast die Mitgliedsanfrage von {name} abgelehnt.',
    EP_GROUP_MEMBERS_GROUP_OWNER_INFO: 'Hat die Gruppe am {date} gegründet',
    EP_GROUP_MEMBERS_GROUP_PENDING_OWNER_INFO:
      'Sobald Deine Gruppe freigegeben wird, kannst Du Leute dazu einladen.',
    EP_GROUP_MEMBERS_LOAD_MORE_ERROR:
      "Wir können gerade keine weiteren Mitglieder anzeigen. Bitte versuch's gleich nochmal.",
    EP_GROUP_MEMBERS_MEMBERSHIP_ACTION_ERROR:
      "Das hat leider nicht geklappt. Bitte versuch's nochmal.",
    EP_GROUP_MEMBERS_MEMBERSHIP_INFO: 'Mitglied seit dem {date}',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.one':
      'Soll Deine Gruppe wachsen? Nimm die Anfrage an und heiß Dein neues Mitglied willkommen, oder lehn sie ab.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.other':
      'Soll Deine Gruppe wachsen? Nimm die Anfragen an und heiß Deine neuen Mitglieder willkommen, oder lehn sie ab.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.zero':
      'Do you want your group to grow? Accept the request to welcome your new member or decline it.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.one': 'Mitgliedsanfrage ansehen',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.other': 'Mitgliedsanfragen ansehen',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.zero': 'View pending requests',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.one': '{number} offene Mitgliedsanfrage',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.other': '{number} offene Mitgliedsanfragen',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.zero':
      '{number} pending membership requests',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP: 'Ausschluss aufheben',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_BODY: 'Ausschluss aufheben? ',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_YES: 'Ausschluss aufheben',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_SUCCESS:
      '{name} kann jetzt eine neue Mitgliedsanfrage stellen.',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_TEXT:
      '{name} ist dann nicht mehr ausgeschlossen, aber auch noch nicht wieder Mitglied dieser Gruppe. Dafür braucht es eine erneute Mitgliedsanfrage.',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR: 'Moderationsstatus aufheben',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP:
      '{name} aus dem Moderations-Team entfernen?',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_CONTENT:
      'Dadurch verliert {first_name} den Moderations-Status und ist wieder normales Mitglied.',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_YES: 'Ja, entfernen',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_SUCCESS:
      'Du hast {name} aus dem Moderations-Team entfernt.',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP: 'Aus der Gruppe ausschließen',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_HEADLINE:
      '{name} aus der Gruppe ausschließen?',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP:
      '{first_name} ist dann kein Mitglied mehr und kann der Gruppe so lange nicht wieder beitreten, bis Du den Ausschluss aufhebst.',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_YES: 'Ausschließen',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_SUCCESS:
      '{name} ist jetzt aus der Gruppe ausgeschlossen.',
    EP_GROUP_MEMBERS_SEARCH_BAR: 'Z. B. "Max Mustermann"',
    EP_GROUP_MEMBERS_SEARCH_BAR_MOBILE: 'Z. B. "Max Mustermann"',
    EP_GROUP_MEMBERS_SEARCH_BUTTON: 'Mitglieder durchsuchen',
    'EP_GROUP_MEMBERS_TOTAL.one': 'Eine Person',
    'EP_GROUP_MEMBERS_TOTAL.other': '{value} Personen',
    'EP_GROUP_MEMBERS_TOTAL.zero': 'Niemand',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER: 'Blockierung aufheben',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER_POP_UP:
      '{first_name} kann dann wieder Beiträge und Kommentare in dieser Gruppe schreiben.',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER_SUCCESS:
      'Die Blockierung ist jetzt aufgehoben. {name} kann wieder was veröffentlichen.',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_YES: 'Blockierung aufheben',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_HEADLINE:
      '{name} nicht mehr blockieren?',
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_BODY:
      "Bestimmt gibt's in Deinem persönlichen Netzwerk spannende Leute, die Deiner Gruppe beitreten und an Deinen Events teilnehmen möchten.",
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_CTA: 'Leute einladen',
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_HEADLINE:
      'Wen suchst Du für Deine Gruppe?',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_BODY:
      'Kennst Du Leute, die zu dieser Gruppe passen? Oder daran interessiert sind, Gruppen-Mitglieder kennenzulernen? Lad sie ein, beizutreten.',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_CTA: 'Kontakte einladen',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_HEADLINE:
      'Wer sollte dieser Gruppe noch beitreten?',
    EP_GROUP_OWNER_DRAFT_BANNER_BODY:
      'Es fehlen nur noch ein paar Infos. Und sobald sie veröffentlicht ist, kannst Du Leute in Deine Gruppe einladen.',
    EP_GROUP_OWNER_DRAFT_BANNER_DELETE_CTA: 'Gruppe verwerfen',
    EP_GROUP_OWNER_DRAFT_BANNER_FINISH_CTA: 'Jetzt fertigstellen',
    EP_GROUP_OWNER_DRAFT_BANNER_TITLE:
      'Deine Gruppe <b>"%group_name</b> ist fast fertig ...',
    EP_GROUP_OWNER_YOUR_GROUPS_PENDING_INFO:
      'Wird gerade geprüft (Antrag vom {date})',
    EP_GROUP_ROLE_INFO_MEMBER: 'Mitglied',
    EP_GROUP_ROLE_INFO_MODERATOR: 'Moderation',
    EP_GROUP_RULES_TITLE: 'Gruppenregeln',
    'EP_GROUP_SOCIAL_PROOF.one': '{username} ist schon dabei.',
    'EP_GROUP_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte sind schon dabei.',
    EP_GROUP_START_PAGE_BODY:
      'Gruppen sind dazu da, echte Menschen kennenzulernen und sich auszutauschen. Z. B. bei Meetups zu einem bestimmten Thema oder After-Work-Abenden zum Netzwerken.',
    EP_GROUP_START_PAGE_CREATE_GROUP_CTA: 'Gruppe starten',
    EP_GROUP_START_PAGE_HEADER: 'Entdecke Gruppen, die zu Dir passen!',
    EP_GROUP_START_PAGE_NEW_GROUPS_HEADER: 'Deine Gruppen mit neuem Design',
    EP_GROUP_START_PAGE_NEW_GROUPS_INFO_BODY:
      'Das haben wir auch gefragt. Aber das Team meinte, dass es noch 4 Wochen dauert, bis alle umgestellt sind. Dann haben wir uns doch entschieden, Dir Deine ersten Gruppen im neuen Design gleich zu zeigen.',
    EP_GROUP_START_PAGE_NEW_GROUPS_INFO_TITLE:
      'Warum sind manche Gruppen im neuen und manche im alten Design?',
    EP_GROUP_START_PAGE_NEW_GROUPS_MEMBER_BODY:
      'Ganz neu und aufgehübscht. Und mit verbesserten Funktionen für Events. Die restlichen Gruppen folgen übrigens bald.',
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY:
      "Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. Dadurch kannst Du Deine Gruppen besser verwalten. Außerdem gibt's verbesserte Funktionen für Deine Events. Und auf dem Smartphone oder Tablet sehen Gruppen jetzt auch besser aus. <a href=“https://faq.xing.com/node/68236”>Was ist neu?</a>",
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_ANDROID:
      'Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. <a href=“https://faq.xing.com/node/68236”>Was ist sonst noch neu?</a>',
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_IOS:
      'Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. <a href=“https://faq.xing.com/node/68236”>Was ist sonst noch neu?</a>',
    EP_GROUP_START_PAGE_OLD_GROUPS_HEADER:
      'Deine Gruppen mit bestehendem Design',
    EP_GROUP_START_PAGE_OLD_GROUPS_MEMBER_BODY:
      'Diese Gruppen sehen noch so aus wie vorher, werden aber auch bald im neuen Design erstrahlen. ',
    EP_GROUP_START_PAGE_SEARCH_GROUP_CTA: 'Nach Gruppen suchen',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_BODY:
      'Finde jetzt Deine Gruppe und lern neue Leute kennen.',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_CTA: 'Spannende Gruppen entdecken',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_TITLE:
      'Alle Deine Gruppen siehst Du hier.',
    EP_GROUP_XBM_ENTRY_BODY:
      'Möchtest Du wissen, wie sich Deine Mitgliederzahlen entwickeln oder wie oft Deine Gruppe gefunden wird? ',
    EP_GROUP_XBM_ENTRY_CTA: 'Zur Gruppen-Analyse',
    EP_HEADER_IMAGE_BANNER_BODY:
      'Gerade kannst Du das Titelbild als <strong>Entwurf speichern</strong> und es ist <strong>nur für Dich sichtbar</strong>. <br />\nMöchtest Du, dass andere Dein Titelbild auch sehen? Dann hole Dir das <strong>Upgrade</strong> und <strong>veröffentliche Dein Bild</strong> danach.',
    EP_HEADER_IMAGE_BANNER_DRAFT_BUTTON:
      'Titelbild erstmal als Entwurf speichern',
    EP_HEADER_IMAGE_BANNER_HEADER:
      'Upgrade sichern und Titelbild veröffentlichen',
    EP_HEADER_IMAGE_BANNER_PUBLISH_BUTTON: 'Upgrade sichern',
    EP_HEADER_LAST_STEP_CREATE_PAGE:
      'Glückwunsch, Ihr Profil {companyName} ist fast fertig!',
    EP_HELP_CENTER: 'Hilfebereich\n',
    EP_IDEAL_EMPLOYER_ADD: 'Als Wunsch-Arbeitgeber hinzufügen',
    EP_IDEAL_EMPLOYER_ADD_CONFIDENTIALLY:
      'Füg dieses Unternehmen einfach als Wunsch-Arbeitgeber hinzu, um es vertraulich über Dein Interesse zu informieren.',
    EP_IDEAL_EMPLOYER_ADDED: 'Als Wunsch-Arbeitgeber hinzugefügt',
    EP_IDEAL_EMPLOYER_ADMIN_ADAPT: 'Das geht direkt im BrandManager.',
    EP_IDEAL_EMPLOYER_ADMIN_GO_BM: 'BrandManager öffnen',
    EP_IDEAL_EMPLOYER_ADMIN_LAPTOP:
      'Das geht direkt im BrandManager (am besten mit etwas größerem Bildschirm). ',
    EP_IDEAL_EMPLOYER_ADMIN_POSITION: ' "Wunsch-Arbeitgeber"-Modul bearbeiten',
    EP_IDEAL_EMPLOYER_CONFIDENTIAL_INFO:
      'Außer dem Arbeitgeber erfährt niemand davon. Es sei denn, Du hast andere in Deinen Job-Wünschen dazu freigeschaltet.',
    EP_IDEAL_EMPLOYER_EDIT_HINT:
      'Im BrandManager sehen Sie, wie viele Mitglieder Ihr Unternehmen aktuell als Wunsch-Arbeitgeber angeben.',
    EP_IDEAL_EMPLOYER_EDIT_HINT_CTA: 'Zum BrandManager',
    EP_IDEAL_EMPLOYER_EI_CONFIDENTIAL:
      'Außer dem Arbeitgeber erfährt davon niemand – es sei denn, Du hast andere in Deinen Job-Wünschen dafür freigeschaltet.',
    EP_IDEAL_EMPLOYER_EI_HOW: 'Wie funktioniert das?',
    EP_IDEAL_EMPLOYER_EI_NON_COMMITTAL:
      'Wir sagen dem Arbeitgeber Bescheid, dass Du gerne dort arbeiten würdest. ',
    EP_IDEAL_EMPLOYER_EI_POTENTIAL:
      'Dadurch erhöhst Du Deine Chance, von diesem Arbeitgeber kontaktiert zu werden.',
    EP_IDEAL_EMPLOYER_EI_UPTO_30:
      'Du kannst bis zu 30 Wunsch-Arbeitgeber eintragen.',
    EP_IDEAL_EMPLOYER_HEADLINE: 'Wunsch-Arbeitgeber',
    EP_IDEAL_EMPLOYER_MAX:
      'Du hast jetzt 30 Wunsch-Arbeitgeber eingetragen – mehr geht leider nicht. ',
    EP_IDEAL_EMPLOYER_NAVIGATION_TITLE: 'Wunsch-Arbeitgeber',
    EP_IDEAL_EMPLOYER_REMOVE: 'Doch kein Wunsch-Arbeitgeber?',
    EP_IDEAL_EMPLOYER_WORK: 'Würdest Du hier gern arbeiten?',
    EP_IMAGE_UPLOAD_SIZE_FORMAT_ERROR:
      'Dieses Bild geht leider nicht: Mögliche Formate sind JPG, JPEG oder PNG, die Maximalgröße beträgt 5 MB.',
    EP_INDUSTRY_SUBCATEGORY: 'Unterbereich',
    EP_INFO_LAST_STEP_CREATE_PAGE:
      '– In der Zwischenzeit können Sie bereits weitere Inhalte zu Ihrem Arbeitgeberprofil hinzufügen.',
    EP_INPUT_CHARS_LEFT: 'Noch {charactersNumber} Zeichen\n',
    EP_INSIDER_CHANGE_PROFILE_INFO_BUTTON: 'Profil besuchen',
    EP_INSIDER_CHANGE_PROFILE_INFO_TEXT:
      'Dein Profilbild und Hintergrundbild kannst Du in Deinem Profil anpassen.',
    EP_INVALID_COMPANY_NAME:
      "Eine XING Seite mit diesem Namen gibt's schon. Schauen Sie doch mal nach.",
    EP_JOB_ADS_FOUND: '{total} Stellenangebote gefunden',
    EP_JOB_JOBBOX: 'Gemerkte Jobs ansehen',
    EP_JOB_LOOKING: 'Auf Job-Suche?',
    EP_JOB_NO_VACANCIES: "Im Moment gibt's keine offenen Stellen.",
    EP_JOBS_CAREER_LEVEL: 'Karriere-Stufe',
    EP_JOBS_DAYSAGO: 'Vor {number} Tagen ',
    EP_JOBS_DESCRIPTION: 'Jobs',
    EP_JOBS_DISCIPLINE: 'Tätigkeitsfeld',
    EP_JOBS_EDIT_HINT:
      'Hier werden alle Stellenanzeigen angezeigt, die Sie bei XING geschaltet haben. ',
    EP_JOBS_EDITSWITCH_CTA: 'Zum XING JobManager',
    EP_JOBS_EDITSWITCH_DISCRIPTION:
      '... können Sie direkt im {jobManager}.\nDas geht übrigens am besten am großen Bildschirm.',
    EP_JOBS_EDITSWITCH_DISCRIPTION_INNER: 'XING JobManager',
    EP_JOBS_EDITSWITCH_HEADLINE: 'Stellenanzeigen schalten und verwalten',
    EP_JOBS_EMPTYSTATE_BODY:
      'Mit Ihrem neuen Jobangebot finden Sie auch die richtigen Mitarbeiter.',
    EP_JOBS_EMPTYSTATE_CTA: 'Neues Jobangebot hinzufügen',
    EP_JOBS_EMPTYSTATE_HEADER: 'Sie haben zurzeit keine offenen Stellen.',
    EP_JOBS_FEEDBACK_ERROR: 'Das hat leider nicht geklappt',
    EP_JOBS_FILTER_ALL: 'Alle',
    EP_JOBS_HEADLINE: 'Jobs',
    EP_JOBS_LINK: 'Alle {number} Jobs ',
    EP_JOBS_LOCATIONS: 'Arbeitsorte',
    EP_JOBS_MATCH: '{number} % Übereinstimmung ',
    EP_JOBS_NAVIGATION_TITLE: 'Jobs',
    EP_JOBS_PUBLIC_EMPTYSTATE_BODY:
      'Bist Du auf Job-Suche? Dann guck Dir mal unsere Empfehlungen an.',
    EP_JOBS_PUBLIC_EMPTYSTATE_CTA: 'Empfehlungen anschauen',
    EP_JOBS_PUBLIC_EMPTYSTATE_HEADER: 'Zurzeit gibt es keine Job-Angebote.',
    EP_JOBS_RECOMMENDATION: 'Job-Vorschläge ansehen',
    EP_JOBS_SEARCH_PLACEHOLDER: 'Job-Titel oder Stichwort eingeben',
    EP_JOBS_SUBPAGE_DESCRIPTION:
      'Alle Jobangebote von {pageTitle} auf einen Blick',
    EP_JOBS_TODAY: 'Heute',
    EP_JOBS_YESTERDAY: 'Gestern',
    EP_JOIN_GROUP_CTA: 'Beitreten',
    EP_KUNUNU_ALL_BENEFITS: 'Alle Vorteile auf kununu',
    EP_KUNUNU_ALL_REVIEWS: 'Alle {number} Bewertungen auf kununu',
    EP_KUNUNU_BENEFITS_CONFIRMATION:
      'In {total} von {totalReviews} Bewertungen bestätigt',
    EP_KUNUNU_BENEFITS_TITLE: 'Vorteile für Mitarbeitende',
    EP_KUNUNU_CULTURE_BUTTON: 'Unternehmenskultur anzeigen',
    EP_KUNUNU_DISCOVER_REVIEWS:
      'Lerne das Unternehmen kennen und erfahre mehr über die Unternehmenskultur',
    EP_KUNUNU_DISCOVER_REVIEWS_CULTURE:
      'Lerne das Unternehmen kennen und erfahre mehr über seine Kultur.',
    EP_KUNUNU_EDIT_HINT:
      'Diese Bewertungen kommen direkt von Ihrem kununu-Profil.',
    EP_KUNUNU_EDIT_HINT_CTA: 'Zum kununu-Profil',
    EP_KUNUNU_HEADLINE: 'Bewertungen',
    EP_KUNUNU_NAVIGATION_TITLE: 'Bewertungen & Kultur',
    EP_KUNUNU_RATE_COMPANY:
      'Arbeitest Du hier – oder hast mal hier gearbeitet?',
    EP_KUNUNU_RATE_COMPANY_BUTTON: 'Arbeitgeber bewerten',
    EP_KUNUNU_RATING: 'Bewertung auf kununu',
    EP_KUNUNU_RATING_VALUE: '{value} / {fullValue}',
    EP_KUNUNU_READ_REVIEW: 'Bewertung lesen',
    EP_KUNUNU_RECOMMENDATION: 'empfehlen diesen Arbeitgeber',
    EP_KUNUNU_REVIEW_TITLE: 'Zitate von Mitarbeitenden',
    EP_KUNUNU_REVIEWER_CURRENT_JOB: 'Arbeitet hier',
    EP_KUNUNU_REVIEWER_FORMER_JOB: 'Hat hier gearbeitet',
    EP_KUNUNU_REVIEWER_INTERNSHIP_JOB: 'Praktikum',
    EP_KUNUNU_REVIEWER_NS_JOB: 'Keine Angabe',
    EP_KUNUNU_SHARE_BUTTON: 'Diesen Arbeitgeber bewerten',
    EP_KUNUNU_SHARE_DETAIL:
      'Teil Deine Erfahrungen mit anderen, natürlich anonym. ',
    EP_KUNUNU_SHARE_TITLE: 'Hast Du für {company} gearbeitet?',
    EP_KUNUNU_WHAT_SAY_BUTTON: 'Profil auf kununu ansehen',
    EP_LEARN_MORE_ABOUT_US: 'Alle Infos über uns',
    EP_LEGAL_NOTICE: 'Impressum',
    EP_LEGAL_NOTICE_EMPTY_STATE: 'Impressum',
    EP_LOAD_MORE_CTA: 'Weitere Beiträge',
    EP_LOCATION_ADDRESS_ERROR:
      'Diese Anschrift haben wir nicht gefunden – können Sie das nochmal prüfen?',
    EP_LOCATION_CITY_ERROR:
      'Diesen Ort haben wir nicht gefunden – können Sie das nochmal prüfen?',
    EP_LOCATION_EMAIL_ERROR:
      'Dies scheint keine E-Mail-Adresse zu sein ... vielleicht vertippt?',
    EP_LOCATION_EMPTY_STATE_BUTTON: 'Kontaktdaten eingeben',
    EP_LOCATION_EMPTY_STATE_TEXT:
      'Bitte geben Sie noch Ihre Anschrift und Kontaktdaten an. Danach können Sie Ihre Seite veröffentlichen.',
    EP_LOCATION_EMPTY_STATE_TITLE: 'Wo kann man Sie finden? Und wie erreichen?',
    EP_LOCATION_FAXNUMBER_ERROR:
      'Bitte geben Sie hier nur Ziffern ein (mind. 5).',
    EP_LOCATION_LABEL_ERROR:
      'Diesen Ort haben wir nicht erkannt – können Sie Ihre Eingabe nochmal prüfen?',
    EP_LOCATION_PHONENUMBER_ERROR:
      'Bitte geben Sie hier nur Ziffern ein (mind. 5).',
    EP_LOCATION_POSTCODE_ERROR: 'Bitte geben Sie hier keine Sonderzeichen ein.',
    EP_LOCATION_WEBSITE_ERROR:
      'Diese Web-Adresse haben wir nicht gefunden ... vielleicht vertippt?',
    EP_LOCATIONS_EDIT_TITLE: 'Standort bearbeiten',
    EP_LOCATIONS_HEADLINE: 'Standort',
    EP_LOCATIONS_NAVIGATION_TITLE: 'Ort',
    EP_LOCATIONS_OPEN_MAP: 'Größere Karte',
    EP_MAIL_LAST_STEP_CREATE_PAGE:
      '– Wir senden die Bestätigungs-Mail an die folgende E-Mail-Adresse: {mail}',
    EP_MANAGE_CONTENT: 'Medien verwalten',
    EP_MAX: 'Max.',
    EP_MEDIA_HEADLINE: 'Impressionen',
    EP_MEMBERS_BLOCKED_MEMBER_LEAVE_BODY:
      'Du bist dann kein Mitglied mehr und kannst der Gruppe auch nicht wieder beitreten.',
    EP_MEMBERS_BLOCKED_MEMBER_LEAVE_HEADLINE:
      'Möchtest Du die Gruppe verlassen?',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.one': '{value} gemeinsamer Kontakt',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.other': '{value} gemeinsame Kontakte',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.zero': 'Keine gemeinsamen Kontakte',
    EP_MEMBERS_DESCRIPTION: 'Mitglieder',
    EP_MEMBERS_FEEDBACK_ERROR:
      "Das hat gerade leider nicht geklappt. Versuch's bitte gleich nochmal.",
    EP_MEMBERS_HEADLINE: 'Mitglieder',
    EP_MEMBERS_LEAVE_GROUP_NO: 'Abbrechen',
    EP_MEMBERS_LEAVE_GROUP_YES: 'Gruppe verlassen',
    EP_MEMBERS_MEMBER_LEAVE_BODY:
      'Du bist dann kein Mitglied mehr, kannst der Gruppe später aber wieder beitreten.',
    EP_MEMBERS_MEMBER_LEAVE_HEADLINE: 'Möchtest Du die Gruppe verlassen?',
    EP_MEMBERS_MODERATOR_LEAVE_BODY:
      'Du bist dann kein Mitglied mehr und verlierst alle Moderations-Rechte, kannst der Gruppe später aber wieder beitreten.',
    EP_MEMBERS_MODERATOR_LEAVE_HEADLINE: 'Möchtest Du die Gruppe verlassen?',
    EP_MEMBERS_NAVIGATION_TITLE: 'Mitglieder',
    EP_MEMBERS_OR: 'oder',
    EP_META_ABOUT_US_DESCRIPTION:
      '► Was zeichnet {pageTitle} als Arbeitgeber aus? Wie ist es, dort zu arbeiten? Das Unternehmen stellt sich Dir vor.',
    EP_META_ABOUT_US_TITLE: 'Über {pageTitle} | XING',
    EP_META_COMPANY_DESCRIPTION:
      '► Alles über {pageTitle} als Arbeitgeber: Informationen, Neuigkeiten, offene Stellen, Ansprechpersonen, Standorte und mehr',
    EP_META_CONTACTS_DESCRIPTION:
      'Ansprechpersonen für alle Anliegen an den Arbeitgeber {pageTitle}',
    EP_META_CONTACTS_TITLE: 'Ansprechpersonen von {pageTitle} | XING',
    EP_META_DESCRIPTION_COMPANY_PAGES:
      "Was zeichnet {pageTitle} als Arbeitgeber aus? Hier erfährst Du's.",
    EP_META_DESCRIPTION_DEFAULT:
      'Infos, aktuelle Neuigkeiten und offene Jobs von {pageTitle} – direkt auf XING.',
    EP_META_DESCRIPTION_PUBLISHER_PAGES:
      'Die besten Artikel von {pageTitle} – einfach folgen, direkt auf XING.',
    EP_META_DESCRIPTION_TOPIC_PAGES:
      'Das Neueste zum Thema {pageTitle} – einfach folgen, direkt auf XING.',
    EP_META_DISCUSSIONS_DESCRIPTION:
      '✅  Aktuelle Themen und Diskussionen der Gruppe {pageTitle}.',
    EP_META_DISCUSSIONS_TITLE: '{pageTitle}: Diskussionen | XING',
    EP_META_EMPLOYEES_DESCRIPTION:
      '► Mitarbeitende von {pageTitle} bei XING. Wenn kennst Du schon – und seid Ihr schon vernetzt? Wenn nicht, lernt Euch kennen und tauscht Euch zu gemeinsamen Themen aus.',
    EP_META_EMPLOYEES_TITLE: 'Mitarbeitende von {pageTitle} | XING',
    EP_META_EVENTS_DESCRIPTION:
      '✅ Hier siehst Du alle Gruppen-Events von {pageTitle}. Tausch Dich aus, vernetz Dich oder lern andere Mitglieder kennen.',
    EP_META_EVENTS_TITLE: 'Alle Gruppen-Events von {pageTitle} | XING',
    EP_META_JOBS_DESCRIPTION:
      '✅ Auf Job-Suche? Hier siehst Du aktuelle Stellenangebote von {pageTitle}. Informier Dich auch über Vorteile für Mitarbeitende und bewirb Dich direkt.',
    EP_META_JOBS_TITLE: 'Offene Stellen bei {pageTitle} | XING',
    EP_META_MEMBERS_DESCRIPTION:
      '✅ Schau nach, wer schon dabei ist, und erweiter Dein Netzwerk.',
    EP_META_MEMBERS_TITLE: 'Mitglieder der Gruppe {pageTitle} | XING',
    EP_META_NEWS_DESCRIPTION:
      "► Was gibt's Neues und Interessantes bei {pageTitle}? Hier erfährst Du's – aus erster Hand. Folge jetzt der XING Seite von {pageTitle}.",
    EP_META_NEWS_TITLE: 'Neuigkeiten und Infos von {pageTitle} | XING',
    EP_META_PAGE_TITLE: '{pageTitle}: Informationen und Neuigkeiten | XING',
    EP_META_WEBSITE_ERROR:
      'Dies scheint keine Website zu sein ... vielleicht vertippt?',
    EP_META_YEAR_LABEL_ERROR:
      'Dies scheint kein Jahr zu sein ... vielleicht vertippt?',
    EP_MIN: 'Mind.',
    EP_MODULE_DISCUSSION_EDITOR_TAB_HIDDEN: 'Ausgeblendet',
    EP_MODULE_DISCUSSION_EDITOR_TAB_PUBLISHED: 'Veröffentlicht',
    EP_MODULE_DISCUSSION_SHOW_MORE: 'Mehr anzeigen',
    EP_MODULE_DISCUSSION_TITLE: 'Diskussionen',
    EP_MODULE_DISCUSSIONS_ALL_LINK: 'Alle Beiträge',
    EP_MODULE_ERROR_SUBLINE:
      'Bitte versuch es nochmal oder geh zur {overview} zurück.',
    EP_MODULE_ERROR_SUBLINE_INNER: '{entityPage} Überblick',
    EP_NA: 'Keine Angabe',
    EP_NAVIGATION_EDIT_HINT:
      'Die Sichtbarkeit und Reihenfolge der Tabs können Sie im XING BrandManager ändern.',
    EP_NAVIGATION_EDIT_HINT_CTA: 'BrandManager öffnen',
    EP_NEW_PAGE_CREATED_DRAFT:
      'Dieses Arbeitgeberprofil befindet sich im Entwurfsmodus und ist noch nicht veröffentlicht.',
    EP_NEWS_ACTION_TYPE_ARTICLE: 'hat diesen Artikel geteilt.',
    EP_NEWS_ACTION_TYPE_IMAGE: 'hat dieses Bild geteilt.',
    EP_NEWS_ACTION_TYPE_LINK: 'hat diesen Link geteilt.',
    EP_NEWS_ACTION_TYPE_TEXT: 'hat einen Beitrag geschrieben.',
    EP_NEWS_ACTION_TYPE_VIDEO: 'hat dieses Video geteilt.',
    EP_NEWS_DESCRIPTION: 'Neuigkeiten',
    EP_NEWS_HEADLINE: 'Neuigkeiten',
    EP_NEWS_NAVIGATION_TITLE: 'Neuigkeiten',
    EP_NEWS_SHOW_ALL: 'Alle Neuigkeiten',
    EP_NEWS_SUBPAGE_DESCRIPTION:
      'Alle Neuigkeiten von {pageTitle} auf einen Blick',
    EP_NEWS_UPSELL_POPOVER_BODY:
      'Ein angehefteter Artikel erscheint immer an oberster Stelle Ihrer Neuigkeiten. Damit heben Sie Beiträge hervor, die besondere Aufmerksamkeit verdienen.',
    EP_NEWS_UPSELL_POPOVER_BUTTON: 'Alle Vorteile entdecken',
    EP_NEWS_UPSELL_POPOVER_HEADER: 'Top-Artikel anheften',
    EP_NEXT_BUTTON_LAST_STEP_CREATE_PAGE: 'Arbeitgeberprofil weiter bearbeiten',
    EP_NO_DOCUMENTS:
      'Bieten Sie Ihren Seitenbesuchern hier z. B. Produkt-Infos, Jahresberichte oder Firmen-Zeitschriften.',
    EP_NO_DOCUMENTS_HEADLINE: 'Hier ist Platz für Ihre PDF-Dokumente.',
    EP_OF_CONTACTS: 'Deiner Kontakte',
    EP_ON_XING: 'auf XING',
    EP_OPTIONAL_FIELD_HINT: 'Optional',
    EP_OPTIONS: 'Was möchtest Du tun?',
    EP_PAGE_CREATION_ABOUT_US_SUBHEADER:
      'Titel und Beschreibung erscheinen auf Eurem Arbeitgeberprofil unter „Über uns“. Beides ist notwendig für die Freigabe und kann in Eurem Profil noch angepasst werden.',
    EP_PAGE_CREATION_BACK_TO_COMPANIES: 'Zurück zur Übersicht',
    EP_PAGE_CREATION_CLOSE: 'Ja, löschen',
    EP_PAGE_CREATION_CLOSE_PROCESS:
      'Möchten Sie das Profil {name} wirklich löschen?',
    EP_PAGE_CREATION_COMPANY_NAME_HELPER:
      'Bitte achten Sie auf die richtige Schreibweise Ihres Unternehmens, da diese Eingabe nicht mehr rückgängig gemacht werden kann.',
    EP_PAGE_CREATION_CONDITIONS:
      'Ich bin berechtigt, diese XING Seite zu erstellen, und akzeptiere die <a href="https://www.xing.com/terms/employer-branding-profil" target="_blank">AGB für XING Unternehmensprofile</a>.',
    EP_PAGE_CREATION_CONTACTS_INFO:
      'Die Kontaktdaten Ihres Unternehmens werden auf dem Arbeitgeberprofil veröffentlicht. ',
    EP_PAGE_CREATION_DELETE_PROFILE: 'Profilentwurf löschen',
    EP_PAGE_CREATION_DIALOG_CLOSE: 'Prozess beenden',
    EP_PAGE_CREATION_DIALOG_TEXT:
      'Möchten Sie den Prozess wirklich beenden? Ihre Eingaben auf dieser Seite gehen dann verloren.',
    EP_PAGE_CREATION_DO_NOT_CLOSE: 'Abbrechen',
    EP_PAGE_CREATION_FORM_1_TITLE: 'Das Wichtigste zu Ihrem Unternehmen',
    EP_PAGE_CREATION_RESUME_OR_DELETE:
      'Schließen Sie bitte die Erstellung Ihres Arbeitgeberprofils ab und übermitteln Sie uns die Daten zur Prüfung. Wenn Sie von Neuem starten möchten, löschen Sie dieses Profil bitte.',
    EP_PAGE_CREATION_SAVE_NEXT: 'Speichern und weiter',
    EP_PAGE_CREATION_SEND_FOR_APPROVAL: 'Freigabe beantragen',
    EP_PAGE_INFO_HELP_BODY:
      'Im Hilfebereich finden Sie viele hilfreiche Tipps zum Einrichten Ihrer XING Seite.',
    EP_PAGE_INFO_HELP_CTA: 'Zum Hilfebereich',
    EP_PAGE_INFO_HELP_TITLE: 'Fragen?',
    EP_PAGE_INFO_MANAGE_BODY:
      'Im BrandManager können Sie Module hinzufügen, verbergen oder umsortieren.',
    EP_PAGE_INFO_MANAGE_CTA: 'BrandManager öffnen',
    EP_PAGE_INFO_MANAGE_TITLE: 'Module verwalten',
    EP_PAGE_INFO_PAGE_TYPE_FREE: 'Gratisprofil',
    EP_PAGE_INFO_PAGE_TYPE_LABEL: 'Seitentyp',
    EP_PAGE_INFO_PAGE_TYPE_PAID: 'Employer Branding Page',
    EP_PAGE_INFO_PAGE_TYPE_PAID_PLUS: 'Employer Branding Page Professional',
    EP_PAGE_INFO_ROLE_ADMINISTRATOR: 'Admin',
    EP_PAGE_INFO_ROLE_EDITOR: 'Editor',
    EP_PAGE_INFO_ROLE_LABEL: 'Ihre Rolle:',
    EP_PAGE_INFO_ROLE_OWNER: 'Eigentümer',
    EP_PAGE_INFO_TITLE: 'Infos zur Seite',
    EP_PAGE_OWNER: 'Seiten-Editor ',
    EP_PARAMS_INCORRECT_ERROR:
      'Bitte gib noch den Titel und die Beschreibung ein (jeweils mind. 4 Zeichen).',
    EP_PENDING_GROUP_JOIN_INFO: 'Zu bestätigen',
    EP_PROMOTE_PAGE: 'Seite bewerben',
    EP_PUBLISH_CTA: 'Speichern',
    EP_READ_LESS: 'Weniger anzeigen',
    EP_READ_MORE: 'Weiterlesen',
    EP_READ_MORE_CTA: 'Weiterlesen',
    EP_REPORT_NEWS_ITEM: 'Melden',
    EP_REPORT_PAGE: 'Seite melden',
    EP_REQUIRED_FIELD: 'Pflichtfeld',
    EP_RESTORE_CTA: 'Wiederherstellen',
    EP_RESULT_LIST_CONTACT:
      'War die richtige Ansprechperson nicht dabei? Wir helfen Ihnen gerne weiter:  <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>',
    EP_RESULT_LIST_CONTACT_V2:
      'War die richtige Ansprechperson nicht dabei? Wir helfen Ihnen gerne weiter:  <a>customer.support@xing.com</a>',
    EP_RESULT_LIST_HEADLINE: 'Ansprechperson auswählen',
    EP_ROLLOUT_BANNER_ADD_LEGAL_NOTICE: 'Ihr Impressum',
    EP_ROLLOUT_BANNER_CONFIRM_BUTTON: 'Zum neuen Design wechseln ',
    EP_ROLLOUT_BANNER_CONTACT_DETAILS: 'Kontaktdaten Ihres Unternehmens',
    EP_ROLLOUT_BANNER_CONTACT_DETAILS_DESCRIPTION:
      'Bitte geben Sie hier die Adresse sowie Telefonnummer Ihres Unternehmens an.',
    EP_ROLLOUT_BANNER_DESCRIPTION:
      'Ihr neues Arbeitgeberprofil steht in den Startlöchern.\nPrüfen Sie bitte zunächst die folgenden Angaben auf Vollständigkeit und ändern Sie diese, falls nötig:',
    EP_ROLLOUT_BANNER_LEGAL_ADVICE_DESCRIPTION:
      'Bitte geben Sie hier den Link zum Impressum Ihrer Unternehmens-Website an oder tragen Sie diese Information manuell ein.',
    EP_ROLLOUT_BANNER_MOBILE_INFO:
      'Öffnen Sie Ihr Arbeitgeberprofil bitte auf dem Desktop, bevor Sie zum neuen Design wechseln.',
    EP_ROLLOUT_BANNER_OLD_URL:
      'Besucher Ihres alten Arbeitgeberprofils werden zukünftig umgeleitet.',
    EP_ROLLOUT_BANNER_PROFILE_UPDATED:
      'Willkommen auf Ihrem neuen Arbeitgeberprofil!',
    EP_ROLLOUT_BANNER_PUBLISH_INFO:
      'Alles geprüft? Prima, dann können Sie zum neuen Design wechseln:',
    EP_ROLLOUT_BANNER_TEXT_EMAIL:
      'Haben Sie Fragen? Wir helfen Ihnen gerne weiter:\n<br/>\nE-Mail: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>\n<br/>\nTelefon: +49 40 419 131 778',
    EP_ROLLOUT_BANNER_TITLE: 'Sie haben es fast geschafft!',
    EP_ROLLOUT_BANNER_UPDATED_URL:
      'Der Link zu Ihrer XING Seite ist jetzt <strong>www.xing.com/pages/{slug}</strong>.',
    EP_ROLLOUT_BANNER_WEBINAR_LINK:
      'https://attendee.gotowebinar.com/rt/2071891534032487180',
    EP_ROLLOUT_PUBLISH_ERROR_ABOUT_US:
      'Bitte fügen Sie jetzt noch Ihre ausführliche Beschreibung für die Rubrik "Über uns" hinzu.',
    EP_ROLLOUT_PUBLISH_ERROR_LOCATION:
      'Bitte fügen Sie noch die Kontaktdaten Ihres Unternehmens hinzu.',
    EP_ROLLOUT_WEBINAR_TEXT_1:
      'Lust auf einen Rundgang durch Ihre neue XING Seite? Oder haben Sie bestimmte Fragen? Dann registrieren Sie sich gern für eines unserer',
    EP_ROLLOUT_WEBINAR_TEXT_2: 'Registrieren Sie sich für eines unserer',
    EP_ROLLOUT_WEBINAR_TEXT_LINK: 'Live-Webinare',
    EP_SEE_ALL_AWARDS: 'Alle Auszeichnungen',
    EP_SELECT_NONE: 'Nichts davon',
    EP_SHARE_PAGE: 'Seite teilen',
    EP_SHOW_ALL_RESULTS: 'Alle Ergebnisse',
    EP_SHOW_MORE_RESULTS: 'Weitere Ergebnisse ',
    EP_SIMILAR_JOBS_HEADLINE: 'Ähnliche Jobs',
    EP_SLOGAN_EDIT_HEADLINE: 'Slogan bearbeiten',
    EP_SLOGAN_EDIT_HEADLINE_INFO:
      'Füg hier Euren Slogan hinzu – oder die Essenz Eurer Seite in wenigen Worten.',
    EP_SLOGAN_EDIT_HINT:
      'Hier steht der Slogan Ihrer Seite, z. B. Ihr Firmenslogan.',
    EP_SLOGAN_EDIT_LABEL: 'Slogan der Seite',
    EP_SUBPAGE_BACK: 'Zur Übersicht',
    EP_TELEPHONE: 'Telefon',
    EP_TITLE_EDIT_HINT: 'Als Seitentitel eignet sich oft der Firmen-Name.',
    EP_TITLE_EDIT_LABEL: 'Titel der Seite',
    EP_UNFOLLOW: 'Nicht mehr folgen',
    EP_UPDATES_EDIT_EMPTY_STATE_DESCRIPTION:
      'Mit jedem neuen Beitrag machst Du XING Mitglieder auf Deine Seite aufmerksam.',
    EP_UPDATES_EDIT_EMPTY_STATE_HEADLINE:
      'Füg hier Deinen ersten Artikel hinzu.',
    EP_UPDATES_PUBLIC_EMPTY_STATE_DESCRIPTION:
      'Folge der Seite einfach, um keine Neuigkeiten mehr zu verpassen.\t',
    EP_UPDATES_PUBLIC_EMPTY_STATE_HEADLINE:
      'Sobald es Neuigkeiten gibt, siehst Du sie hier.',
    EP_UPLOAD_COVER: 'Titelbild auswählen',
    EP_UPLOAD_COVER_LABEL:
      'Wählen Sie ein eindrucksvolles Hintergrundbild für Ihre XING Seite.',
    EP_UPLOAD_DOCUMENT: 'PDF hinzufügen',
    EP_UPLOAD_IMAGE_DRAG_LABEL: 'Logo-Datei hier ablegen',
    EP_UPLOAD_IMAGE_HINT: 'JPG, BMP oder PNG (max. 5 MB) im Format 16:9',
    EP_UPLOAD_IMAGE_LABEL: 'Datei hierher ziehen oder auswählen',
    EP_UPLOAD_LOGO: 'Neues Logo hinzufügen',
    EP_UPLOAD_LOGO_DRAG_LABEL: 'Sie können Ihr Logo hier ablegen.',
    EP_UPLOAD_LOGO_EDIT_INFO:
      'Tipps für ein perfektes Logo auf Deiner XING Seite gefällig?',
    EP_UPLOAD_LOGO_EDIT_INFO_CTA: 'Tipps lesen',
    EP_UPLOAD_LOGO_HINT: 'JPG, BMP oder PNG (max. 5 MB), Format: Quadrat',
    EP_UPLOAD_LOGO_LABEL: 'Datei hierher ziehen oder auswählen',
    EP_UPSELL_BANNER_CONTAINER_DISCARD_BUTTON: 'Verwerfen',
    EP_UPSELL_BANNER_CONTAINER_PUBLISH_BUTTON: 'Weiter',
    EP_UPSELL_BODY_TOP_HEADER:
      'Begrüßen Sie Besucher·innen Ihres Arbeitgeberprofils mit Ihrem eigenen Titelbild und Slogan. Dadurch steigern Sie Ihren Wiedererkennungswert als Marke und erreichen Ihre Zielgruppe zuverlässig mit Ihrer Botschaft.\n \nZeigen Sie allen, wofür Ihr Unternehmen steht!',
    EP_UPSELL_COMPANY_RECOMMENDED_BODY:
      'Schließen Sie mit dem Upgrade alle Empfehlungen für fremde Unternehmen auf Ihrem eigenen Arbeitgeberprofil aus. So liegt der Fokus allein auf Ihnen.',
    EP_UPSELL_COMPANY_RECOMMENDED_HEADER: 'Weniger ist mehr!',
    EP_UPSELL_CONTACT_BODY:
      'Fügen Sie auf Ihrem Arbeitgeberprofil mehrere Ansprechpersonen hinzu, damit Ihre Besucher·innen immer den richtigen Kontakt für Ihre Anfragen finden.',
    EP_UPSELL_CONTACT_HEADER: 'Immer die richtige Ansprechperson',
    EP_UPSELL_DOCUMENTS:
      'Stellen Sie nützliche Dokumente wie offizielle Firmenpräsentationen, Tipps, Handbücher und ähnliches zur Verfügung und nutzen Sie Ihr Arbeitgeberprofil als zentralen Ort für relevante Informationen für Ihre Besucher.',
    EP_UPSELL_DOCUMENTS_HEADER: 'Alle relevanten Infos an einem zentralen Ort',
    EP_UPSELL_DOCUMENTS_HEADLINE: 'Dokumente hinzufügen',
    EP_UPSELL_EMPLOYER_FLAG_BUTTON: 'Employer Branding Profil',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY:
      'Diesen und mehr Vorteile gibt’s beim Employer Branding Profil. <br / >\nMit Klick auf den Stift <strong>Bild wählen</strong> und in die <strong>richtige Position</strong> rücken. Mit einem Upgrade kannst Du’s veröffentlichen.',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY_WITH_IMAGE:
      'Aktuell ist es aber nur für Dich sichtbar – eigentlich schade, oder? <br />\nSicher Dir das Upgrade, damit auch andere es sehen können.',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BUTTON: 'Upgrade',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER: 'Hier ist Platz für ein Titelbild!',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER_WITH_IMAGE:
      'Dein Titelbild sieht gut aus!',
    EP_UPSELL_GALLERY_ABOUT_US:
      'Gestalten Sie Ihr Arbeitgeberprofil interessant und einzigartig. Nutzen Sie Ihre ganz persönlichen Gestaltungsmöglichkeiten durch Bilder und Videos aus Ihrem Unternehmen, von Ihrem Team oder Ihrem Produkt.',
    EP_UPSELL_GALLERY_ABOUT_US_HEADER: 'Überzeugen Sie auf allen Wegen.',
    EP_UPSELL_GALLERY_BUTTON: 'Vorteile entdecken',
    EP_UPSELL_HEADER_TOP_HEADER: 'Mit Titelbild & Slogan neue Talente gewinnen',
    EP_UPSELL_PROFILE_MULTIMEDIA_BODY:
      'Gestalten Sie Ihr Arbeitgeberprofil interessant und einzigartig. Nutzen Sie Ihre ganz persönlichen Gestaltungsmöglichkeiten: durch Bilder und Videos aus Ihrem Unternehmen, von Ihrem Team oder Ihrem Produkt.',
    EP_UPSELL_PROFILE_MULTIMEDIA_HEADER: 'Eigene Videos und Bilder',
    EP_VISIT_WEBSITE: 'Website',
    EP_VISIT_WEBSITE_EMPTY_STATE: 'Webseite',
    EP_WHO_TO_CONTACT: 'Unsere Ansprechpersonen',
    EP_YOUR_TOPICS_EDIT_VIEW_CANCEL: 'Abbrechen',
    EP_YOUR_TOPICS_EDIT_VIEW_COPY:
      'Um von Deinen Leser·innen besser gefunden zu werden, gib hier bitte die Themenbereiche an, über die Du schreibst. Du kannst bis zu vier Kategorien wählen oder erstellen.',
    EP_YOUR_TOPICS_EDIT_VIEW_LABEL: 'Thema hinzufügen',
    EP_YOUR_TOPICS_EDIT_VIEW_SAVE: 'Speichern',
    EP_YOUR_TOPICS_EDIT_VIEW_TITLE: 'Deine Themenbereiche',
    'EP-ARTICLES-MODULE-EMPTY-STATE-EDIT-TEXT':
      'Nutz den XING Editor, um einen neuen Artikel zu schreiben. Du kannst auch einen externen Artikel von Dir via Link teilen.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-EDIT-TITLE':
      'Zeit für Deinen ersten Artikel',
    'EP-ARTICLES-MODULE-EMPTY-STATE-PINNED-TEXT':
      'Du kannst einen Deiner Artikel an den Anfang Deiner Sammlung pinnen. Das geht mit dem Stern-Button.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-PINNED-TITLE':
      'Setz Deinen besten Artikel in Szene',
    'EP-ARTICLES-MODULE-EMPTY-STATE-TEXT':
      'Du kannst der Seite folgen. Dann benachrichtigen wir Dich, falls es etwas Neues gibt.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-TITLE':
      'Bis jetzt wurden hier keine Artikel veröffentlicht.',
    'EP-ARTICLES-MODULE-FILTER-ALL': 'Alle Artikel',
    'EP-ARTICLES-MODULE-FILTER-DRAFTS': 'Entwurf',
    'EP-ARTICLES-MODULE-FILTER-HIDDEN': 'Ausgeblendet',
    'EP-ARTICLES-MODULE-FILTER-PUBLISHED': 'Veröffentlicht',
    'EP-ARTICLES-MODULE-FILTER-SCHEDULED': 'Geplant',
    'EP-ARTICLES-MODULE-MOBILE-HINT-TEXT':
      'Auf mobilen Geräten funktioniert der Editor leider nicht.',
    'EP-ARTICLES-MODULE-MOBILE-HINT-TITLE': 'Bitte benutze einen Computer',
    'EP-ARTICLES-MODULE-SHARE-NEW-ARTICLE-BUTTON': 'Externen Artikel teilen',
    'EP-ARTICLES-MODULE-SHOW-MORE-ARTICLES-BUTTON': 'Mehr Artikel anzeigen',
    'EP-ARTICLES-MODULE-WRITE-NEW-ARTICLE-BUTTON': 'Artikel schreiben',
    ERROR_DUPLICATE_SERVICE:
      'Du kannst nur ein Benutzerkonto pro Anbieter angeben.',
    ERROR_ENDDATE_INVALID: 'Bitte wähle ein korrektes Enddatum aus.',
    ERROR_INDUSTRY: 'Bitte wähle eine Branche aus.',
    ERROR_INVALID_COMPANY: 'Bitte wähle eine Firma aus.',
    ERROR_INVALID_SCHOOL: 'Bitte wähle eine Hochschule aus.',
    ERROR_INVALID_SERVICE: 'Bitte wähle einen Anbieter aus.',
    ERROR_INVALID_STATUS: 'Bitte wähle Deinen Status aus.',
    ERROR_SOMETHING_WENT_WRONG:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    ERROR_STATUS_CHANGE_COMPANY_MISS:
      'Um Deinen Status zu ändern, gib bitte mindestens eine Tätigkeit an.',
    ERROR_STATUS_CHANGE_SCHOOL_MISS:
      'Um Deinen Status zu ändern, gib bitte mindestens eine Hochschule und eine Fachrichtung an.',
    ERROR_STATUS_CHANGE_SUBJECT_MISS:
      'Um Deinen Status zu ändern, gib bitte eine Fachrichtung zu Deiner Hochschule an.',
    ERROR_WIDGET_SAVE: 'Fehler beim Speichern',
    ERROR_WIDGET_SAVE_MSG:
      'Deine Änderungen konnten nicht übernommen werden, da die Daten sich inzwischen geändert haben. Bitte bestätige mit "{\'BUTTON_OK}" und bearbeite die Daten erneut.',
    EXECUTIVES_CV_COMPETENCES_HEADER: 'Führungsverantwortung',
    FAX: 'Fax',
    FEEDY_CARD_VERB_CONTENT_PAGE_ARTICLE_POST:
      'hat einen Artikel veröffentlicht',
    FEEDY_CARD_VERB_IMAGE_POST: 'hat dieses Bild geteilt',
    FEEDY_CARD_VERB_LINK_POST: 'hat diesen Link geteilt',
    FEEDY_CARD_VERB_STATUS_POST: 'hat einen Beitrag geschrieben',
    FOOTER_LANGUAGES: 'Sprache',
    FRAME_HEADER_SEARCH: 'Suche',
    FRAME_HEADER_UPSELL_PREMIUM: 'Premium werden',
    FRAME_HEADER_UPSELL_PROJOBS: 'ProJobs entdecken',
    FRAME_NAVIGATION_DISCO: 'Entdecken',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE:
      ' Was denkst Du über die neue App?',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE: 'Dein Feedback',
    FRAME_NAVIGATION_JOBS: 'Jobs',
    FRAME_NAVIGATION_ME_HUB: 'Deins',
    FRAME_NAVIGATION_NETWORKING_ICON_TEXT: 'Netzwerken',
    FRAME_NAVIGATION_PROJOBS_UPSELL: 'ProJobs werden',
    FRAME_NAVIGATION_SUPI: 'Start',
    FRAME_NAVIGATION_UPSELL_HEADLINE: 'Angebote für Dich',
    FRAME_NAVIGATION_YOUR_PREMIUM: 'Dein Premium',
    FRAME_NAVIGATION_YOUR_PROJOBS: 'Dein ProJobs',
    FROM: 'Von',
    GIVE_WORK_DETAILS_HINT:
      'Mach auf Dich aufmerksam und trage nähere Angaben zu Deiner aktuellen Firma und Deinem Aufgabengebiet ein.',
    GOOGLE_TRANSLATION_BUTTON: 'Übersetzen',
    GOOGLE_TRANSLATION_ERROR: 'Text konnte nicht übersetzt werden.',
    GOOGLE_TRANSLATION_ERROR_NO_TEXT: 'Kein Text zum Übersetzen vorhanden',
    GOOGLE_TRANSLATION_LABEL: 'powered by Google',
    GOOGLE_TRANSLATION_SELECT_FROM: 'Sprachkombination wählen:',
    GOOGLE_TRANSLATION_SELECT_TO: 'in',
    GROUP_NEWSLETTER: 'Gruppen-Newsletter',
    GROUP_VISIBILITY: 'Sichtbarkeit von Gruppen',
    HEADER_SKIP_NAVIGATION: 'Navigation überspringen',
    IM: 'Chat-Dienste',
    IM_PROFILES_EMPTY:
      'Gib hier Deine Benutzernamen für den Chat-Dienst (z. B. Skype oder MSN) an. Du kannst später jeweils einzeln entscheiden, welche Kontakte diese Angaben sehen dürfen.',
    IM_PROFILES_SERVICE: 'Anbieter',
    IM_PROFILES_USERNAME: 'Benutzername',
    INDIVIDUAL_GROUP_VISIBILITY: 'Sichtbarkeit von neuen Gruppen',
    INDUSTRY: 'Branche',
    INDUSTRY_10000: 'Architektur, Bauwesen',
    INDUSTRY_100000: 'Telekommunikation',
    INDUSTRY_10100: 'Bauingenieurwesen',
    INDUSTRY_10200: 'Baugewerbe',
    INDUSTRY_10300: 'Baustoffe',
    INDUSTRY_10400: 'Architektur',
    INDUSTRY_10500: 'Garten- und Landschaftsbau',
    INDUSTRY_110000: 'Medien, Verlage',
    INDUSTRY_110100: 'Informationsdienste',
    INDUSTRY_110200: 'Rundfunk, Fernsehen',
    INDUSTRY_110300: 'Verlagswesen',
    INDUSTRY_110400: 'Film, Musik',
    INDUSTRY_110500: 'Journalismus',
    INDUSTRY_110600: 'Übersetzen, Dolmetschen',
    INDUSTRY_110700: 'Text, Lektorat',
    INDUSTRY_120000: 'Banken, Finanzdienstleistungen',
    INDUSTRY_120100: 'Finanzdienstleistungen',
    INDUSTRY_120200: 'Bankwesen',
    INDUSTRY_120300: 'Investmentbanken',
    INDUSTRY_120400: 'Risikokapital, Private Equity',
    INDUSTRY_130000: 'Versicherungen',
    INDUSTRY_140000: 'Immobilien',
    INDUSTRY_140100: 'Facility Management',
    INDUSTRY_140200: 'Immobilienverwaltung',
    INDUSTRY_140300: 'Immobilienvermittlung',
    INDUSTRY_150000: 'Wirtschaftsprüfung, Steuern, Recht',
    INDUSTRY_150100: 'Rechtsberatung',
    INDUSTRY_150200: 'Wirtschaftsprüfung',
    INDUSTRY_150300: 'Steuerberatung',
    INDUSTRY_160000: 'Beratung, Consulting',
    INDUSTRY_170000: 'Marketing, PR und Design',
    INDUSTRY_170100: 'Marketing, Werbung',
    INDUSTRY_170200: 'Markt- und Meinungsforschung',
    INDUSTRY_170300: 'Design, Grafik',
    INDUSTRY_170400: 'Messe, Ausstellungen, Kongresse',
    INDUSTRY_170500: 'PR',
    INDUSTRY_180000: 'Personaldienstleistungen',
    INDUSTRY_180100: 'Personaldienstleistungen und -beratung',
    INDUSTRY_180200: 'Outsourcing, Offshoring',
    INDUSTRY_190000: 'Öffentlicher Dienst, Verbände und Einrichtungen',
    INDUSTRY_190100: 'Gemeinnützige Einrichtungen und Vereine',
    INDUSTRY_190200: 'Religiöse Einrichtungen',
    INDUSTRY_190300: 'Öffentliche Verwaltung',
    INDUSTRY_190400: 'Politik, Verbände',
    INDUSTRY_190500: 'Verteidigung, Justiz, Polizei',
    INDUSTRY_190600: 'Internationale Angelegenheiten',
    INDUSTRY_20000: 'Konsumgüter, Handel',
    INDUSTRY_200000: 'Erziehung, Bildung, Wissenschaft',
    INDUSTRY_200100: 'Forschung',
    INDUSTRY_200200: 'Schulen, Kindergärten',
    INDUSTRY_200300: 'Fach- und Hochschulen',
    INDUSTRY_200400: 'Kinderbetreuung',
    INDUSTRY_200500: 'Coaching, Fortbildung',
    INDUSTRY_200600: 'E-Learning',
    INDUSTRY_20100: 'Lebensmittel',
    INDUSTRY_20200: 'Getränke',
    INDUSTRY_20300: 'Tabakwaren',
    INDUSTRY_20400: 'Mode, Textilien',
    INDUSTRY_20500: 'Schmuck, Luxusgüter',
    INDUSTRY_20600: 'Möbel, Holzwaren',
    INDUSTRY_20700: 'Papierwaren',
    INDUSTRY_20800: 'Kosmetik, Körperpflege',
    INDUSTRY_20900: 'Glas, Keramik',
    INDUSTRY_21000: 'Import, Export',
    INDUSTRY_210000: 'Gesundheit, Soziales',
    INDUSTRY_210100: 'Krankenhäuser',
    INDUSTRY_210200: 'Tiermedizin',
    INDUSTRY_210300: 'Arztpraxen',
    INDUSTRY_210400: 'Alternative Medizin',
    INDUSTRY_210500: 'Psychologie, Psychotherapie',
    INDUSTRY_210600: 'Medizinische Dienste',
    INDUSTRY_210700: 'Pflegeberufe',
    INDUSTRY_210800: 'Sozialwesen',
    INDUSTRY_21100: 'Großhandel',
    INDUSTRY_21200: 'Einzelhandel',
    INDUSTRY_220000: 'Kunst, Kultur, Sport',
    INDUSTRY_220100: 'Darstellende Kunst',
    INDUSTRY_220200: 'Fotografie',
    INDUSTRY_220300: 'Musik',
    INDUSTRY_220400: 'Kunst, Kunsthandwerk',
    INDUSTRY_220500: 'Museen, Kultureinrichtungen',
    INDUSTRY_220600: 'Bibliotheken',
    INDUSTRY_220700: 'Fitness-Studios, Sportvereine und -anlagen',
    INDUSTRY_220800: 'Sporttreibende, Veranstalter, Verbände',
    INDUSTRY_230000: 'Sonstige Branchen',
    INDUSTRY_230100: 'Spiel-, Wett- und Lotteriewesen',
    INDUSTRY_230200: 'Landwirtschaft',
    INDUSTRY_230300: 'Forstwirtschaft, Jagd',
    INDUSTRY_230400: 'Fischerei',
    INDUSTRY_230500: 'Sonstige Dienstleistungen',
    INDUSTRY_230600: 'Bergbau, Metalle',
    INDUSTRY_230700: 'Geologie',
    INDUSTRY_230800: 'Sicherheit, Ermittlungen',
    INDUSTRY_30000: 'Automobil- und Fahrzeugbau',
    INDUSTRY_30100: 'Automobile und Zweiräder',
    INDUSTRY_30200: 'Schiffbau',
    INDUSTRY_30300: 'Schienenfahrzeugbau',
    INDUSTRY_30400: 'Verkehrstechnik',
    INDUSTRY_30500: 'Luft- und Raumfahrzeugbau',
    INDUSTRY_30600: 'Fahrzeugvermietung',
    INDUSTRY_40000: 'Industrie und Maschinenbau',
    INDUSTRY_40100: 'Mess-, Steuer- und Regelungstechnik',
    INDUSTRY_40200: 'Halbleiter, elektronische Bauteile',
    INDUSTRY_40300: 'Druckwesen',
    INDUSTRY_40400: 'Verbundwerkstoffe',
    INDUSTRY_40500: 'Chemie',
    INDUSTRY_40600: 'Mineralöl-Verarbeitung',
    INDUSTRY_40700: 'Metallindustrie und -verarbeitung',
    INDUSTRY_40800: 'Bio- und Nanotechnologie',
    INDUSTRY_40900: 'Kunststoff- und Gummiwaren',
    INDUSTRY_41000: 'Rüstung',
    INDUSTRY_41100: 'Maschinenbau, Betriebstechnik',
    INDUSTRY_41200: 'Elektrotechnik',
    INDUSTRY_41300: 'Optische und fotografische Geräte',
    INDUSTRY_50000: 'Pharma, Medizintechnik',
    INDUSTRY_50100: 'Medizintechnik',
    INDUSTRY_50200: 'Pharmazeutische Produkte, Arzneimittel',
    INDUSTRY_60000: 'Energie, Wasser, Umwelt',
    INDUSTRY_60100: 'Erneuerbare Energien',
    INDUSTRY_60200: 'Energiewirtschaft',
    INDUSTRY_60300: 'Wasserversorgung und -entsorgung',
    INDUSTRY_60400: 'Abfälle, Recycling',
    INDUSTRY_60500: 'Umweltschutz',
    INDUSTRY_70000: 'Transport, Logistik',
    INDUSTRY_70100: 'Personenverkehr',
    INDUSTRY_70200: 'Bahnverkehr',
    INDUSTRY_70300: 'Schifffahrt',
    INDUSTRY_70400: 'Luftverkehr',
    INDUSTRY_70500: 'Lagerhaltung',
    INDUSTRY_70600: 'Post, Spedition',
    INDUSTRY_80000: 'Tourismus, Gastronomie',
    INDUSTRY_80100: 'Hotelgewerbe',
    INDUSTRY_80200: 'Gastronomie',
    INDUSTRY_80300: 'Reisebüros und -veranstalter',
    INDUSTRY_80400: 'Freizeiteinrichtungen',
    INDUSTRY_90000: 'Internet, IT',
    INDUSTRY_90100: 'Computer-Software',
    INDUSTRY_90200: 'IT-Dienstleister',
    INDUSTRY_90300: 'IT-Sicherheit',
    INDUSTRY_90400: 'Computernetzwerke',
    INDUSTRY_90500: 'Computer-Hardware',
    INDUSTRY_90600: 'Unterhaltungselektronik',
    INDUSTRY_90700: 'Internet, Onlinemedien',
    INDUSTRY_90800: 'Computerspiele',
    INSIDER_DESCRIPTION_INTRO: 'Schreibt über',
    INSIDER_FOLLOWED_BY: 'Abonniert von',
    INSIDER_FOLLOWED_BY_AND: 'und',
    INSIDER_FOLLOWED_BY_AND_MORE: 'weiteren',
    INVISIBLE_ON_PROFILE: 'sichtbar für Recruiter',
    INVISIBLE_TO_OTHERS: 'nicht sichtbar für andere',
    JOB_SEARCH_ALERTS_ALERT_NAME_ALL: 'Alle Jobs',
    JOBS_JOB_TEASER_SAVE: 'Job merken',
    JOBS_JOB_TEASER_SAVED: 'Gemerkt',
    JS_REALLY_DONT_REMIND: 'Wirklich nicht mehr erinnern?',
    LANG_NOT_AVAIL: 'Deine Sprache steht nicht zur Auswahl?',
    LANG_PREFS: 'Spracheinstellungen',
    LANGUAGE: 'Sprache',
    LANGUAGE_SKILL_LEVEL_0: '- Sprachkenntnisse -',
    LANGUAGE_SKILL_LEVEL_1: 'Grundkenntnisse',
    LANGUAGE_SKILL_LEVEL_2: 'Gut',
    LANGUAGE_SKILL_LEVEL_3: 'Fließend',
    LANGUAGE_SKILL_LEVEL_4: 'Muttersprache',
    LANGUAGE_SKILLS_NOT_AVAILABLE: 'Deine Sprache steht nicht zur Auswahl?',
    LANGUAGE_SKILLS_SELECT_LANGUAGE: '- Sprache -',
    LANGUAGES: 'Sprachen',
    LEVEL: 'Karriere-Stufe',
    LIKE_BUTTON_LABEL: 'Gefällt mir',
    LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    LOGGEDOUT_ABOUT_ME: '{-display_name} über sich',
    LOGGEDOUT_EDUCATION: 'Ausbildung von {-display_name}',
    LOGGEDOUT_PERSONAL: 'Persönliches über {-display_name}',
    LOGGEDOUT_WORK_EXPERIENCE: 'Berufserfahrung von {-display_name}',
    MAIL_EMAIL_LOGINABLE_SUBJECT:
      '{EMAIL_SUBJ}: Wichtig - Deine Zugangsdaten bei XING',
    MAIL_NOT_CONFIRMED:
      'Die E-Mail-Adresse konnte nicht bestätigt werden, da Du Deine E-Mail-Daten inzwischen geändert hast. Bitte versuche es erneut.',
    MAIL_WAS_CONFIRMED: 'Die E-Mail-Adresse wurde bestätigt.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE:
      'Die Datei "{filesTooBig}" ist leider zu groß: Bis zu {maxSize} MB sind erlaubt.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL:
      'Du kannst Dateien von bis zu {maxSize} MB hochladen. Diese Dateien sind daher leider zu groß: {filesTooBig}',
    MALT_FILE_UPLOAD_NO_FILE: 'Noch keine Datei ausgewählt',
    MALT_FILE_UPLOAD_NUMBER_OF_FILES: '{numberOfFiles} Dateien',
    MALT_FOOTER_COPYRIGHT_API: '© {siteoperator} | Alle Rechte vorbehalten',
    MALT_IMAGE_UPLOAD_BROWSE_BUTTON: 'Datei auswählen',
    MALT_TEST_RUBY_STYLE_TRANSLATION: 'Mein Name ist {name}.',
    MEMBERSHIP_MOTIVATION: 'Warum ich auf {-SITENAME} bin',
    MEMENU_FOLLOWING_LABEL: 'Folgst Du',
    MEMENU_HELP_LABEL: 'Hilfe',
    MEMENU_JOB_ADS_LABEL: 'Stellenanzeigen verwalten',
    MEMENU_JOB_PREFERENCES_LABEL: 'Job-Wünsche',
    MEMENU_MY_POSTS_LABEL: 'Deine Beiträge',
    MEMENU_PREMIUM_FOR_BASIC_USER_LABEL: 'Premium werden',
    MEMENU_PREMIUM_LABEL: 'Premium',
    MEMENU_PROBUSINESS_LABEL: 'ProBusiness',
    MEMENU_PROFILE_LABEL: 'Profil',
    MEMENU_PROJOBS_FOR_BASIC_USER_LABEL: 'ProJobs werden',
    MEMENU_PROJOBS_LABEL: 'ProJobs',
    MEMENU_SETTINGS_LABEL: 'Einstellungen',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Empfänger:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Empfänger eingeben',
    MESSENGER_SHARE_TARGET_LABEL: 'Deine Nachricht:',
    MONTH_NAMES:
      'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    MONTH_NAMES_SHORT: 'Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
    MORE_PROFILES: 'Weitere Profile von mir im Web',
    MOTIVATIONS_EMPTY:
      'Teile Mitgliedern mit, wie Du XING nutzen möchtest - so optimierst Du Dein Networking.',
    MP_000_RESOURCE_USER_ROLES_EMPLOYEE: 'Mitarbeitende des Unternehmens',
    MP_000_RESOURCE_USER_ROLES_EXECUTIVE: 'Geschäftsführer',
    MP_000_RESOURCE_USER_ROLES_EXTERNAL_RECRUITER: 'Personalvermittler',
    MP_000_RESOURCE_USER_ROLES_HR_CONSULTANT: 'Personalberater',
    MP_000_RESOURCE_USER_ROLES_HR_DEPARTMENT: 'Personalabteilung',
    MP_000_RESOURCE_USER_ROLES_MANAGER: 'Direkter Vorgesetzter',
    MP_000_RESOURCE_USER_ROLES_RECRUITER_CONSULTANT: 'Personalberater',
    MP_700_INFOBOX_EDIT_PROFILE_LINK: 'Profil bearbeiten',
    MY_NOTIFICATION_PREFS: 'Benachrichtigungs-Einstellungen',
    MY_NOTIFICATIONS: 'Benachrichtigungen',
    MY_PERSONAL_INFO: 'Meine persönlichen Daten',
    MY_PRIVACY_SETTINGS: 'Deine Privatsphäre',
    MY_PROFILE_SETTINGS: 'Meine Profileinstellungen',
    MY_SETTINGS: 'Einstellungen',
    MY_USERNAME_PASSWORD: 'Meine Zugangsdaten',
    MYXING_LOADING_ALERT_MESSAGE:
      'Das hat leider nicht geklappt. Bitte aktualisiere diese Seite noch einmal.',
    NBA_BUTTON_CANCEL: 'Abbrechen',
    NBA_BUTTON_CHANGE_IMAGE: 'Bild ändern',
    NBA_BUTTON_CONTINUE: 'Weiter',
    NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT:
      'Ein gutes Profilbild unterstreicht Dein professionelles Auftreten und erhöht die Anzahl Deiner Profilbesuche.',
    NBA_CREATE_PHOTO_CARD_GENERIC_ERROR:
      "Das hat leider nicht geklappt – kannst Du's nochmal versuchen?",
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE:
      'Bitte wähl eines dieser Bildformate: JPG, PNG oder BMP',
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE:
      'Bitte wähl ein Bild mit weniger als 20 MB Dateigröße.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX: 'Max.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN: 'Min.',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE: 'Profilbild',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES:
      'Empfohlene Auflösung: 1024 x 1024 px',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES:
      'JPG, BMP, PNG (max. 20 MB)',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK: 'Bild hochladen',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP:
      'Bild hierhin ziehen',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR: 'oder',
    NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT:
      'Du kannst dieses Bild jederzeit in Deiner Visitenkarte ändern.',
    NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE:
      'Prima, Du hast nun ein neues Profilbild!',
    NEW_JOB: 'Weiterer Beruf',
    NEW_SCHOOL: 'Weitere Hochschule',
    NEWLETTER_AND_MAIL_TIPS:
      'XING Newsletter, E-Mail-Tipps und Angebote per Post',
    NEWS_MODULE_DELETE_LABEL: 'Löschen',
    NEWS_MODULE_DIALOG_DELETE_HEADLINE: 'Artikel löschen?',
    NEWS_MODULE_DIALOG_DELETE_NO: 'Nein',
    NEWS_MODULE_DIALOG_DELETE_TEXT:
      'Soll dieser Artikel wirklich für immer gelöscht werden?',
    NEWS_MODULE_DIALOG_DELETE_YES: 'Ja, löschen',
    NEWS_MODULE_DIALOG_HIDE_HEADLINE: 'Artikel ausblenden?',
    NEWS_MODULE_DIALOG_HIDE_NO: 'Nein',
    NEWS_MODULE_DIALOG_HIDE_TEXT: 'Er ist dann auf XING nicht mehr auffindbar.',
    NEWS_MODULE_DIALOG_HIDE_YES: 'Ja, ausblenden',
    NEWS_MODULE_DIALOG_PIN_HEADLINE: 'Top-Artikel anheften?',
    NEWS_MODULE_DIALOG_PIN_NO: 'Nein',
    NEWS_MODULE_DIALOG_PIN_TEXT:
      'Soll dieser Artikel immer an oberster Postion erscheinen?',
    NEWS_MODULE_DIALOG_PIN_YES: 'Ja, ab nach oben ',
    NEWS_MODULE_DIALOG_UNPIN_HEADLINE: 'Nicht mehr anheften?',
    NEWS_MODULE_DIALOG_UNPIN_NO: 'Oben belassen',
    NEWS_MODULE_DIALOG_UNPIN_TEXT:
      'Möchten Sie diesen Artikel von der obersten Position entfernen?',
    NEWS_MODULE_DIALOG_UNPIN_YES: 'Ja, entfernen',
    NEWS_MODULE_DRAFT_LABEL: 'Entwurf',
    NEWS_MODULE_DRAFT_TAB: 'Entwürfe',
    NEWS_MODULE_EDIT_ALL: 'Alle Neuigkeiten bearbeiten',
    NEWS_MODULE_EDIT_LABEL: 'Bearbeiten',
    NEWS_MODULE_EMPTY_STATE_DESCRIPTION:
      'Du kannst der Seite einfach folgen, um keine zukünftigen Updates zu verpassen.\t',
    NEWS_MODULE_EMPTY_STATE_TITLE:
      'Hier findest Du Deine wichtigsten Neuigkeiten.',
    NEWS_MODULE_EMPTYSTATE_DESCRIPTION:
      'Mit jedem neuen Beitrag machen Sie XING Mitglieder auf Ihre Seite aufmerksam.',
    NEWS_MODULE_EMPTYSTATE_TITLE: 'Fügen Sie hier Ihren ersten Artikel hinzu.',
    NEWS_MODULE_HIDDEN_LABEL: 'Ausgeblendet',
    NEWS_MODULE_HIDDEN_TAB: 'Ausgeblendet',
    NEWS_MODULE_HIDE_BUTTON: 'Ausblenden',
    NEWS_MODULE_PIN_BUTTON: 'Anheften',
    NEWS_MODULE_PINNED_LABEL: 'Angeheftet',
    NEWS_MODULE_PROMOTE_BUTTON: 'Bewerben',
    NEWS_MODULE_PROMOTE_LABEL: 'Gesponsert',
    NEWS_MODULE_PUBLISH_FIRST_ARTICLE_BODY:
      'Dieses Modul wird dann für Seitenbesucher sichtbar.',
    NEWS_MODULE_PUBLISH_FIRST_ARTICLE_TITLE:
      'Veröffentlichen Sie jetzt Ihren ersten Artikel.',
    NEWS_MODULE_PUBLISHED_STORY_LABEL: 'Veröffentlicht',
    NEWS_MODULE_PUBLISHED_TAB: 'Veröffentlicht',
    NEWS_MODULE_SCHEDULE_LABEL: 'Geplant',
    NEWS_MODULE_SCHEDULED_TAB: 'Terminiert',
    NEWS_MODULE_SHOW_BUTTON: 'Einblenden',
    NEWS_MODULE_SHOW_STATISTICS: 'Statistiken ansehen',
    NEWS_MODULE_TOP_AREA_CTA: 'Einen Artikel auswählen',
    NEWS_MODULE_TOP_AREA_HEADLINE:
      'Sie haben noch keinen Top-Artikel ausgewählt.',
    NEWS_MODULE_TOP_AREA_SUB:
      'Per Klick auf das Sternsymbol können Sie einen Artikel aus Ihrer Sammlung hier prominent hervorheben.',
    NEWS_MODULE_TOP_LABEL: 'Top-Artikel',
    NEWS_MODULE_UNPIN_BUTTON: 'Nicht mehr anheften',
    NEWS_MODULE_UNPIN_LABEL: 'Nicht mehr anheften',
    NEWSFEED_PROFILE_PREVIEW_AWARDS: 'Auszeichnungen',
    NEWSFEED_PROFILE_PREVIEW_AWARDS_MORE:
      '{?IF:awards_sg}\n{.awards_more_entries} weitere Auszeichnung\n{?ELSE:awards_sg}\n{.awards_more_entries} weitere Auszeichnungen\n{?END:awards_sg}',
    NEWSFEED_PROFILE_PREVIEW_BUSINESS: 'Geschäftlich',
    NEWSFEED_PROFILE_PREVIEW_DOCUMENTS: 'Dateianhänge',
    NEWSFEED_PROFILE_PREVIEW_DOCUMENTS_MORE:
      '{?IF:certificates_sg}\n{.certificates_more_entries} weiterer Dateianhang\n{?ELSE:certificates_sg} \n{.certificates_more_entries} weitere Dateianhänge\n{?END:certificates_sg}',
    NEWSFEED_PROFILE_PREVIEW_HAVES: 'Fähigkeiten & Kenntnisse',
    NEWSFEED_PROFILE_PREVIEW_INTERESTS: 'Interessen',
    NEWSFEED_PROFILE_PREVIEW_MOBILE: 'Handy',
    NEWSFEED_PROFILE_PREVIEW_ORGANISATIONS: 'Organisationen',
    NEWSFEED_PROFILE_PREVIEW_PRIVATE: 'Privat',
    NEWSFEED_PROFILE_PREVIEW_QUALIFICATIONS: 'Qualifikationen',
    NEWSFEED_PROFILE_PREVIEW_QUALIFICATIONS_MORE:
      '{?IF:qualifications_sg}\n{qualifications_more_entries} weiterer Eintrag\n{?ELSE:qualifications_sg}\n{qualifications_more_entries} weitere Einträge\n{?END:qualifications_sg}',
    NEWSFEED_PROFILE_PREVIEW_SCHOOLS_MORE:
      '{?IF:schools_sg}\n{schools_more_entries} weiterer Eintrag\n{?ELSE:schools_sg}\n{schools_more_entries} weitere Einträge\n{?END:schools_sg}',
    NEWSFEED_PROFILE_PREVIEW_WANTS: 'Ich suche',
    NEWSFEED_PROFILE_PREVIEW_WORKEXP_MORE:
      '{?IF:sg}\n{more_entries} weiterer Eintrag\n{?ELSE:sg}\n{more_entries} weitere Einträge\n{?END:sg}',
    NEWSFEED_RECOMMEND: 'Teilen',
    NO_END_DATE_HINT:
      'Du hast kein Enddatum angegeben und auch nicht "bis heute" ausgewählt.',
    NO_PRIV_ADD_HINT: 'Du hast noch keine Daten zur Privatadresse angegeben.',
    NOTES: 'Schwerpunkte',
    NOTIFICATION_CENTER_LINK: 'Mitteilungen',
    NOTIFICATIONS: 'Benachrichtigungen',
    OBCPAGEHTML_DETAILS_NOTAPPROVED: '(nicht freigegeben)',
    OBCPAGEHTML_LANGUAGES: 'Sprachkenntnisse',
    OBCPAGEHTML_PERIOD: 'Zeitraum',
    OBCPAGEHTML_SHOW_SHARED_CONTACTS: 'Gemeinsame Kontakte anzeigen',
    OBCPAGEHTML_TAB5: 'Applikationen',
    OPENSOCIAL_REFERENCES_NEW: 'NEU',
    OPENSOCIAL_REFERENCES_TEXT:
      '{-DISPLAY_NAME} verwendet die Applikation XING Referenzen. <a href="{-LINK}">Referenzen ansehen</a>',
    OPENSOCIAL_REFERENCES_TITLE: 'Referenzen',
    OPTIMIZEPROFILE_ADVANTAGES_1:
      'Von <b>über 75.000 Personalern</b> sofort gefunden werden',
    OPTIMIZEPROFILE_ADVANTAGES_2:
      'Mit optimal ausgefülltem Profil <b>zum neuen Job</b>',
    OPTIMIZEPROFILE_ADVANTAGES_3:
      '<b>Diskret gefunden werden</b>, z. B. für Personen in Arbeitsverhältnissen',
    OPTIMIZEPROFILE_BTN: 'Jetzt Profil optimieren',
    OPTIMIZEPROFILE_CHECK_1: 'Wirst Du als Erstes gefunden?',
    OPTIMIZEPROFILE_CHECK_1_MORE_1:
      'Dein Profil ist nicht nur Deine Visitenkarte, sondern entscheidet auch darüber, an welcher Stelle Du von Personalern in den Suchergebnissen gefunden wirst. Denn: Vollständig ausgefüllte Profile werden als Erstes angezeigt!',
    OPTIMIZEPROFILE_CHECK_1_MORE_2:
      'Überlasse Dein berufliches Schicksal nicht dem Zufall: Mit einem vollständig ausgefüllten Profil erscheinst Du in der Ergebnisliste ganz oben!',
    OPTIMIZEPROFILE_CHECK_1_MORE_3:
      'Nutze die Tipps, die Dir auf Deiner Profilseite zur Vervollständigung Deines Profils angezeigt werden.',
    OPTIMIZEPROFILE_CHECK_2: 'Weist Du auf Deine Job-Suche hin?',
    OPTIMIZEPROFILE_CHECK_2_MORE_1:
      'Stelle die Weichen für Deinen Erfolg: Auf XING kannst Du von über 75.000 Personalern gefunden werden. Gib also in Deinem Profil an, dass Du eine neue Herausforderung suchst.',
    OPTIMIZEPROFILE_CHECK_2_MORE_2:
      'Trage im Bereich „Warum ich auf XING bin“ ein, dass Du auf Job-Suche bist.',
    OPTIMIZEPROFILE_CHECK_2_MORE_3:
      'Wenn Du Dich in einer Anstellung befindest und diskret einen Job suchst, wähle die Option „Nur Recruiter“. So wird Deine Suche nur für ausgewiesene Personalentscheider sichtbar.',
    OPTIMIZEPROFILE_CHECK_3:
      'Ist Deine Berufserfahrung detailliert genug aufgelistet?',
    OPTIMIZEPROFILE_CHECK_3_MORE_1:
      'Personaler sind besonders an Deinem beruflichen Werdegang interessiert. Gib diesen im Bereich „Berufserfahrung“ genau an.',
    OPTIMIZEPROFILE_CHECK_3_MORE_2:
      'Mache bei jetzigen und früheren Stationen auch Angaben zur Dauer der Beschäftigung, am besten durch Monats- und Jahresangabe. Nutze das Feld „Karriere-Stufe“, um Deine Erfahrung zu dokumentieren.',
    OPTIMIZEPROFILE_CHECK_3_MORE_3:
      'Biete Futter: Zähle nicht nur Deine Stationen auf. Lass im Feld „Beschreibe Deine Position“ Deine Erfolge oder spezifische Kompetenzen erkennen.',
    OPTIMIZEPROFILE_CHECK_4: 'Hast Du Deine Qualifikationen genau beschrieben?',
    OPTIMIZEPROFILE_CHECK_4_MORE_1:
      'Überzeuge mit Kompetenz: Zähle im Bereich "Fähigkeiten & Kenntnisse" auf, was Du kannst.',
    OPTIMIZEPROFILE_CHECK_4_MORE_2:
      'Orientiere Dich auch an Schlagwörtern, die Personalverantwortliche auf ihren Profilseiten benutzen. Sucht ein Personaler beispielsweise nicht nach “Webdesign”, sondern nach “XHTML”, “HTML 4″ und “CSS 3″, solltest Du darauf vorbereitet sein.',
    OPTIMIZEPROFILE_CHECK_5: 'Teilst Du bereits mit, was Du suchst?',
    OPTIMIZEPROFILE_CHECK_5_MORE_1:
      'Warte nicht, bis ein Personaler Dich über Deine Qualifikationen entdeckt – kommuniziere auch, was Du suchst. So wirst Du leichter gefunden!',
    OPTIMIZEPROFILE_CHECK_5_MORE_2:
      'Trage unter „Ich suche“ Schlagwörter wie „Herausforderung“, „Veränderung“ oder „Job“ ein.',
    OPTIMIZEPROFILE_CHECK_5_MORE_3:
      'Sei kreativ: Hier könnte z. B. Deine Wunsch-Stellenbezeichnung stehen.',
    OPTIMIZEPROFILE_CHECK_6: 'Was sagt Dein Foto über Dich aus?',
    OPTIMIZEPROFILE_CHECK_6_MORE_1:
      'Bei Deinem Profilbild gelten dieselben Regeln wie für Bewerbungsfotos: keine Urlaubsschnappschüsse, sondern ein professionell aufgenommenes Porträt.',
    OPTIMIZEPROFILE_CHECK_7: 'Hältst Du Dich regelmäßig auf dem Laufenden?',
    OPTIMIZEPROFILE_CHECK_7_MORE_1:
      'Wenn Du mit einem Personaler in Kontakt trittst, sorge für eine transparente und zügige Kommunikation – Personalmanagement ist ein schnelles Geschäft.',
    OPTIMIZEPROFILE_CHECK_7_MORE_2:
      'Bleib am Ball: Checke regelmäßig Deine Nachrichten, da Personalverantwortliche zeitnah Antworten benötigen.',
    OPTIMIZEPROFILE_CHECK_7_MORE_3:
      'Halte Deine Benachrichtigungsadresse auf XING aktuell: Per E-Mail wirst Du über neue XING-Nachrichten sofort informiert.',
    OPTIMIZEPROFILE_CHECK_8: 'Nutze die Felder “Firma” und „Status“ effizient?',
    OPTIMIZEPROFILE_CHECK_8_MORE_1:
      'Überrasche Deinen zukünftigen Arbeitgeber mit einer Kostprobe Deiner Kreativität: Wenn Du Arbeit suchst, trage ins Feld „Firma“ statt Deines Namens lieber Bezeichnungen wie „Freelancer“, „Auf Suche“ oder etwas Originelles wie „Hier könnte Ihr Firmenname stehen!“ ein.',
    OPTIMIZEPROFILE_CHECK_8_MORE_2:
      'Ändere Deinen Status in “Arbeit suchend“, Personaler suchen oft mit diesem Begriff.',
    OPTIMIZEPROFILE_CHECK_8_MORE_3:
      'Es ist auch legitim, ein „(Ex-)“ vor die letzte Firma zu setzen.',
    OPTIMIZEPROFILE_CHECKLIST_TITLE:
      'Profil-Checkliste: Ist Dein Profil komplett?',
    OPTIMIZEPROFILE_DESCRIPTION:
      'Mit einem optimal ausgefüllten Profil wird Deine Suche noch effektiver! Schließe jetzt die Lücken in Deinem XING Profil und steigere die Chancen auf Deinen Traumjob.',
    OPTIMIZEPROFILE_INFO:
      'Klicke auf die einzelnen Punkte unserer Profil-Checkliste auf der rechten Seite und informiere Dich, wie Du Dein Profil am besten optimierst.',
    OPTIMIZEPROFILE_SUBTITLE_1: 'Du bist auf der Suche nach einem neuen Job?',
    OPTIMIZEPROFILE_TIP: 'Wichtiger Tipp: Einstellungen zur Privatsphäre',
    OPTIMIZEPROFILE_TIP_MORE_1:
      'Falls Du angestellt bist, ist es ratsam, Deine Job-Suche diskret zu halten. Bedenke, dass alle Profiländerungen auch im Feed "Neues aus Deinem Netzwerk“ Deiner direkten Kontakte erscheinen! So beugst Du eventuellen Irritationen vor:',
    OPTIMIZEPROFILE_TIP_MORE_2:
      'Geh auf Nummer sicher: Passe vor dem Verändern Deines Profils Deine Privatsphäre an. Entferne im Bereich „Einstellungen/Meine Privatsphäre/Neues aus Deinem Netzwerk“ die Haken bei „Persönliches“ und „Berufserfahrung, Anhänge und Ausbildung“. Deine Änderungen werden dann nicht auf der Startseite und im Newsletter Deiner Kontakte angezeigt.',
    OPTIMIZEPROFILE_TIP_MORE_3:
      'Setze das Häkchen nach Deinen Änderungen wieder. So wird Dein Netzwerk wieder über Deine Neuigkeiten informiert.',
    OPTIMIZEPROFILE_TITLE: 'Mach Dein Profil fit für Deinen Traumjob!',
    OPTIONS: 'Optionen',
    OPTIONS_DELETE: 'Ja, bitte löschen.',
    ORG_TYPE: 'Art der Organisation',
    PERSONAL: 'Persönliches',
    PERSONAL_INFO: 'Persönliche Daten',
    PHONE: 'Telefon',
    PHOTOBOX_LOCAL_TIME: 'Ortszeit:',
    POLLS_HEADER_LABEL: 'Umfrage',
    POLLS_SHOW_RESULT_TITLE: 'Ergebnisse ansehen',
    POLLS_SHOW_VOTING_OPTIONS_TITLE: 'Antwort-Optionen ansehen',
    POLLS_TIME_ENDED: 'Umfrage geschlossen',
    POLLS_TIME_LAST_MINUTES: 'Umfrage schließt bald!',
    'POLLS_TIME_REMAINING_DAYS_IOS.one': 'Endet morgen',
    'POLLS_TIME_REMAINING_DAYS_IOS.other': 'Endet in %d Tagen',
    'POLLS_TIME_REMAINING_DAYS_IOS.zero': 'Endet heute',
    'POLLS_TIME_REMAINING_DAYS_WEB.one': 'Endet morgen',
    'POLLS_TIME_REMAINING_DAYS_WEB.other': 'Endet in {days} Tagen',
    'POLLS_TIME_REMAINING_DAYS_WEB.zero': 'Endet heute',
    POLLS_VOTE_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    'POLLS_VOTES_NUMBER_IOS.one': '1 Stimme',
    'POLLS_VOTES_NUMBER_IOS.other': '%d Stimmen',
    'POLLS_VOTES_NUMBER_IOS.zero': 'Keine Stimmen',
    PORTFOLIO_CHOICE_HINT_VIDEO_UPSELL:
      'Max. 15 Videos<br>\n<a {href}>(Nur Premium)</a>',
    PORTFOLIO_DESCRIPTION_VIDEO_UPSELL:
      'Präsentiere Deine Arbeit mit einem Video.<br><br>Möchtest Du diese Funktion nutzen? Dann werde jetzt einfach Premium-Mitglied: <a {href}>Zur Premium-Mitgliedschaft</a>',
    PORTFOLIO_UPGRADE_MESSAGE_WITH_NO_VIDEO:
      'Bis zu {max_file_number} Bilder oder PDF-Dokumente hinzufügen<br>\nBis zu {max_video_number} Videos einbinden<br>\nUnbegrenzt Textmodule verwenden',
    PREFSHTML_LANG_OPT_de: 'Deutsch',
    PREFSHTML_LANG_OPT_en: 'Englisch',
    PREFSHTML_LANG_OPT_es: 'Spanisch',
    PREFSHTML_LANG_OPT_fr: 'Französisch',
    PREFSHTML_LANG_OPT_it: 'Italienisch',
    PRESENT: 'heute',
    PREVIEW: 'Vorschau',
    PRIMARY_JOB:
      'Diese Tätigkeit neben meinem Namen und oben auf meiner Profilseite anzeigen',
    PRIMARY_SCHOOL:
      'Diese Hochschule neben meinem Namen und oben auf meiner Profilseite anzeigen.',
    PRIVATE: 'Privat',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY:
      'Schau Dir alle Event-Teilnehmenden direkt in ProBusiness an, verfeinere die Liste mit zahlreichen Filtern und speicher relevante Leads gleich ab.',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON:
      'Teilnahmeliste in ProBusiness ansehen',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE:
      'Du möchtest Leads aufgabeln?',
    PROBUSINESS_BANNER_SEARCH_BODY:
      'Sieh Dir diese Ergebnisse direkt in ProBusiness an, nutz die effizienten Filtermöglichkeiten und speicher gefundene Kontakte gleich als relevante Leads ab.',
    PROBUSINESS_BANNER_SEARCH_BUTTON: 'Ergebnisse in ProBusiness anzeigen',
    PROBUSINESS_BANNER_SEARCH_HEADLINE:
      'Vertriebsgeheimnis: Verfeinere Deine Ergebnisse!',
    PROBUSINESS_DROPDOWN_SHOW_RESULT: 'In ProBusiness ansehen',
    PROBUSINESS_NO_STATUS_AVAILABLE: 'Lead-Status derzeit unbekannt',
    PROBUSINESS_SAVE_AS_LEAD: 'Lead merken',
    PROFILE_ABOUT_PREVIEW_CREATE: '"Über mich"-Seite anlegen',
    PROFILE_ABOUT_PREVIEW_EDIT: 'Den Bereich "Über mich" editieren',
    PROFILE_ABOUT_PREVIEW_EMPTY_TEXT:
      '<strong>Willkommen auf Deiner persönlichen "Über mich"-Seite!</strong><br><br>\nXING-Mitglieder, die Dein Profil besuchen, möchten hier mehr über Dich erfahren als es der Lebenslauf hergibt.<br><br>\n\nNutze daher diese Seite, um Dich bei Interessenten im besten Licht zu präsentieren. Stelle Dich also persönlich vor, gehe genauer auf Deine Qualifikationen, Erfahrungen und beruflichen Ambitionen ein oder &ndash; wenn Du Freiberufler bist &ndash; nutze diese Seite für die Präsentation Deiner Dienstleistungen und Produkte.',
    PROFILE_ABOUT_PREVIEW_MORE: 'Mehr',
    PROFILE_ACTIONS_HEADLINE: 'Optionen',
    PROFILE_ACTIONS_MORE_TRIGGER: 'Mehr',
    PROFILE_BACKEND_PMBX_INQUIRY_PAYLOAD_SETTINGS_ACTIVITY_TAB_VISIBILITY:
      'Aktivitäten sichtbar?',
    PROFILE_BACKEND_PMBX_INQUIRY_PAYLOAD_SETTINGS_PORTFOLIO_TAB_VISIBILITY:
      'Portfolio sichtbar?',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE: 'Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT:
      'Ambassador·innen moderieren die offiziellen XING Gruppen und\norganisieren die offiziellen XING Events. Sie haben dabei einen von drei verschiedenen Schwerpunkten:',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE:
      'Branchen-Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK: 'Branchen-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB:
      'Moderator·innen und ausgewiesene Fachleute ihrer Branche',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT:
      'Branchen-Ambassador·innen sind\nengagierte XING Mitglieder mit einer spezielle Lizenz im\nRahmen unseres Ambassador-Programms. \nSie moderieren jeweils eine große Branchen-Gruppe, verfügen\nüber Fachwissen und Anerkennung in ihrem Fachgebiet\nund unterstützten die Aktivitäten der Mitglieder ihrer Gruppe\nsowohl online als auch durch offizielle Events.',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE:
      'Regional-Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK: 'Regional-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB:
      'Offizieller Event-Veranstalter und Vertrauensperson vor Ort',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT:
      'Regional-Ambassador·innen sind Markenbotschafter·innen und regionaler Anlaufpunkt für XING Mitglieder und Interessierte. Sie moderieren jeweils eine offizielle Regional-Gruppe, veranstalten regelmäßig Events in ihrer\nRegion und unterstützen den Austausch der Gruppen-Mitglieder untereinander.',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE: 'Themen-Ambassador·innen ',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK: 'Themen-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB:
      'Expert·innen für Themen rund um die moderne Arbeitswelt',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT:
      'Dies sind Spezialisten für die moderne\nArbeitswelt. In ihren Gruppen begleiten sie Diskussionen rund\num das Thema "Arbeit der Zukunft". Sie organisieren\nVeranstaltungen, in denen es um neue Trends, Erkenntnisse\nund Meinungen zur Arbeitswelt von heute und morgen geht.',
    PROFILE_BADGES_LAYER_MODERATOR_SUB:
      'Ansprechperson und Konfliktlöser einer Gruppe',
    PROFILE_BADGES_LAYER_PREMIUM_LINK: 'Alle Premium-Vorteile im Überblick',
    PROFILE_BADGES_LAYER_PREMIUM_SUB:
      'Hilfreiche Zusatzfunktionen für Beruf, Karriere und Geschäft',
    PROFILE_BUSINESS_ANCHOR_PRIVATE:
      'Gib hier Deine <a href="#contact_details">private Adresse</a> an.',
    PROFILE_BUSINESS_ANCHOR_WEB:
      'Gib auch <a href="#web-profiles">Deine anderen Profile im Web</a> an (z. B. von Facebook oder Twitter etc.).',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT: 'Was ist ein Ambassador?',
    PROFILE_BUSINESS_CARD_BADGE_BASIC: 'Basis',
    PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP: 'Premium kennenlernen',
    PROFILE_BUSINESS_CARD_BADGE_EXECUTIVE: 'Executive',
    PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR: 'Branchen-Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR: 'Moderator',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT: 'Was ist ein Moderator?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM: 'Premium',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT:
      'Welche Vorteile hat die<br>Premium-Mitgliedschaft?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP: 'Premium-Mitglied',
    PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR: 'Themen-Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_XPERT: 'Xpert',
    PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT: 'Was ist ein Xpert?',
    PROFILE_BUSINESS_CARD_BUSINESS_ADDRESS: 'Geschäftlich',
    PROFILE_BUSINESS_CARD_PRIVATE_ADDRESS: 'Privat',
    PROFILE_BUSINESS_CARD_ROUTE: 'Kartenansicht',
    PROFILE_BUSINESS_CARD_WEB_PROFILES: 'Profile im Web',
    PROFILE_COMPLETE_WITH:
      'Mit diesen Angaben wird Dein Profil vervollständigt:',
    PROFILE_COMPLETION_TEXT: 'Vollständigkeit des Profils',
    PROFILE_CONTACTS_MORE: 'Weitere Kontakte',
    PROFILE_GROUPS_BOX_HEADER_OTHER: 'Gruppen von {-ONAME}',
    PROFILE_GROUPS_BOX_NO_GROUPS_VISIBLE:
      'Auf Deinem Profil sind keine Gruppen sichtbar.',
    PROFILE_GROUPS_SHOW_ALL_LINK: 'Alle anzeigen',
    PROFILE_GUESTBOOK_BOX_MORE: 'Weitere Einträge',
    PROFILE_HEAD_MESSAGE: 'Nachricht schreiben',
    PROFILE_INLINETEASER_HEADER_MULTI_ENTRIES:
      'Es gibt {num_past_workentries} weitere Einträge.',
    PROFILE_INLINETEASER_HEADER_NO_ENTRIES:
      'Möchtest Du mehr über {-ONAME} wissen?',
    PROFILE_INLINETEASER_HEADER_SINGLE_ENTRY: 'Es gibt einen weiteren Eintrag.',
    PROFILE_INLINETEASER_TEXT:
      'Registriere Dich dazu kostenlos. Als XING-Mitglied kannst Du {-ONAME} auch direkt kontaktieren.',
    PROFILE_INLINETEASER_TEXT_MULTIPLE:
      'Registriere Dich kostenlos, um die gesamte Berufserfahrung von {-ONAME} zu sehen.',
    PROFILE_LATEST_ACTIVITIES_HEADLINE: 'Letzte Aktivitäten',
    PROFILE_LATEST_ACTIVITIES_MORE: 'Mehr',
    PROFILE_LIGHTBOX_SIGNUP_HEADLINE:
      '{-ONAME} ist eines von über 20 Mio. XING Mitgliedern.',
    PROFILE_LIGHTBOX_SIGNUP_TEXT:
      'Registriere Dich kostenlos, um alte Kontakte wiederzufinden und neue interessante Menschen zu entdecken.',
    PROFILE_LOGGED_OUT_JOIN_NOW: 'Kostenlos registrieren',
    PROFILE_LOGGEDOUT_RIGHTBOX_1: 'Bist Du schon dabei?',
    PROFILE_LOGGEDOUT_RIGHTBOX_2:
      'XING ist ein Business-Netzwerk für Geschäftsleute und verbindet Know-how mit Know-who.',
    PROFILE_LOGGEDOUT_RIGHTBOX_3: 'Nutze die Vorteile von XING:',
    PROFILE_LOGGEDOUT_RIGHTBOX_4:
      'Finde neue Vertriebskanäle, Fachkräfte und Jobs',
    PROFILE_LOGGEDOUT_RIGHTBOX_5: 'Finde Kolleg·innen und Bekannte wieder',
    PROFILE_LOGGEDOUT_RIGHTBOX_6: 'Erreiche Experten per Mausklick',
    PROFILE_LOGGEDOUT_RIGHTBOX_7: 'Kostenlos registrieren',
    PROFILE_LOGGEDOUT_SEACRHBOX_1: 'Suche im XING-Netzwerk',
    PROFILE_LOGGEDOUT_SEACRHBOX_2:
      'Finde neue Business-Kontakte auf XING\nund treffe alte Kontakte wieder!',
    PROFILE_LOGGEDOUT_TOPBOX_BUTTON:
      'Kostenlos registrieren und {ONAME} kontaktieren',
    PROFILE_LOGGEDOUT_TOPBOX_HEADER: 'Kontaktiere {-ONAME}!',
    PROFILE_LOGGEDOUT_TOPBOX_HEADER_2: 'Möchtest Du mehr über {-ONAME} wissen?',
    PROFILE_LOGGEDOUT_TOPBOX_TEXT1: 'Registriere Dich dazu kostenlos bei XING.',
    PROFILE_LOGGEDOUT_TOPBOX_TEXT2:
      'Schon Mitglied? <a href="/profile/{+obcpage_name}">Einloggen</a> und {-ONAME} als Kontakt hinzufügen.',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE: 'Aktiv',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE_FALSE: 'Nein',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE_TRUE: 'Ja',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_CAREER_SETTINGS:
      'Job-Wünsche',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_CONTENT_INSIDER:
      'Artikel',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_MODULE_NAME: 'Name',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_PATTERNS_SHOWCASE:
      'Patterns showcase',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_PERSONAL_DETAILS:
      'Persönliches',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_TIMELINE:
      'Werdegang',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_TITLE:
      'Profilbereiche',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_TITLE: 'Sichtbarkeit der Profildaten',
    PROFILE_MORE_DETAILS_NOTES_CATS: 'Meine Anmerkungen zu {-ONAME}',
    PROFILE_MORE_DETAILS_TOGGLE_LESS: 'Weniger',
    PROFILE_MORE_DETAILS_TOGGLE_MORE: 'Mehr',
    PROFILE_OTHER_EXPERIENCE_HEADLINE:
      'Andere Besucher haben sich auch folgende Profile angesehen:',
    PROFILE_OTHER_EXPERIENCE_LINK: 'Weitere Profile',
    PROFILE_PMBX_INQUIRY_PAYLOAD_CONTENT: 'Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_CREATED_AT: 'Erstellt am',
    PROFILE_PMBX_INQUIRY_PAYLOAD_FEED_URL: 'Feed URL',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_CONTENT: 'Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_DISPLAY_CONTENT:
      'Angezeigter Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_TITLE:
      'Rechtliche Informationen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_NO_DATA_REASON: 'Keine Daten vorhanden',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_IMAGETILE_HEADER:
      'Portfolio: Bilder',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_PDFTILE_HEADER:
      'Portfolio: PDF-Dateien',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TEXTTILE_HEADER:
      'Portfolio: Textmodule',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_CONTENT: 'Beschreibung',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_FILE: 'PDF',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_IMAGE: 'Bild',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_LINK: 'Link',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_TITLE: 'Überschrift',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_VIDEOTILE_HEADER:
      'Portfolio: Videos',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_ACCURACY: 'Genauigkeit',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_ADMIN_AREA: 'Region',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_CITY: 'Ort',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_FORMATTED_COUNTRY: 'Land',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_JSON_ATTRIBUTES:
      'Lokale Angaben',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LATITUDE: 'Breitengrad',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LOCATION_TYPE: 'Typ',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LONGITUDE: 'Längengrad',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_POSTAL_CODE: 'Postleitzahl',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_STREET: 'Straße und Hausnr.',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_TITLE: 'Ermittelter Standort',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_UPDATE_FAILED:
      'Die Ortsdaten konnten leider nicht aktualisiert werden.',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_PHOTO_ORIGINAL_PICTURE: 'Profilbild',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_PHOTO_ORIGINAL_TITLE: 'Profilbild',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_GIVEN_AT: 'Erteilt am',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_GIVEN_TO: 'Für',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_POSITION: 'Für die Position',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_RECIEVED_FROM: 'Von',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN:
      'Referenzen gegeben',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN_TEXT:
      'Am {given_at} an {referee_id} | ({referee_position}). {testimonial}',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN_TITLE:
      'Erteilte Referenzen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_POSITON: 'Position',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECEIVED:
      'Referenzen erhalten',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECEIVED_TEXT:
      'Am {given_at} von {referrer_id} | ({referrer_position}). {testimonial}',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECIEVED_TITLE:
      'Erhaltene Referenzen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_TITLE: 'Referenzen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_TESTIMONIAL: 'Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_RSS_PROFILE_TITLE: 'RSS Feeds',
    PROFILE_PMBX_INQUIRY_PAYLOAD_TITLE: 'Standortdaten',
    PROFILE_PMBX_INQUIRY_PAYLOAD_UPDATED_AT: 'Aktualisiert am',
    PROFILE_POWERSEARCHES_HEADER: 'Suchen rund um mein Profil',
    PROFILE_PREVIEW_HEADER: 'So sieht Dein Profil für Nicht-Kontakte aus.',
    PROFILE_PREVIEW_INFO_BUTTON_BACK: 'Zur normalen Ansicht',
    PROFILE_PREVIEW_INFO_HEADLINE: 'So wird Dein Profil Besuchern angezeigt',
    PROFILE_PREVIEW_INFO_TEXT:
      'Bitte wechsel zurück in den Editier-Modus, um Dein Profil zu bearbeiten.',
    PROFILE_PREVIEW_OFF: 'Zur normalen Ansicht',
    PROFILE_PREVIEW_ON: 'Dein Profil aus der Sicht anderer',
    PROFILE_PROMOTE_HEADLINE: 'Dein persönlicher Profil-Button',
    PROFILE_PROMOTE_MORE: 'Quelltext anzeigen',
    PROFILE_PROMOTE_TEXT:
      'Der Button für Deine Website oder Deinen Blog: Wer darauf klickt, landet automatisch auf Deinem XING Profil. Um ihn zu integrieren, musst Du lediglich den unten stehenden Quelltext in Deine Website einfügen.',
    PROFILE_SECTIONS_GROUPS_TITLE: 'Gruppen',
    PROFILE_SETTINGS: 'Einstellungen',
    PROFILE_SEVERAL_GROUPS_COUNT: '({-count} von {-total})',
    PROFILE_SEVERAL_GROUPS_TITLE: 'Einige Gruppen von {-ONAME}',
    PROFILE_SEVERAL_OF_MY_GROUPS_TITLE: 'Einige meiner Gruppen',
    PROFILE_TIMELINE_MODULE_ACTION_ADD_ENTRY: 'Etwas anderes',
    PROFILE_TIMELINE_MODULE_ACTION_ADD_PROMOTION: 'Beförderung',
    PROFILE_TIMELINE_MODULE_ACTION_CHANGE_ORGANIZATION: 'Neue Stelle',
    PROFILE_TIMELINE_MODULE_ACTION_EDIT_ENTRY: 'Interner Wechsel',
    PROFILE_TIMELINE_MODULE_BUCKET_PROFESSIONAL_AND_ENTRY_LEVEL_TITLE:
      'Berufserfahrung',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION:
      '{years} und {months}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_FROM:
      '{duration}, ab {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_SINCE:
      '{duration}, seit {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_SINCE_YEAR:
      '{duration}, seit {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_ONLY_FROM: 'ab {date}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_ONLY_SINCE:
      'seit {date}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_PERIOD: '{from} - {to}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_TO_PRESENT_ONLY:
      '**Bis heute**',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_WITH_DURATION_AND_PERIOD:
      '{duration}, {period}',
    PROFILEPAGE_MSG_INV_ALREADY_MEMBER:
      '<b>Achtung:</b> Deine Einladung wurde NICHT versandt, da die ausgewählte Person bereits Mitglied in der Gruppe ist.',
    PROFILEPAGE_MSG_INV_TOO_EARLY:
      '<b>Achtung:</b> Deine Einladung wurde NICHT versandt, da die ausgewählte Person bereits von Dir in die Gruppe eingeladen wurde.',
    PROFILERAILS_BLOG_PREPARE_INFO:
      'Die Beiträge des Blogs stehen gleich zur Verfügung.',
    PROFILERAILS_BLOG_PREPARE_INFO_ERROR:
      'Dieser Link reagiert gerade nicht  ... vielleicht vertippt? Sonst versuche es bitte später noch einmal.',
    PROFILERAILS_EDIT_CONTACT_DETAILS_PATH_FENCED_HINT:
      'Über welche Deiner Kontakte seid ihr miteinander verbunden?',
    PROFILERAILS_EDIT_CONTACT_DETAILS_PATH_SHOW_ALL_FENCED:
      'Alle Kontaktpfade anzeigen',
    PROFILERAILS_PROFILE_VISITORS_HL_BASIC:
      '<strong>Profilbesuche</strong>  sind für Premium-Mitglieder sichtbar!',
    PROFILERAILS_PROJOBS_ONBOARDING_HEADER: 'Deine ProJobs-Profilansicht',
    PROFILERAILS_PROJOBS_ONBOARDING_TEXT:
      'Diese Ansicht ist nur für Personen verfügbar, die Du in Deinen <a href="/projobs/start?sc_o=ojm_443_settings">ProJobs Einstellungen</a> freigeschaltet hast. Mehr Informationen über die Nutzung von ProJobs bekommst Du im <a href="#" data-mypj-trigger-tour>ProJobs-Rundgang</a>.',
    PROFILERAILS_VISITORS_BUTTON_PREMIUM_UPSELL: 'Premium-Mitglied werden',
    PROGRESS_BAR_LOADING_PERCENTAGE: '{percentage} % hochgeladen',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_10_AM: '10 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_10_PM: '22 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_12_AM: '00 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_12_PM: '12 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_2_PM: '14 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_4_PM: '16 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_6_AM: '06 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_6_PM: '18 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_8_AM: '08 Uhr',
    PROJOBS_CONTACT_OPTIONS_PHONE_TIME_8_PM: '20 Uhr',
    PROVINCE_0: 'Macau',
    PROVINCE_1279685: 'Autonomes Gebiet Tibet',
    PROVINCE_1280239: 'Qinghai',
    PROVINCE_1529047: 'Autonomes Gebiet Xinjiang',
    PROVINCE_1784764: 'Zhejiang',
    PROVINCE_1785694: 'Yunnan',
    PROVINCE_1792943: 'Tianjin',
    PROVINCE_1794299: 'Sichuan',
    PROVINCE_1795912: 'Shanxi',
    PROVINCE_1796231: 'Shanghai',
    PROVINCE_1796328: 'Shandong',
    PROVINCE_1796480: 'Shaanxi',
    PROVINCE_1799355: 'Autonome Region Ningxia',
    PROVINCE_1806222: 'Jiangxi',
    PROVINCE_1806260: 'Jiangsu',
    PROVINCE_1806691: 'Hunan',
    PROVINCE_1806949: 'Hubei',
    PROVINCE_1808520: 'Henan',
    PROVINCE_1808773: 'Hebei',
    PROVINCE_1809054: 'Hainan',
    PROVINCE_1809445: 'Guizhou',
    PROVINCE_1809867: 'Autonome Region Guangxi',
    PROVINCE_1809935: 'Guangdong',
    PROVINCE_1810676: 'Gansu',
    PROVINCE_1811017: 'Fujian',
    PROVINCE_1814905: 'Chongqing',
    PROVINCE_1818058: 'Anhui',
    PROVINCE_2035607: 'Autonomes Gebiet Innere Mongolei',
    PROVINCE_2036115: 'Liaoning',
    PROVINCE_2036500: 'Jilin',
    PROVINCE_2036965: 'Heilongjiang',
    PROVINCE_2038349: 'Peking',
    PROVINCE_2513413: 'Region Murcia',
    PROVINCE_2521383: 'Balearische Inseln',
    PROVINCE_2593109: 'Andalusien',
    PROVINCE_2593110: 'Kanarische Inseln',
    PROVINCE_2593111: 'Kastilien-La Mancha',
    PROVINCE_2593112: 'Estremadura',
    PROVINCE_2593113: 'Landes Valencia',
    PROVINCE_2822542: 'Thüringen',
    PROVINCE_2838632: 'Schleswig-Holstein',
    PROVINCE_2842565: 'Sachsen-Anhalt',
    PROVINCE_2842566: 'Sachsen',
    PROVINCE_2842635: 'Saarland',
    PROVINCE_2847618: 'Rheinland-Pfalz',
    PROVINCE_2861876: 'Nordrhein-Westfalen',
    PROVINCE_2862926: 'Niedersachsen',
    PROVINCE_2872567: 'Mecklenburg-Vorpommern',
    PROVINCE_2905330: 'Hessen',
    PROVINCE_2911297: 'Hamburg',
    PROVINCE_2944387: 'Bremen',
    PROVINCE_2945356: 'Brandenburg',
    PROVINCE_2950157: 'Berlin',
    PROVINCE_2951839: 'Bayern',
    PROVINCE_2953481: 'Baden-Württemberg',
    PROVINCE_3042613: 'Komitat Zala',
    PROVINCE_3042925: 'Veszprém',
    PROVINCE_3043047: 'Komitat Vas',
    PROVINCE_3043845: 'Tolna',
    PROVINCE_3045226: 'Somogy',
    PROVINCE_3046431: 'Pest',
    PROVINCE_3047348: 'Nógrád',
    PROVINCE_3049518: 'Komitat Komárom-Esztergom',
    PROVINCE_3051977: 'Komitat Győr-Moson-Sopron',
    PROVINCE_3053028: 'Komitat Fejér',
    PROVINCE_3054638: 'Budapest',
    PROVINCE_3055399: 'Branau',
    PROVINCE_3055744: 'Komitat Bács-Kiskun',
    PROVINCE_3114710: 'Asturien',
    PROVINCE_3115609: 'Autonome Region Navarra',
    PROVINCE_3117732: 'Autonome Region Madrid',
    PROVINCE_3336897: 'La Rioja',
    PROVINCE_3336898: 'Kantabrien',
    PROVINCE_3336899: 'Aragonien',
    PROVINCE_3336900: 'Kastilien und León',
    PROVINCE_3336901: 'Katalonien',
    PROVINCE_3336902: 'Galicien',
    PROVINCE_3336903: 'Baskenland',
    PROVINCE_4099753: 'Arkansas',
    PROVINCE_4138106: 'District of Columbia',
    PROVINCE_4142224: 'Delaware',
    PROVINCE_4155751: 'Florida',
    PROVINCE_4197000: 'Georgia',
    PROVINCE_4273857: 'Kansas',
    PROVINCE_4331987: 'Louisiana',
    PROVINCE_4361885: 'Maryland',
    PROVINCE_4398678: 'Missouri',
    PROVINCE_4436296: 'Mississippi',
    PROVINCE_4482348: 'North Carolina',
    PROVINCE_4544379: 'Oklahoma',
    PROVINCE_4597040: 'South Carolina',
    PROVINCE_4662168: 'Tennessee',
    PROVINCE_4736286: 'Texas',
    PROVINCE_4826850: 'West Virginia',
    PROVINCE_4829764: 'Alabama',
    PROVINCE_4831725: 'Connecticut',
    PROVINCE_4862182: 'Iowa',
    PROVINCE_4896861: 'Illinois',
    PROVINCE_4921868: 'Indiana',
    PROVINCE_4971068: 'Maine',
    PROVINCE_5001836: 'Michigan',
    PROVINCE_5037779: 'Minnesota',
    PROVINCE_5073708: 'Nebraska',
    PROVINCE_5090174: 'New Hampshire',
    PROVINCE_5101760: 'New Jersey',
    PROVINCE_5128638: 'New York',
    PROVINCE_5165418: 'Ohio',
    PROVINCE_5224323: 'Rhode Island',
    PROVINCE_5242283: 'Vermont',
    PROVINCE_5279468: 'Wisconsin',
    PROVINCE_5332921: 'Kalifornien',
    PROVINCE_5417618: 'Colorado',
    PROVINCE_5481136: 'New Mexico',
    PROVINCE_5509151: 'Nevada',
    PROVINCE_5549030: 'Utah',
    PROVINCE_5551752: 'Arizona',
    PROVINCE_5596512: 'Idaho',
    PROVINCE_5667009: 'Montana',
    PROVINCE_5690763: 'North Dakota',
    PROVINCE_5744337: 'Oregon',
    PROVINCE_5769223: 'South Dakota',
    PROVINCE_5815135: 'Washington',
    PROVINCE_5843591: 'Wyoming',
    PROVINCE_5855797: 'Hawaii',
    PROVINCE_5879092: 'Alaska',
    PROVINCE_6254925: 'Kentucky',
    PROVINCE_6254926: 'Massachusetts',
    PROVINCE_6254927: 'Pennsylvania',
    PROVINCE_6254928: 'Virginia',
    PROVINCE_715593: 'Komitat Szabolcs-Szatmár-Bereg',
    PROVINCE_719637: 'Komitat Jász-Nagykun-Szolnok',
    PROVINCE_720002: 'Heves',
    PROVINCE_720293: 'Komitat Hajdú-Bihar',
    PROVINCE_721589: 'Csongrád',
    PROVINCE_722064: 'Komitat Borsod-Abaúj-Zemplén',
    PROVINCE_722433: 'Békés',
    PW_CHANGE_SUGGESTION:
      'Um Deine Zugangsdaten vor Missbrauch zu schützen, empfehlen wir dringend, Dein Passwort mindestens zweimal jährlich zu ändern.',
    QUALIFICATIONS: 'Qualifikationen',
    QUALIFICATIONS_EMPTY:
      'Gib hier zusätzliche Qualifikationen wie z. B. Sprachdiplome oder Zertifikate an.',
    RA_1_2_years_in_pos: '1-2 Jahren',
    RA_2_5_years_in_pos: '2-5 Jahren',
    RA_5_10_years_in_pos: '5-10 Jahren',
    RA_ACTIVE: 'Besonders aktive Mitglieder',
    RA_ACTIVE_INFO:
      'Die Nutzeraktivität wird auf Basis des Aktivitätsindex des Mitglieds bemessen. Der Index wird jedoch nur einbezogen, wenn der Nutzer ihn öffentlich freigegeben hat.',
    RA_CLOSE: 'Schließen',
    RA_GIVE_FEEDBACK_ITEM:
      'Du hast Ideen oder Anregungen zur Recruiter-Mitgliedschaft?',
    RA_GIVE_FEEDBACK_LINK: 'Gib uns Dein Feedback!',
    ra_hits: 'Treffer',
    RA_JOBSEARCH: 'Mitglieder, die an Karrierechancen interessiert sind',
    RA_JOBSEARCH_INFO:
      'Hier erscheinen Mitglieder, die in ihrem Profil unter "Warum ich auf XING bin" den Punkt "An Karrierechancen interessiert" ausgewählt haben.',
    RA_SEARCH_ERROR:
      'Bitte schränke Deine Suche durch mindestens einen Suchparameter ein.',
    RA_SEARCHHITS: 'Treffer',
    RA_TEASER_GIVE_FEEDBACK_HEADLINE: 'Deine Meinung ist uns wichtig',
    RA_XING_USAGE: 'Spezielle Kandidaten-Filter',
    REFERENCES_AWARDS: 'Referenzen & Auszeichnungen',
    REMEMBER_PASSWORD: 'Eingeloggt bleiben',
    REMOTE_OPTION_FULL_REMOTE: 'Im Home-Office',
    REMOTE_OPTION_NON_REMOTE: 'Vor Ort',
    REMOTE_OPTION_PARTLY_REMOTE: 'Home-Office z. T. möglich',
    ROFILERAILS_PORTFOLIO_ERROR_TITLE_OR_CONTENT:
      'Diese Box enthält keinen Text.',
    SCHOOL: 'Hochschulen',
    SCHOOL_UNIVERSITY: 'Hochschule',
    SCHOOLS_EMPTY:
      'Gebe hier die von Dir besuchte Hochschule ein, um wertvolle Kontakte aus Deiner Studienzeit wieder herzustellen.',
    SE_ALL_VIEW_SEARCH_RESULTS: '{max} Ergebnisse (von {total})',
    SE_ERROR_NOTIFICATION_JOIN_GROUP: 'Das hat leider nicht geklappt.',
    SE_EXTENDED_SEARCH_LIST_DESCRIPTION: 'Erweiterte Suche im Bereich ...',
    SE_FILTER_JOBS_PROJOB_LABEL: 'Jobs von Top-Recruitern',
    SE_JOBS_SUGGESTED_NAME_LOCATION: 'Jobs in {location}',
    SE_LABEL_COMMUNITIES: 'Gruppen',
    SE_LABEL_COMPANIES: 'Unternehmen',
    SE_LABEL_EVENTS: 'Events',
    SE_LABEL_JOBS: 'Jobs',
    SE_LABEL_MEMBERS: 'Mitglieder',
    SE_LABEL_NEWS: 'News',
    SE_OFFICIAL_XING_GROUPS: 'Offizielle XING Gruppen',
    SE_PREMIUM_FLAG_ALTTEXT: 'Nur für Premium-Mitglieder',
    SE_SELECT_MEMBERS: 'Mitglieder',
    SE_SHOW_ALL_RESULTS: 'Alle Ergebnisse',
    SE_SUCCESS_NOTIFICATION_GROUP_JOINED:
      'Du bist jetzt ein Mitglied dieser Gruppe!',
    SE_SUCCESS_NOTIFICATION_REQUESTED_TO_JOIN_GROUP:
      'Deine Beitrittsanfrage wurde einem Moderator dieser Gruppe gesendet.',
    SEARCH_DROPDOWN_COMPANIES: 'Unternehmen',
    SEARCH_DROPDOWN_JOBS: 'Jobs',
    SEARCH_DROPDOWN_MEMBERS: 'Mitglieder',
    SEARCH_DROPDOWN_NEWS: 'News',
    SEARCH_OFFER_INTERESTED_HINT:
      'Werde von Mitgliedern gefunden, die suchen, was Du bietest, Dir interessante Angebote machen können oder Deine Interessen teilen.',
    SEARCH_OFFER_INTERESTED_IN: 'Ich suche, Fähigkeiten, Interessen',
    SEARCH_TOPICS_TAB_SEARCH_BUTTON: 'Suchen',
    SEARCH_TOPICS_TAB_TITLE: 'Themen',
    SELECT_INDUSTRY: 'Bitte wähle eine Branche aus.',
    SELECT_LANGUAGE: 'Bitte wähle eine Sprache aus.',
    SELECT_SERVICE: 'Bitte wähle einen Anbieter aus.',
    SELECT_STATUS: 'Bitte wähle einen Status aus.',
    SERVICE: 'Anbieter',
    SETTINGS_LANGUAGES_TEXT:
      'Bitte wähle die Sprache aus, in der Du {-SITENAME} benutzen möchtest.',
    SETTINGS_MOTIVATIONS:
      '1. Neugeschäft und Aufträge generieren\n2. Neue Mitarbeiter finden\n3. Interessante Personen kennenlernen\n4. Mein Netzwerk pflegen\n5. An Events teilnehmen\n6. Alte Bekannte und Kollegen wiederfinden\n7. An Karrierechancen interessiert',
    SETTINGS_USERNAME_PASSWORD_TEXT:
      'Ändere die Zugangsdaten Deines {-SITENAME}-Benutzerkontos.',
    SHARE_ACTIONSHEET_HEADER: 'Diesen Beitrag teilen',
    SHARE_BOX_DEFAULT_ERROR_MESSAGE:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    SHARE_BOX_HEADER: 'Auf XING teilen',
    SHARE_BOX_PLACEHOLDER: 'Hier kannst Du Deinen Link kommentieren.',
    SHARE_BOX_SHARE_SUCCESS: 'Vielen Dank fürs Teilen!',
    SHARE_BOX_SUBMIT_SHARE: 'Teilen',
    SHARE_BUTTON_LABEL: 'Teilen',
    SHARE_CANCEL_BUTTON: 'Abbrechen',
    SHARE_CHAT_CONTACTS: 'Kontakt auswählen',
    SHARE_CHAT_HINT: 'Die Empfänger erhalten einzelne Nachrichten.',
    SHARE_COUNTER_LABEL:
      '{counter, plural,\n    =1 {Einmal geteilt}\n    other {#-mal geteilt}\n}',
    SHARE_FEEDBACK_GROUPS_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_GROUPS_MESSAGE: '{item} in der Gruppe {group} geteilt',
    SHARE_FEEDBACK_INSIDERARTICLE_LABEL: 'Artikel',
    SHARE_FEEDBACK_JOB_LABEL: 'Job',
    SHARE_FEEDBACK_KLARTEXT_LABEL: 'Beitrag',
    SHARE_FEEDBACK_LINK_LABEL: 'Link',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'Nachricht ansehen',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} per XING Nachricht geteilt',
    SHARE_FEEDBACK_NEWS_LABEL: 'Artikel',
    SHARE_FEEDBACK_PICTURE_LABEL: 'Bild',
    SHARE_FEEDBACK_POST_LABEL: 'Beitrag',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} auf der Startseite geteilt',
    SHARE_FEEDBACK_VIDEO_LABEL: 'Video',
    SHARE_FETCH_ERROR: 'Das hat leider nicht geklappt.',
    SHARE_FETCH_ERROR_COUNTDOWN:
      "Wir versuchen's in {countdown} Sekunden noch einmal.",
    SHARE_FETCH_ERROR_RETRY: 'Jetzt erneut versuchen',
    SHARE_MOST_RECENT_CHATS: 'Unterhaltungen',
    SHARE_PREVIEW_ERROR_HEADLINE:
      'Wir können gerade leider keine Vorschau zeigen.',
    SHARE_QUICKSHARE_TO_STARTPAGE: 'Direkt auf der Startseite',
    SHARE_TEXT_BOX_LENGTH_ERROR:
      '{delta, plural, \none {Bitte gib ein Zeichen weniger ein.} \nother {Bitte gib # Zeichen weniger ein.}\n}',
    SHARE_TO_GROUPS: 'In einer Gruppe',
    SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS: 'Forum',
    SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS: 'Gruppe',
    SHARE_TO_GROUPS_SELECTION_LABEL: 'Gruppe auswählen:',
    SHARE_TO_GROUPS_TEXT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    SHARE_TO_GROUPS_THREAD_LABEL: 'Dein Gruppen-Beitrag:',
    SHARE_TO_GROUPS_TITLE_PLACEHOLDER: 'Beitragstitel',
    SHARE_TO_MESSENGER: 'Als private Nachricht',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      'Wir haben leider keinen "{query}" gefunden.',
    SHARE_TO_STARTPAGE: 'Mit Anmerkung auf der Startseite',
    SHARE_USER_SUBTEXT_GROUPS: 'In einer Gruppe teilen',
    SHARE_USER_SUBTEXT_MESSAGE: 'Als private Nachricht teilen',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Auf der Startseite teilen',
    SHARED_BUTTON_CONTINUE: 'Weiter',
    SHARER_LIST_HEADLINE_MEMBERS: '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS:
      '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_ONE_MEMBER: 'Ein Mitglied hat dies geteilt.',
    SHARER_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SHARER_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SHARERS_BACK_TO_POST_LINK: 'Zurück',
    SHARERS_LIST_BACK_LINK: 'Zurück',
    SHOW_OLD_PROFILE_INDUSTRY: 'Branche aus altem Profil anzeigen',
    SOCIAL_ADD_CONTACT: 'Kontakt-Anfrage schicken',
    SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION:
      'Das zeigt Dir ab sofort immer der Zähler neben dem Augen-Symbol.',
    SOCIAL_BAR_VIEW_COUNTER_HEADING:
      'Wie oft wurde Dein Beitrag auf XING gesehen?',
    SOCIAL_BAR_VIEW_COUNTER_SEEN:
      'Dieser Beitrag von Dir wurde z. B. schon <strong>{views}-mal</strong> gesehen.',
    SOCIAL_BAR_VIEW_COUNTER_TIP:
      '<strong>Tipp:</strong> Mit ein paar Kniffen kannst Du <a>Deine Sichtbarkeit auf XING erhöhen</a>.',
    SOCIAL_COMMENT_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_COUNTER_LABEL: '{amount} Kommentare',
    SOCIAL_COMMENT_CREATE_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_DELETE_LABEL: 'Kommentar löschen',
    SOCIAL_COMMENT_DELETED_MESSAGE: 'Dieser Kommentar wurde gelöscht.',
    SOCIAL_COMMENT_EDIT_LABEL: 'Kommentar bearbeiten',
    SOCIAL_COMMENT_ERROR_TOO_LARGE:
      'Dieser Kommentar ist leider zu lang: Bis zu 20 Tsd. Zeichen sind erlaubt.',
    SOCIAL_COMMENT_LIST_EMPTY_HEADLINE: 'Und was meinst Du dazu?',
    SOCIAL_COMMENT_LIST_EMPTY_SUBLINE: 'Verrate uns Deine Meinung.',
    SOCIAL_COMMENT_OVERFLOW_ERROR: '{amount} Zeichen',
    SOCIAL_COMMENT_REPORT_LABEL: 'Kommentar melden',
    SOCIAL_COMMENT_WAS_EDITED: 'Bearbeitet',
    SOCIAL_COMMENTS_COUNTER_LABEL:
      "{counter, plural,\n    =0 {Kommentier's als erstes:}\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}",
    SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER:
      'Etwas schreiben (andere mit "@" erwähnen) …',
    SOCIAL_COMMENTS_CREATE_PLACEHOLDER: 'Schreibe einen Kommentar …',
    SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL: 'Abbrechen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM: 'Löschen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT:
      'Nicht zufrieden mit Deinem Kommentar? Dann kannst Du ihn einfach löschen.',
    SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE: 'Kommentar löschen?',
    SOCIAL_COMMENTS_DELETE_DIALOG_TEXT:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    SOCIAL_COMMENTS_DELETE_MENTION_LABEL: 'Nicht erwähnt werden',
    SOCIAL_COMMENTS_DELETED_TEXT: 'Dieser Kommentar wurde gelöscht.',
    SOCIAL_COMMENTS_ERROR:
      "Das hat leider nicht geklappt. Probier's bitte nochmal.",
    SOCIAL_COMMENTS_FORM_PLACEHOLDER: 'Etwas schreiben ( mit "@" erwähnen) …',
    SOCIAL_COMMENTS_LOAD_MORE: 'Weitere Kommentare',
    SOCIAL_COMMENTS_MORE_REPLIES: 'Weitere Antworten ansehen',
    SOCIAL_COMMENTS_PREVIOUS_COMMENTS: 'Vorherige Kommentare ansehen',
    SOCIAL_COMMENTS_PREVIOUS_REPLIES: 'Vorherige Antworten ansehen',
    SOCIAL_COMMENTS_REPLY_PLACEHOLDER: 'Deine Antwort an {authorName}',
    SOCIAL_GENERIC_REPORT: 'Melden',
    SOCIAL_INTERACTION_BAR_COMMENT_INPUT_HINT: 'Etwas schreiben ...',
    SOCIAL_LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    SOCIAL_LIKERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle "Gefällt mir"-Angaben sehen, weil einige Mitglieder das in ihren Privatsphäre-Einstellungen so festgelegt haben.',
    SOCIAL_LOAD_MORE_BUTTON: 'Weitere Kommentare',
    SOCIAL_OK: 'Alles klar',
    SOCIAL_PMBX_COMMENT_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_COMMENT_DATE: 'Datum',
    SOCIAL_PMBX_COMMENT_HEADING: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_MESSAGE: 'Dein Kommentar',
    SOCIAL_PMBX_COMMENT_ORIGIN: 'Wo hast Du kommentiert?',
    SOCIAL_PMBX_COMMENT_TITLE: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_USER_AGENT: 'System-Info',
    SOCIAL_PMBX_DESCRIPTION:
      'Beiträge auf XING, die Du geteilt, kommentiert, erwähnt oder mit "Gefällt mir" markiert hast',
    SOCIAL_PMBX_REACTION_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_REACTION_DATE: 'Datum',
    SOCIAL_PMBX_REACTION_LIKE: 'Beiträge, die Dir gefallen.',
    SOCIAL_PMBX_REACTION_ORIGIN: 'Wo hast Du auf den Beitrag reagiert?',
    SOCIAL_PMBX_REACTION_TITLE: 'Beiträge, auf die Du reagiert hast',
    SOCIAL_PMBX_REACTION_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_SHARE_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_SHARE_DATE: 'Datum',
    SOCIAL_PMBX_SHARE_GROUPS: 'Beiträge, die Du in einer Gruppe geteilt hast',
    SOCIAL_PMBX_SHARE_MESSAGE: 'Deine Anmerkung',
    SOCIAL_PMBX_SHARE_MESSENGER:
      'Beiträge, die Du als private Nachricht geteilt hast',
    SOCIAL_PMBX_SHARE_ORIGIN: 'Wo hast Du den Beitrag geteilt?',
    SOCIAL_PMBX_SHARE_STARTPAGE:
      'Beiträge, die Du auf der XING Startseite geteilt hast',
    SOCIAL_PMBX_SHARE_TITLE: 'Beiträge, die Du geteilt hast',
    SOCIAL_PMBX_SHARE_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_TITLE: 'Interaktionen',
    SOCIAL_REPLIES_LOAD_MORE: 'Weitere Antworten ansehen',
    SOCIAL_REPLY_BUTTON: 'Antworten',
    SOCIAL_REPLY_DISCARD_MESSAGE:
      'Dann kannst Du ihn löschen. Vielleicht schreibst Du ja beim nächsten Mal was.',
    SOCIAL_REPLY_LOAD_MORE: 'Weitere Antwort ansehen',
    SOCIAL_REPLY_LOAD_MULTIPLE: 'Weitere Kommentare ansehen',
    SOCIAL_REPLY_POST_BUTTON: 'Antworten',
    SOCIAL_SEND_MESSAGE: 'Nachricht schreiben',
    SOCIAL_SHARE_COUNTER_LABEL: '{amount}-mal geteilt',
    SOCIAL_SHARE_EXTERNAL_LINK_ERROR:
      'Dieser Link funktioniert leider nicht – deshalb kannst Du ihn nicht teilen.',
    SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS: 'Diese Mitglieder haben das geteilt:',
    SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SOCIAL_SHARERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SOCIAL_SHOW_MORE: 'Weiterlesen',
    SOCIAL_SOCIAL_PROOF_LABEL:
      '{counter, plural,\n    =1 {gefällt das:}\n    other {# gefällt das:}\n}',
    SOCIAL_UPDATE_COMMENT_LABEL: 'Speichern',
    STATE: 'Bundesland',
    STATUS: 'Beschäftigungsart',
    STATUS_BUTTON_CHANGE: 'Ändern',
    STATUS_BUTTON_SEND: 'Speichern',
    STATUS_CHANGE_COMPANY_EXPL:
      'Bitte wähle das Unternehmen, das neben Deinem Namen und oben auf Deiner Profilseite angezeigt werden soll. Trage bitte zunächst Dein aktuelles Unternehmen ein, falls dieses noch nicht aufgeführt ist.',
    STATUS_CHANGE_SCHOOL_EXPL:
      'Bitte wähle eine Hochschule aus, die neben Deinem Namen und oben auf Deiner Profilseite angezeigt werden soll. Trage bitte zunächst Deine aktuelle Hochschule ein, falls diese noch nicht aufgeführt ist.',
    STATUS_CHANGE_TO_UNEMPLOYED_HINT:
      'Halte Dein Profil immer auf dem neuesten Stand! Wenn Du auch die Felder "Ich suche" und "Fähigkeiten & Kenntnisse" ausfüllst, kannst Du schneller z. B. von einem interessanten Arbeitgeber gefunden werden.',
    STATUS_CHANGE_TO_UNEMPLOYED_HINT_TITLE:
      'Finde jetzt Deinen neuen Job auf XING!',
    STATUS_MESSAGE_DELETE: 'Löschen',
    STILL_IN_POSITION: 'bis heute',
    SUBJECT: 'Fachrichtung',
    SUBJECT_HINT: '(Fachrichtung)',
    SYSTEM_LANGUAGE: 'Dies ist Deine Systemsprache.',
    SYSTEM_LANGUAGE_LABEL: 'Systemsprache',
    TARGET_DEGREE: '(Angestrebter) Abschluss',
    TEXTAREA_EMPTY: 'Du hast in dieser Kategorie noch keine Angaben gemacht.',
    TITLE: 'Position',
    TO: 'Bis',
    TO_LOWERCASE: 'bis',
    TOP_ARTICLE_PAID_COPY:
      'Heften Sie Ihre Top-Artikel an und wechseln Sie diese bei Bedarf, sodass der aktuell wichtigste Beitrag immer an oberster Stelle bei Ihren Neuigkeiten erscheint.',
    TOP_ARTICLE_PAID_CTA: 'Alle Vorteile entdecken',
    TOP_ARTICLE_PAID_FLAG: 'Employer Branding Profil',
    TOP_ARTICLE_PAID_HEADLINE: 'Was steht für Sie an erster Stelle?',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL: 'Zurück',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM: 'Zurück zu {section}',
    TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE: 'Profil',
    UNIVERSAL_CAREER_LEVEL_LIST:
      '1. Student·in / Praktikant·in\n2. Berufseinsteiger·in\n3. Mit Berufserfahrung\n4. Manager (mit und ohne Personalverantwortung)\n5. Direktor·in (z. B. Bereichsleitung, VP, SVP)\n6. Geschäftsführer·in (z. B. GF, CEO)',
    UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST:
      '1001. Analyse und Statistik\n1002. Administration, Sachbearbeitung und Verwaltung\n1003. Beratung / Consulting\n4. Controlling und Planung\n1004. Customer Service und Kundenbetreuung\n1005. Einkauf, Materialwirtschaft und Logistik\n1006. Finanzen, Rechnungswesen und Controlling\n1007. Forschung, Lehre und Entwicklung\n1008. Gesundheit, Medizin und Soziales\n1009. Grafik, Design und Architektur\n1010. Ingenieurwesen und technische Berufe\n1011. IT und Softwareentwicklung\n1012. Management und Unternehmensentwicklung\n1013. Marketing und Werbung\n1014. Personalwesen und HR\n1015. PR, Öffentlichkeitsarbeit und Journalismus\n1016. Produktion und Handwerk\n1017. Produktmanagement\n1018. Projektmanagement\n1019. Prozessplanung und Qualitätssicherung\n1020. Recht\n1021. Vertrieb und Handel\n1022. Sonstige Tätigkeitsfelder',
    UNIVERSITY_HINT: '(Student)',
    UPLOAD_PHOTO: 'Foto hochladen',
    UPLOAD_PHOTO_HINT:
      'Lade ein Foto hoch und werde besser von Business-Kontakten und Kollegen erkannt.',
    UPLOADER_ADD_IMAGE: 'Bild hinzufügen',
    UPLOADER_ADD_VIDEO: 'Video hinzufügen',
    UPLOADER_CANCEL_UPLOAD: 'Doch nicht hochladen',
    UPLOADER_ERROR_BODY: 'Können Sie es bitte nochmal versuchen?',
    UPLOADER_ERROR_HEADLINE: 'Das hat leider nicht geklappt.',
    UPLOADER_IMAGE_LOADING_HEADLINE: 'Dein Bild wird hochgeladen ...',
    UPLOADER_TRY_AGAIN: 'Noch einmal versuchen',
    UPLOADER_VIDEO_LOADED_BODY:
      'Wir bereiten es nun auf, damit es in bestmöglicher Qualität abgespielt werden kann. Sie können es aber gerne schon veröffentlichen oder teilen.',
    UPLOADER_VIDEO_LOADED_HEADLINE: 'Ihr Video wurde hochgeladen.',
    UPLOADER_VIDEO_LOADING_HEADLINE: 'Video wird hochgeladen ...',
    URL: 'URL',
    USER_FLAG_BUTTON_ARIA_LABEL: 'Markierung für XING {type}',
    USER_FLAG_ERROR:
      "Diese Info können wir gerade leider nicht zeigen.<br>\nVersuch's bitte später nochmal.",
    USER_FLAG_ERROR_PARAGRAPH_1:
      'Diese Info können wir gerade leider nicht zeigen.',
    USER_FLAG_ERROR_PARAGRAPH_2: "Versuch's bitte später nochmal.",
    USER_FLAG_LOADING: 'Einen Moment bitte ...',
    USER_SETTINGS_TAB_PROFILE_SETTINGS: 'Profileinstellungen',
    USER_SETTINGS_TAB_USERNAME_PASSWORD: 'Zugangsdaten',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_LABEL: 'Business-Lösungen',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_SHORT_LABEL: 'Business',
    VERTICAL_NAV_FIND_JOBS_LABEL: 'Jobs finden',
    VERTICAL_NAV_FOLLOWING_LABEL: 'Folgst Du',
    VERTICAL_NAV_INSIGHTS_LABEL: 'Insights',
    VERTICAL_NAV_JOB_PREFERENCES_LABEL: 'Job-Wünsche',
    VERTICAL_NAV_MESSAGES_LABEL: 'Nachrichten',
    VERTICAL_NAV_MY_POSTS_LABEL: 'Deine Beiträge',
    VERTICAL_NAV_NETWORK_LABEL: 'Netzwerk',
    VERTICAL_NAV_NETWORK_SHORT_LABEL: 'Netzwerk',
    VERTICAL_NAV_PREMIUM_FOR_BASIC_USER_LABEL: 'Premium werden',
    VERTICAL_NAV_PREMIUM_LABEL: 'Premium',
    VERTICAL_NAV_PREMIUM_SHORT_LABEL: 'Premium',
    VERTICAL_NAV_PROBUSINESS_LABEL: 'ProBusiness',
    VERTICAL_NAV_PROFILE_LABEL: 'Profil',
    VERTICAL_NAV_PROJOBS_FOR_BASIC_USER_LABEL: 'ProJobs werden',
    VERTICAL_NAV_PROJOBS_LABEL: 'ProJobs',
    VERTICAL_NAV_YOUR_JOBS_LABEL: 'Deine Jobs',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS: 'Business-Lösungen',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT: 'Business',
    VERTICAL_NAVIGATION_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_COMMUNITIES: 'Gruppen',
    VERTICAL_NAVIGATION_COMPANIES: 'Unternehmen',
    VERTICAL_NAVIGATION_CONTACTS: 'Dein Netzwerk',
    VERTICAL_NAVIGATION_CONTACTS_SHORT: 'Netzwerk',
    VERTICAL_NAVIGATION_CONTENT_PAGES: 'News',
    VERTICAL_NAVIGATION_EVENTS: 'Eventmarkt',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE:
      'Die neue XING App: Feedback & Hilfe',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT: 'Neue App',
    VERTICAL_NAVIGATION_FOOTER_ADVERTISE: 'Werben auf XING',
    VERTICAL_NAVIGATION_FOOTER_AMIANDO: 'Ticketing und Eventvermarktung',
    VERTICAL_NAVIGATION_FOOTER_ANDROID: 'Android',
    VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN: 'Anschreiben-Editor',
    VERTICAL_NAVIGATION_FOOTER_APP_GALLERY: 'Mobile & Desktop Apps',
    VERTICAL_NAVIGATION_FOOTER_APPS: 'Apps',
    VERTICAL_NAVIGATION_FOOTER_BEWERBUNG: 'Bewerbungsratgeber',
    VERTICAL_NAVIGATION_FOOTER_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_FOOTER_CAREER: 'Karriere',
    VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE: 'Karriere-Ratgeber',
    VERTICAL_NAVIGATION_FOOTER_COACHES: 'Coaches + Trainer',
    VERTICAL_NAVIGATION_FOOTER_COMMUNITY: 'Community',
    VERTICAL_NAVIGATION_FOOTER_COMPANIES: 'Unternehmen',
    VERTICAL_NAVIGATION_FOOTER_COMPANY: 'Unternehmen',
    VERTICAL_NAVIGATION_FOOTER_DEVBLOG: 'Devblog',
    VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL: 'Entwickler',
    VERTICAL_NAVIGATION_FOOTER_DOWNLOAD: 'Downloads',
    VERTICAL_NAVIGATION_FOOTER_EVENTS: 'Events',
    VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH: 'Gehaltsvergleich',
    VERTICAL_NAVIGATION_FOOTER_GROUPS: 'Gruppen',
    VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER: 'Freelancer verwalten',
    VERTICAL_NAVIGATION_FOOTER_HELP: 'Hilfe & Kontakt',
    VERTICAL_NAVIGATION_FOOTER_IMPRINT: 'Impressum',
    VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS: 'Investor Relations',
    VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD: 'iPhone & iPad',
    VERTICAL_NAVIGATION_FOOTER_JOB_MARKET: 'Jobs',
    VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY: 'Jobs Verzeichnis',
    VERTICAL_NAVIGATION_FOOTER_KUNUNU: 'Arbeitgeber-Bewertungen',
    VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF: 'Lebenslauf-Editor',
    VERTICAL_NAVIGATION_FOOTER_LOGINWXING: 'Button "Mit XING einloggen"',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION:
      'Mitgliedschaft kündigen',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS: 'Mitgliedschaften',
    VERTICAL_NAVIGATION_FOOTER_MOBILE: 'XING Apps',
    VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE:
      'NWX – Neues zur Zukunft der Arbeit',
    VERTICAL_NAVIGATION_FOOTER_NEWWORKSE: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY: 'Mitgliederverzeichnis',
    VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE: 'Praktikum-Guide',
    VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_FOOTER_PRESS: 'Presse',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY: 'Datenschutz bei XING',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY: 'Datenschutzerklärung',
    VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_FOOTER_RESOURCES: 'Ressourcen',
    VERTICAL_NAVIGATION_FOOTER_SERVICES: 'Weitere Angebote',
    VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER: 'Personalgewinnung mit XING',
    VERTICAL_NAVIGATION_FOOTER_TANDC: 'AGB',
    VERTICAL_NAVIGATION_FOOTER_TRACKING: 'Tracking',
    VERTICAL_NAVIGATION_FOOTER_WINDOWS_10: 'Windows 10',
    VERTICAL_NAVIGATION_FOOTER_XAS: 'Werbeanzeige erstellen',
    VERTICAL_NAVIGATION_FOOTER_XING_AG: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_XING_NEWS: 'XING News',
    VERTICAL_NAVIGATION_FOOTER_XING_SHARE: 'Button "Auf XING teilen"',
    VERTICAL_NAVIGATION_FOOTER_YOUR_XING: 'Hauptbereiche',
    VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR: 'BrandManager',
    VERTICAL_NAVIGATION_HEADER_HELP: 'Hilfe',
    VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS: 'Stellenanzeigen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS: 'AdManager',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE: 'Coach-Profil',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES: 'Rechnungen & Konten',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT: 'Ausloggen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES:
      'Mitgliedschaften & Rechnungen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS:
      'ProJobs-Einstellungen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS: 'Einstellungen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS: 'Alle Ergebnisse',
    VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON: 'Suchen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES: 'Gruppen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE: 'Arbeitgeber',
    VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS: 'Events',
    VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS: 'Jobs',
    VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS: 'Mitglieder',
    VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS: 'Branchen-News',
    VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER:
      'Job, Namen oder Stichwort eingeben',
    VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN: 'LizenzManager',
    VERTICAL_NAVIGATION_HEADER_XTM: 'TalentManager',
    VERTICAL_NAVIGATION_MESSAGES: 'Nachrichten',
    VERTICAL_NAVIGATION_MORE: 'Mehr',
    VERTICAL_NAVIGATION_MYPROJOBS: 'ProJobs',
    VERTICAL_NAVIGATION_OTHER_SERVICES: 'Weitere Services',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS: 'Premium',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER: 'Premium werden',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT: 'Premium',
    VERTICAL_NAVIGATION_PROBUSINESS: 'ProBusiness',
    VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER: 'ProJobs werden',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL: 'ProJobs entdecken',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT: 'ProJobs',
    VERTICAL_NAVIGATION_STARTPAGE: 'Startseite',
    VIDEO_DELETE_ERROR:
      "Leider konnten wir Ihr Video gerade nicht löschen. Können Sie's nochmal probieren?",
    VIDEO_DIALOG_CANCEL: 'Abbrechen',
    VIDEO_DIALOG_CONFIRM: 'Verwerfen',
    VIDEO_DIALOG_HEADLINE: 'Änderungen verwerfen?',
    VIDEO_DIALOG_TEXT: 'Sie gehen dadurch verloren.',
    VIDEO_ENCODING_HEADLINE: 'Ihr Video wird gerade aufbereitet.',
    VIDEO_ENCODING_MESSAGE:
      'Wir bereiten gerade Dein Video so auf, dass wir es in der bestmöglichen Qualität anzeigen können. Dies kann ein paar Minuten dauern.',
    VIDEO_SAVE_ERROR:
      "Leider konnten wir Ihr Video gerade nicht speichern. Können Sie's nochmal probieren?",
    VIDEO_UPLOAD_CANCEL: 'Doch nicht hochladen',
    VIDEO_UPLOAD_CROP_CANCEL: 'Doch nicht zuschneiden',
    VIDEO_UPLOAD_CROP_MAX: 'Max.',
    VIDEO_UPLOAD_CROP_MIN: 'Mind.',
    VIDEO_UPLOAD_CROP_SAVE: 'Speichern',
    VIDEO_UPLOAD_DELETE: 'Video löschen',
    VIDEO_UPLOAD_ENCODING_TITLE:
      'Dein Video wird nun aufbereitet. Sobald es fertig ist, sagen wir Ihnen per E-Mail Bescheid.',
    VIDEO_UPLOAD_INPROGRESS_DESCRIPTION: '{percentage} % abgeschlossen ',
    VIDEO_UPLOAD_INPROGRESS_TITLE: 'Video wird hochgeladen ...',
    VIDEO_UPLOAD_PREVIEW_IMAGE_CTA: 'Datei auswählen',
    VIDEO_UPLOAD_PREVIEW_IMAGE_DESCRIPTION:
      'Sie können hier ein Vorschaubild für das Video hinzufügen (JPG oder PNG,  max. 10 MB). Ansonsten wird ein Bild automatisch generiert.',
    VIDEO_UPLOAD_PREVIEW_IMAGE_TITLE: 'Vorschaubild',
    VIDEO_UPLOAD_READY_CTA: 'Dateien durchsuchen',
    VIDEO_UPLOAD_READY_DESCRIPTION:
      'Format: AVI, MOV oder MP4 | Verhältnis: 16:9 | Größe: max. 5 GB',
    VIDEO_UPLOAD_READY_TITLE: 'Datei hierher ziehen oder auswählen',
    VIDEO_UPLOAD_READY_TITLE_DRAGGING: 'Datei jetzt loslassen',
    VIDEO_UPLOAD_SAVE: 'Speichern',
    VIDEO_UPLOAD_SUBTITLES_CTA: 'Datei auswählen',
    VIDEO_UPLOAD_SUBTITLES_DESCRIPTION:
      'Sie können Ihrem Video hier Untertitel hinzufügen: als WebVTT- oder SRT-Datei.',
    VIDEO_UPLOAD_SUBTITLES_LABEL_DE: 'Deutsch',
    VIDEO_UPLOAD_SUBTITLES_LABEL_EN: 'Englisch',
    VIDEO_UPLOAD_SUBTITLES_TITLE: 'Untertitel',
    VIDEO_UPLOAD_TITLE: 'Titel des Videos',
    VIDEO_UPLOADING_ERROR:
      'Leider konnten wir Ihr Video nicht hochladen – bitte wählen Sie ein Video im Format AVI, MOV oder MP4, mit dem Verhältnis 16:9 und mit max. 5 GB.',
    VIDEOS_AUTOPLAY: 'Automatisch abspielen',
    VIDEOS_SETTINGS: 'Videos automatisch abspielen?',
    VIDEOS_WATCH_VIDEO: 'Video ansehen',
    VIEW_PAGE_IN_CHINESE: 'Diese Seite auf Chinesisch anzeigen',
    VIEW_PAGE_IN_DUTCH: 'Diese Seite auf Niederländisch anzeigen',
    VIEW_PAGE_IN_ENGLISH: 'Diese Seite auf Englisch anzeigen',
    VIEW_PAGE_IN_FINNISH: 'Diese Seite auf Finnisch anzeigen',
    VIEW_PAGE_IN_FRENCH: 'Diese Seite auf Französisch anzeigen',
    VIEW_PAGE_IN_GERMAN: 'Diese Seite auf Deutsch anzeigen',
    VIEW_PAGE_IN_HUNGARIAN: 'Diese Seite auf Ungarisch anzeigen',
    VIEW_PAGE_IN_ITALIAN: 'Diese Seite auf Italienisch anzeigen',
    VIEW_PAGE_IN_JAPANESE: 'Diese Seite auf Japanisch anzeigen',
    VIEW_PAGE_IN_KOREAN: 'Diese Seite auf Koreanisch anzeigen',
    VIEW_PAGE_IN_POLISH: 'Diese Seite auf Polnisch anzeigen',
    VIEW_PAGE_IN_PORTUGUESE: 'Diese Seite auf Portugiesisch anzeigen',
    VIEW_PAGE_IN_RUSSIAN: 'Diese Seite auf Russisch anzeigen',
    VIEW_PAGE_IN_SPANISH: 'Diese Seite auf Spanisch anzeigen',
    VIEW_PAGE_IN_SWEDISH: 'Diese Seite auf Schwedisch anzeigen',
    VIEW_PAGE_IN_TURKISH: 'Diese Seite auf Türkisch anzeigen',
    VISIBLE_ON_MY_PROFILE: 'sichtbar für Besucher meines Profils',
    VISIBLE_TO_ALL_MEMBERS: 'für alle XING Mitglieder sichtbar',
    VISIBLE_TO_RECRUITERS: 'nur für Personalentscheider sichtbar',
    WEB: 'Web',
    WEB_PROFILES_EMPTY:
      'Gib weitere Web-Profile von Dir an, um Deine Sichtbarkeit zu erhöhen und Dich auch auf anderen Webseiten mit Deinen Kontakten zu vernetzen.',
    WELCOME_BOX:
      'Willkommen <a href="/profile/my_profile" title="{\'NAVI_EDITCONTACTPAGE}">{-FULL_NAME}</a>{!USER_ICONS}',
    WORK: 'Berufe',
    WORK_EXPERIENCE: 'Berufserfahrung',
    WORKEXPERIENCE_ADDITIONAL_INDUSTRIES: 'Weitere Branchen',
    WORKEXPERIENCE_DISCIPLINE_LIST:
      '1. Administration / Sachbearbeitung\n2. Analyse und Statistik\n3. Consulting / Beratung\n4. Controlling und Planung\n5. Customer Service / Kundenbetreuung\n6. Grafik und Design\n7. Einkauf, Materialwirtschaft und Logistik\n8. Finanzen und Rechnungswesen\n9. Forschung und Lehre\n10. Unternehmensleitung, M&A und Strategisches Management\n11. Handwerk\n12. Hard-/Softwareentwicklung\n13. Journalismus\n14. Marketing / Werbung\n15. Medizinische Berufe\n16. Öffentlichkeitsarbeit / PR\n17. Organisation und Verwaltung\n18. Personal / HR\n19. Produktion und Herstellung\n20. Produktmanagement\n21. Projektmanagement\n22. Forschung und Entwicklung\n23. Recht\n24. Vertrieb',
    WORKEXPERIENCE_GET_OLD_INDUSTRIES:
      'Branchen aus altem XING Profil übernehmen',
    WORKEXPERIENCE_ORG_TYPE_LIST:
      '1. Börsennotierte AG\n2. Gesellschaft in privater Hand\n3. Gemeinnützig\n4. Personengesellschaft\n5. Einzelunternehmen\n6. Selbstständig',
    WORKEXPERIENCE_SIZE_LIST:
      '1. Nur ich\n2. 1-10 Mitarbeitende\n3. 11-50 Mitarbeitende\n4. 51-200 Mitarbeitende\n5. 201-500 Mitarbeitende\n6. 501-1.000 Mitarbeitende\n7. 1.001-5.000 Mitarbeitende\n8. 5.001-10.000 Mitarbeitende\n9. 10.001 oder mehr Mitarbeitende',
    WORKEXPERIENCE_STATUS_1: 'Angestellt (Vollzeit)',
    WORKEXPERIENCE_STATUS_10: 'Gesellschafter·in',
    WORKEXPERIENCE_STATUS_11: 'Beamtet',
    WORKEXPERIENCE_STATUS_12: 'Personalvermittler·in',
    WORKEXPERIENCE_STATUS_13: 'Freiberuflich',
    WORKEXPERIENCE_STATUS_14: 'Partner·in',
    WORKEXPERIENCE_STATUS_17: 'In einer Ausbildung',
    WORKEXPERIENCE_STATUS_2: 'Angestellt (Teilzeit)',
    WORKEXPERIENCE_STATUS_3: 'Im Praktikum',
    WORKEXPERIENCE_STATUS_4: 'Selbstständig',
    WORKEXPERIENCE_STATUS_5: 'Inhaber·in',
    WORKEXPERIENCE_STATUS_6: 'Partner·in bzw. Gesellschafter·in',
    WORKEXPERIENCE_STATUS_7: 'Vorstandsmitglied',
    WORKEXPERIENCE_STATUS_8: 'Ehrenamtlich tätig',
    WORKEXPERIENCE_STATUS_9: 'Selbstständig',
    WORKEXPERIENCE_STATUS_LIST:
      '1. Angestellt (Vollzeit)\n2. Angestellt (Teilzeit)\n3. Praktikum\n4. Selbstständig\n5. Inhaber·in\n6. Partner·in bzw. Gesellschafter·in\n7. Vorstandsmitglied\n8. Ehrenamt\n9. Selbstständig\n10. Gesellschafter·in\n11. Beamtet\n12. Personalvermittler·in\n13. Freiberuflich\n14. Partner·in\n17. In einer Ausbildung',
    WRONG_END_DATE_HINT:
      'Du hast "bis heute" ausgewählt, das Enddatum liegt jedoch in der Vergangenheit.',
    X_UI_HEADER_REGISTER: 'Registrieren',
    X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK: 'Einloggen',
    XBP_NAVIGATION_ENTRY_LINK: 'Business Pages verwalten',
    XDS_BACK_TO_TOP_BUTTON: 'Nach oben',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Noch mal versuchen',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: "Bitte versuch's noch mal.",
    XDS_EMPTYSTATE_ERROR_TITLE: 'Das hat leider nicht geklappt.',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassadx',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassadorin',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Basis',
    XDS_FLAG_BASIC_FEMALE: 'Basis',
    XDS_FLAG_BASIC_MALE: 'Basis',
    XDS_FLAG_BASIC_NEUTRAL: 'Basis',
    XDS_FLAG_BETA_DIVERSE: 'Beta',
    XDS_FLAG_BETA_FEMALE: 'Beta',
    XDS_FLAG_BETA_MALE: 'Beta',
    XDS_FLAG_BETA_NEUTRAL: 'Beta',
    XDS_FLAG_INSIDER_DIVERSE: 'Insidx',
    XDS_FLAG_INSIDER_FEMALE: 'Insiderin',
    XDS_FLAG_INSIDER_MALE: 'Insider',
    XDS_FLAG_INSIDER_NEUTRAL: 'Insider',
    XDS_FLAG_MODERATOR_DIVERSE: 'Moderatx',
    XDS_FLAG_MODERATOR_FEMALE: 'Moderatorin',
    XDS_FLAG_MODERATOR_MALE: 'Moderator',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Moderator',
    XDS_FLAG_NEW_DIVERSE: 'Neu',
    XDS_FLAG_NEW_FEMALE: 'Neu',
    XDS_FLAG_NEW_MALE: 'Neu',
    XDS_FLAG_NEW_NEUTRAL: 'Neu',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainx',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainerin',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
    XING_FAQ_GUIDE_URL:
      'https://faq.xing.com/de/dein-netzwerk/netzwerken-so-gehts',
    XINGID_ADD_LEAD_SUCCESS: '{displayName} als Lead hinzugefügt',
    XINGID_REMOVE_LEAD_SUCCESS: '{displayName} als Lead entfernt',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS:
      'Zugriff auf die Video-API für Werbetreibende',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING: 'XING Video-API',
    XWS_100_INACTIVE_MEMBER: 'Inaktives Mitglied',
    YEAR: 'Jahr',
    YEARS: 'Jahre',
    YOUR_BIRTHDAY: 'Dein Geburtstag',
    YOUR_CURRENT_ADDRESS: 'Deine aktuelle Geschäftsadresse',
    YOUR_CURRENT_COMPANY: 'Deine aktuelle Firma',
    YOUR_LANGUAGE_NOT_AVAIL: 'Deine Sprache steht nicht zur Auswahl?',
    YOUR_PIC: 'Dein Foto',
    YOUR_PREVIOUS_COMPANIES: 'Deine vorherigen Firmen',
    YOUR_STATUS: 'Dein Status',
    YOUR_UNIVERSITY: 'Deine Hochschule',
    ZIP_CODE: 'PLZ',
  },
};
